// Auto-generated file - do not edit directly
// Run: node build.js
// Source files are in src/ directory

// ===== constants.js =====
// Static Color Registry - IDs NEVER change, matches physical label numbers
// This is the single source of truth for color IDs
// When adding colors: assign next available ID (51, 52, etc.)
// When removing colors: set active: false but keep the ID
const LEGO_COLOR_REGISTRY__OLD = [
  { id: 1, hex: "#161616", name: "Black", active: true },
  { id: 2, hex: "#f4f4f4", name: "White", active: true },
  { id: 3, hex: "#f9e2f0", name: "Pink", active: true },
  { id: 4, hex: "#7e93a7", name: "Light Blue", active: true },
  { id: 5, hex: "#784e90", name: "Purple", active: true },
  { id: 6, hex: "#faaa8d", name: "Coral", active: true },
  { id: 7, hex: "#b58150", name: "Brown", active: true },
  { id: 8, hex: "#dd7975", name: "Light Red", active: true },
  { id: 9, hex: "#da291c", name: "Red", active: true },
  { id: 10, hex: "#cf578a", name: "Magenta", active: true },
  { id: 11, hex: "#f8e59a", name: "Yellow", active: true },
  { id: 12, hex: "#b14eb5", name: "Violet", active: true },
  { id: 13, hex: "#f8ad6d", name: "Orange", active: true },
  { id: 14, hex: "#b1a2ca", name: "Lavender", active: true },
  { id: 15, hex: "#d0cec9", name: "Light Gray", active: true },
  { id: 16, hex: "#9e7d5e", name: "Tan", active: true },
  { id: 17, hex: "#efb661", name: "Gold", active: true },
  { id: 18, hex: "#00bbdc", name: "Cyan", active: true },
  { id: 19, hex: "#aeb862", name: "Olive", active: true },
  { id: 20, hex: "#8bbee8", name: "Sky Blue", active: true },
  { id: 21, hex: "#5e7e29", name: "Dark Green", active: true },
  { id: 22, hex: "#ecd0b5", name: "Beige", active: true },
  { id: 23, hex: "#3e87cb", name: "Blue", active: true },
  { id: 24, hex: "#2dc84d", name: "Green", active: true },
  { id: 25, hex: "#8c8a88", name: "Medium Gray", active: true },
  { id: 26, hex: "#693f23", name: "Dark Brown", active: true },
  { id: 27, hex: "#ff6900", name: "Bright Orange", active: true },
  { id: 28, hex: "#e59bdc", name: "Pink", active: true },
  { id: 29, hex: "#646464", name: "Dark Gray", active: true },
  { id: 30, hex: "#333333", name: "Charcoal", active: true },
  { id: 31, hex: "#005eb8", name: "Navy Blue", active: true },
  { id: 32, hex: "#4e3524", name: "Dark Brown", active: true },
  { id: 33, hex: "#e793b7", name: "Rose", active: true },
  { id: 34, hex: "#009a44", name: "Forest Green", active: true },
  { id: 35, hex: "#d5c897", name: "Sand", active: true },
  { id: 36, hex: "#6b3529", name: "Brown", active: true },
  { id: 37, hex: "#becaea", name: "Light Blue", active: true },
  { id: 38, hex: "#b5bd00", name: "Lime", active: true },
  { id: 39, hex: "#ffd100", name: "Bright Yellow", active: true },
  { id: 40, hex: "#c54644", name: "Dark Red", active: true },
  { id: 41, hex: "#003550", name: "Dark Blue", active: true },
  { id: 42, hex: "#335525", name: "Olive Green", active: true },
  { id: 43, hex: "#8e7fae", name: "Purple", active: true },
  { id: 44, hex: "#e59e6d", name: "Peach", active: true },
  { id: 45, hex: "#ffa300", name: "Orange", active: true },
  { id: 46, hex: "#a65523", name: "Rust", active: true },
  { id: 47, hex: "#afcdd7", name: "Light Cyan", active: true },
  { id: 48, hex: "#f0c4a0", name: "Cream", active: true },
  { id: 49, hex: "#aea46f", name: "Khaki", active: true },
  { id: 50, hex: "#b2b4b2", name: "Light Gray", active: true }
];

// Alternate palette: use when URL has ?palette=2 or #palette=2 (replace with your own colors)
const LEGO_COLOR_REGISTRY = [
  { id: 1, hex: "#c4b980", name: "Sand", active: true },
  { id: 3, hex: "#f7d377", name: "", active: true },
  { id: 4, hex: "#f7e392", name: "", active: true },
  { id: 5, hex: "#5e7c8c", name: "", active: true },
  { id: 6, hex: "#3c4b54", name: "", active: true },
  { id: 7, hex: "#435d6e", name: "", active: true },
  { id: 8, hex: "#1c568c", name: "", active: true },
  { id: 9, hex: "#1d5d99", name: "", active: true },
  { id: 10, hex: "#55a8c9", name: "", active: true },

  { id: 11, hex: "#b0915b", name: "", active: true },
  { id: 12, hex: "#d47b28", name: "", active: true },
  { id: 13, hex: "#f0c33c", name: "", active: true },
  { id: 14, hex: "#db9a53", name: "", active: true },
  { id: 15, hex: "#609da8", name: "", active: true },
  { id: 16, hex: "#528ec7", name: "", active: true },
  { id: 17, hex: "#2b79bd", name: "", active: true },
  { id: 18, hex: "#1b3b66", name: "", active: true },
  { id: 19, hex: "#203854", name: "", active: true },
  { id: 20, hex: "#328dba", name: "", active: true },

  { id: 21, hex: "#d6945a", name: "", active: true },
  // { id: 22, hex: "#f09630", name: "", active: true },
  { id: 23, hex: "#d47457", name: "", active: true },
  { id: 24, hex: "#bd5a53", name: "", active: true },
  { id: 25, hex: "#326d80", name: "", active: true },
  // { id: 26, hex: "#37a0b3", name: "", active: true },
  // { id: 27, hex: "#426dad", name: "", active: true },
  { id: 28, hex: "#9eb5db", name: "", active: true },
  { id: 29, hex: "#7e9cd6", name: "", active: true },
  { id: 30, hex: "#73bbe6", name: "", active: true },

  { id: 31, hex: "#d6b292", name: "", active: true },
  { id: 32, hex: "#c77c4e", name: "", active: true },
  { id: 33, hex: "#ffc6a1", name: "", active: true },
  { id: 34, hex: "#ebc6b9", name: "", active: true },
  // { id: 35, hex: "#2c7043", name: "", active: true },
  { id: 36, hex: "#487a36", name: "", active: true },
  // { id: 37, hex: "#62c95f", name: "", active: true },
  { id: 38, hex: "#d8e077", name: "", active: true },
  // { id: 39, hex: "#cdf28d", name: "", active: true },
  { id: 40, hex: "#bbfcf0", name: "", active: true },

  { id: 41, hex: "#4d372c", name: "", active: true },
  { id: 42, hex: "#633431", name: "", active: true },
  { id: 43, hex: "#ebcba9", name: "", active: true },
  // { id: 44, hex: "#edac9f", name: "", active: true },
  { id: 45, hex: "#38473b", name: "", active: true },
  { id: 46, hex: "#3c5734", name: "", active: true },
  { id: 47, hex: "#486e62", name: "", active: true },
  { id: 48, hex: "#68a186", name: "", active: true },
  { id: 49, hex: "#87ccaa", name: "", active: true },
  { id: 50, hex: "#b0d4a9", name: "", active: true },

  { id: 51, hex: "#5e3727", name: "", active: true },
  { id: 52, hex: "#63251f", name: "", active: true },
  { id: 53, hex: "#c49160", name: "", active: true },
  // { id: 54, hex: "#ffb0b8", name: "", active: true },
  { id: 55, hex: "#707a43", name: "", active: true },
  { id: 56, hex: "#419459", name: "", active: true },
  { id: 57, hex: "#789940", name: "", active: true },
  { id: 58, hex: "#88b344", name: "", active: true },
  { id: 59, hex: "#cf3e21", name: "", active: true },
  { id: 60, hex: "#eb622d", name: "", active: true },

  { id: 62, hex: "#7d482e", name: "", active: true },
  { id: 63, hex: "#966539", name: "", active: true },
  // { id: 64, hex: "#bf4b8b", name: "", active: true },
  { id: 65, hex: "#e090c8", name: "", active: true },
  // { id: 66, hex: "#d16685", name: "", active: true },
  // { id: 67, hex: "#bd869b", name: "", active: true },
  { id: 68, hex: "#a86a88", name: "", active: true },
  // { id: 69, hex: "#de7035", name: "", active: true },
  { id: 70, hex: "#a6332d", name: "", active: true },

  { id: 72, hex: "#a1441d", name: "", active: true },
  { id: 73, hex: "#9c6f57", name: "", active: true },
  { id: 74, hex: "#ad4264", name: "", active: true },
  // { id: 75, hex: "#d3abdb", name: "", active: true },
  // { id: 76, hex: "#8b63b0", name: "", active: true },
  { id: 77, hex: "#a590d6", name: "", active: true },
  // { id: 78, hex: "#613d50", name: "", active: true },
  // { id: 79, hex: "#912749", name: "", active: true },
  // { id: 80, hex: "#8a325f", name: "", active: true },

  { id: 81, hex: "#464a4e", name: "", active: true },
  { id: 82, hex: "#555555", name: "", active: true },
  { id: 83, hex: "#777777", name: "", active: true },
  { id: 84, hex: "#909090", name: "", active: true },
  // { id: 81, hex: "#3e4957", name: "", active: true },
  // { id: 82, hex: "#4d6161", name: "", active: true },
  // { id: 83, hex: "#6e807b", name: "", active: true },
  // { id: 84, hex: "#83989e", name: "", active: true },
  { id: 85, hex: "#733582", name: "", active: true },
  { id: 86, hex: "#3d3382", name: "", active: true },
  { id: 87, hex: "#4d579e", name: "", active: true },
  // { id: 88, hex: "#bf395b", name: "", active: true },
  { id: 89, hex: "#bf2822", name: "", active: true },
  { id: 90, hex: "#a12115", name: "", active: true },

  { id: 91, hex: "#131516", name: "black", active: true },
  { id: 93, hex: "#f4f4f4", name: "white", active: true },
  { id: 94, hex: "#dbd3b4", name: "", active: true },
  { id: 95, hex: "#b8b58d", name: "", active: true },
  { id: 96, hex: "#7c83a6", name: "", active: true },
  { id: 97, hex: "#72659e", name: "", active: true },
];

const BLACK_WHITE_REGISTRY = [
  { id: 91, hex: "#131516", name: "black", active: true },
  { id: 93, hex: "#f4f4f4", name: "white", active: true },
  { id: 81, hex: "#464a4e", name: "", active: true },
  { id: 82, hex: "#555555", name: "", active: true },
  { id: 83, hex: "#777777", name: "", active: true },
  { id: 84, hex: "#909090", name: "", active: true },
];

function getActiveColorRegistry() {
  if (typeof window !== 'undefined' && window.location) {
    const s = (window.location.search || '') + (window.location.hash || '');
    if (s.indexOf('palette=old') !== -1) return LEGO_COLOR_REGISTRY__OLD;
  }
  return LEGO_COLOR_REGISTRY;
}

const ACTIVE_COLOR_REGISTRY = getActiveColorRegistry();

// Helper: Get only active colors (for backward compatibility with existing code)
const legoColorHexes = ACTIVE_COLOR_REGISTRY
  .filter(color => color.active)
  .map(color => color.hex);

// Helper: Get color by ID
function getColorById(id) {
  return ACTIVE_COLOR_REGISTRY.find(c => c.id === id);
}

// Helper: Get color by hex (for finding ID from hex)
function getColorByHex(hex) {
  return ACTIVE_COLOR_REGISTRY.find(c => c.hex.toLowerCase() === hex.toLowerCase());
}

/** Order shown in the Formaat modal; orientation is implied by WxH (e.g. 3x2 vs 2x3). */
const editorSizeOptions = [
  "2x2",
  "3x3",
  "4x4",
  "3x2",
  "4x3",
  "5x3",
  "2x3",
  "3x4",
  "3x5",
];

// Mozaik variant IDs by size
const mozaikVariantIDs = {
  "2x2": 56199517667659,
  "2x3": 56199534510411,
  "3x2": 56199534313803,
  "3x3": 56199517700427,
  "3x4": 56199534543179,
  "3x5": 56199534575947,
  "4x3": 56199534346571,
  "4x4": 56199517733195,
  "5x3": 56199534379339,
};

// Montagestrips variant ID (quantity varies based on size)
const stripsVariantID = 56194574254411;

/**
 * Base URL for detect-api (no trailing slash). Used for POST /suggest-crop.
 * Switch between local and production here.
 * Set to empty string to disable suggest-crop requests (falls back to aspect-only format pick).
 */
const DETECT_API_BASE_URL = "https://api.pixelbrick.nl";
// const DETECT_API_BASE_URL = "http://localhost:3001";

/** Sent as `x-api-key` when non-empty. Omit or clear for local detect-api without DETECT_API_KEY. */
const DETECT_API_KEY = "6c89f4d27ebad8afbab3b399315ddb36186db7d3886d13cf9c7df43eaec0cc87";

/** Max number of shop formats to send to suggest-crop (cheapest first). */
const SUGGEST_CROP_REQUEST_FORMAT_LIMIT = 9;

/** Extra zoom when applying suggest-crop framing (1.2 = 20% tighter than API crop box). */
const SUGGEST_CROP_ZOOM_BOOST = 1.2;

/** Editor zoom range — keep in sync with ui-handlers zoom slider and wheel limits. */
const EDITOR_MIN_ZOOM = 1;
const EDITOR_MAX_ZOOM = 3;

/**
 * Mosaic preview brick size calibration (CSS px per stud).
 * Reference: iPhone 11-class portrait (~414px innerWidth, 326 ppi) where 2px/stud looked correct.
 */
const MOSAIC_BRICK_PX_REFERENCE_INNER_WIDTH = 414;
const MOSAIC_BRICK_PX_REFERENCE = 2;
/** Optional multiplier on reference px/stud (1 = no extra bump). */
const MOSAIC_BRICK_PX_SCALE = 1;
const MOSAIC_BRICK_PX_MIN = 1;
/** Caps desktop growth; 3 matches the old innerWidth >= 750 behaviour. */
const MOSAIC_BRICK_PX_MAX = 3;

// Product handle for fetching prices from Shopify
// Replace 'your-product-handle' with your actual product handle
const mozaikProductHandle = 'foto-mozaiekset-24x24-cm-baseplaten';

// Frame variant IDs by size and color
// Format: frameVariants[size][color] = variantId
// Note: Rotated sizes (e.g., 3x2 and 2x3) share the same frame variant
const frameVariants = {
  "2x2": {
    "black": 56194661679435
  },
  "3x2": {
    "black": 56194661843275
  },
  "2x3": {
    "black": 56194661843275  // Same as 3x2
  },
  "3x3": {
    "black": 56194661712203
  },
  "4x3": {
    "black": 56194661876043
  },
  "3x4": {
    "black": 56194661876043  // Same as 4x3
  },
  "4x4": {
    "black": 56194661744971
  },
  "5x3": {
    "black": 56194661908811
  },
  "3x5": {
    "black": 56194661908811  // Same as 5x3
  },
};

const redMask32 = 0xff000000;
const greenMask32 = 0x00ff0000;
const blueMask32 = 0x0000ff00;

const pRedCoefficient = 0.299;
const pGreenCoefficient = 0.587;
const pBlueCoefficient = 0.114;



// ===== uploaded-image-idb.js =====
/**
 * Single-record IndexedDB used by the upload page and editor.
 * @see page.photo_upload.liquid saveUploadToIndexedDb
 */
var UPLOADED_IMAGE_DB_NAME = "uploaded_image_editor";
var UPLOADED_IMAGE_DB_VERSION = 1;
var UPLOADED_IMAGE_STORE = "uploads";
var UPLOADED_IMAGE_KEY = "current";
/** Shopify upload / creëer page — redirect when editor has no valid upload */
var UPLOAD_PAGE_PATH = "/pages/creeren";

function isEditorShopifyPath() {
  return typeof window !== "undefined" && window.location && window.location.pathname === "/pages/editor";
}

function openUploadedImageDb() {
  return new Promise(function (resolve, reject) {
    try {
      if (!("indexedDB" in window)) {
        reject(new Error("IndexedDB not supported"));
        return;
      }
      var req = indexedDB.open(UPLOADED_IMAGE_DB_NAME, UPLOADED_IMAGE_DB_VERSION);
      req.onupgradeneeded = function () {
        var db = req.result;
        if (!db.objectStoreNames.contains(UPLOADED_IMAGE_STORE)) {
          db.createObjectStore(UPLOADED_IMAGE_STORE, { keyPath: "id" });
        }
      };
      req.onsuccess = function () {
        resolve(req.result);
      };
      req.onerror = function () {
        reject(req.error || new Error("Failed to open IndexedDB"));
      };
    } catch (e) {
      reject(e);
    }
  });
}

function getUploadedImageRecord() {
  return openUploadedImageDb().then(function (db) {
    return new Promise(function (resolve, reject) {
      try {
        var tx = db.transaction(UPLOADED_IMAGE_STORE, "readonly");
        var store = tx.objectStore(UPLOADED_IMAGE_STORE);
        var r = store.get(UPLOADED_IMAGE_KEY);
        r.onsuccess = function () {
          resolve(r.result || null);
        };
        r.onerror = function () {
          reject(r.error || new Error("Failed to read upload record"));
        };
        tx.oncomplete = function () {
          try {
            db.close();
          } catch (e) {}
        };
      } catch (e) {
        try {
          db.close();
        } catch (err) {}
        reject(e);
      }
    });
  });
}

function deleteUploadedImageRecord() {
  return openUploadedImageDb().then(function (db) {
    return new Promise(function (resolve, reject) {
      try {
        var tx = db.transaction(UPLOADED_IMAGE_STORE, "readwrite");
        tx.objectStore(UPLOADED_IMAGE_STORE).delete(UPLOADED_IMAGE_KEY);
        tx.oncomplete = function () {
          try {
            db.close();
          } catch (e) {}
          resolve(true);
        };
        tx.onerror = function () {
          try {
            db.close();
          } catch (e) {}
          reject(tx.error || new Error("IndexedDB delete failed"));
        };
        tx.onabort = function () {
          try {
            db.close();
          } catch (e) {}
          reject(tx.error || new Error("IndexedDB delete aborted"));
        };
      } catch (e) {
        try {
          db.close();
        } catch (err) {}
        reject(e);
      }
    });
  });
}

function clearUploadedImageRecordAndRedirect(message) {
  if (typeof message === "string" && message.trim()) {
    console.error(message.trim());
  }
  return deleteUploadedImageRecord()
    .catch(function () {})
    .then(function () {
      window.location.href = UPLOAD_PAGE_PATH;
    });
}

function isNonEmptyImageArrayBuffer(value) {
  return value instanceof ArrayBuffer && value.byteLength > 0;
}

/** Upload page stores both originals; editor requires both to be present and non-empty. */
function isValidTransformedUploadRecord(record) {
  return (
    record &&
    typeof record === "object" &&
    isNonEmptyImageArrayBuffer(record.originalImageArrayBuffer) &&
    isNonEmptyImageArrayBuffer(record.transformedImageArrayBuffer)
  );
}


// ===== dom-elements.js =====
const canvas = document.getElementById("mozaikCanvas");
const ctx = canvas.getContext("2d");
const pictureRendering = document.querySelector(".simple-picture-rendering");
const mozaikCanvasLoader = document.getElementById("mozaikCanvasLoader");

const canvasPrerender = document.createElement('canvas');
const ctxPrerender = canvasPrerender.getContext('2d', { willReadFrequently: true });

const imageInput = document.getElementById("imageInput");
// const orientationSelect = document.getElementById("orientationSelect");
// const sizeSelect = document.getElementById("sizeSelect");
const sizesSelect = document.getElementById("sizesSelect");
const zoomRange = document.getElementById("zoomRange");
const brightnessRange = document.getElementById("brightnessRange");
const contrastRange = document.getElementById("contrastRange");
const saturationRange = document.getElementById("saturationRange");
const colorModeColorfulBtn = document.getElementById("colorModeColorfulBtn");
const colorModeBwBtn = document.getElementById("colorModeBwBtn");
const mozaikPrices = document.querySelectorAll(".js-mozaik-price-eur");
const mozaikSizeShort = document.getElementById("js-mozaik-size-cm");
const mozaikSizeLong = document.getElementById("js-mozaik-size-long-cm");
const mozaikBaseplates = document.getElementById("js-mozaik-baseplates");
const mozaikBricks = document.getElementById("js-mozaik-bricks");
const previewFormatSize = document.getElementById("js-preview-format-size");
const previewHangingOption = document.getElementById("js-preview-hanging-option");
const previewHangingPrice = document.getElementById("js-preview-hanging-price");
const previewHangingEdit = document.getElementById("js-preview-hanging-edit");
const previewHangingItem = document.getElementById("js-preview-hanging-item");
const sizeCropToolbar = document.getElementById("size-crop-toopbar");
const previewToolbar = document.getElementById("preview-toopbar");
const previewFooter = document.getElementById("preview-footer");
const headerStepTitle = document.querySelector(".simple-editor-header-title");
const headerStepIndicator = document.getElementById("header-step-indicator");
const nextStepButton = document.getElementById("btn-next-step__UNUSED");
const prevStepButton = document.getElementById("btn-prev-step");
const addToCartButton = document.getElementById("btn-add-to-cart");
const addToCartButtonFooter = document.getElementById("btn-add-to-cart-footer");
const helpButtonStep1 = document.getElementById("btn-help-step1");
const helpButtonStep2 = document.getElementById("btn-help-step2");
const formatDetailsButton = document.getElementById("btn-format-details");
const detailsViewer = document.getElementById("details-viewer");
const detailsViewerStage = document.getElementById("details-viewer-stage");
const detailsViewerCanvas = document.getElementById("details-viewer-canvas");
const detailsViewerCloseTop = document.getElementById("details-viewer-close-top");
const detailsViewerCloseBottom = document.getElementById("details-viewer-close-bottom");
const detailsViewerReset = document.getElementById("details-viewer-reset");
const detailsViewerZoomOut = document.getElementById("details-viewer-zoom-out");
const detailsViewerZoomIn = document.getElementById("details-viewer-zoom-in");
const detailsViewerZoomValue = document.getElementById("details-viewer-zoom-value");
const arPreviewButton = document.getElementById("btn-ar-preview");
const deliveryBaseplatesCount = document.getElementById("js-delivery-baseplates-count");
const deliveryBricksCount = document.getElementById("js-delivery-bricks-count");
const deliveryStripsCard = document.getElementById("js-delivery-strips-card");
const deliveryStripsCount = document.getElementById("js-delivery-strips-count");
const deliveryFrameCard = document.getElementById("js-delivery-frame-card");
const deliveryFrameImage = document.getElementById("js-delivery-frame-image");
const deliveryFrameText = document.getElementById("js-delivery-frame-text");



// ===== state.js =====
let uploadedImage = null;
const decodeCanvas = document.createElement("canvas");
const decodeCtx = decodeCanvas.getContext("2d", { willReadFrequently: true });
let dragOffset = { x: 0, y: 0 };
let isDragging = false;
let dragStart = { x: 0, y: 0 };
let zoom = 1;
// Color correction defaults must match existing hardcoded values in rendering pipeline.
let colorCorrectionBrightness = 0;
let colorCorrectionContrast = 0.15;
let colorCorrectionSaturation = 0.05;
/** "colorful" = full registry; "blackWhite" = BLACK_WHITE_REGISTRY */
let mosaicColorMode = "colorful";
/** Brightness before switching to zwart-wit; restored when returning to kleurrijk */
let colorBrightnessBeforeBlackWhite = null;
let autoColorDefaultsAppliedForCurrentImage = false;
let selectedSize = "3x3";
let lastCanvasRatio = null;
let currentStep = 1;

let addToCartButtonClicked = false;
let selectedFrame = null; // 'frame-black', 'frame-white', 'frame-gold', or null
/** A/B: mosaic black border (first/last row/column). Set once per customer on editor open. */
let mosaicBlackFrameEnabled = false;

// Cache for pan-based rendering optimization
let renderCache = {
  canvas: null, // Offscreen canvas with full processed image
  ctx: null,
  cachedZoom: null,
  cachedSize: null,
  cachedOffset: null, // The offset used when cache was created
  cachedResizedWidth: null, // Cached resized image width (before brickify)
  cachedResizedHeight: null, // Cached resized image height (before brickify)
  needsUpdate: true
};

// Store the current brickified bitmap for adding to cart (no reprocessing needed)
let currentBrickedBitmap = null;



// ===== palette.js =====
// Create a simple brick color object similar to the original
function createBrickColor(hex) {
  const rgb = hexToRGB(hex);
  const rgba = (rgb[0] << 24) | (rgb[1] << 16) | (rgb[2] << 8) | 255;
  return {
    r: rgb[0],
    g: rgb[1], 
    b: rgb[2],
    rgba: rgba >>> 0, // Ensure it's unsigned
    hexString: hex
  };
}

var legoPalette = [];

const neededBricks = {};

var paletteLen = 0;
var paletteR = new Uint8Array(0);
var paletteG = new Uint8Array(0);
var paletteB = new Uint8Array(0);
var paletteHex = [];

function getMosaicPaletteRegistryForMode(mode) {
  if (mode === "blackWhite") return BLACK_WHITE_REGISTRY;
  return getActiveColorRegistry();
}

function getMosaicPaletteRegistry() {
  return getMosaicPaletteRegistryForMode(mosaicColorMode);
}

function rebuildMosaicPalette(mode) {
  var registry = getMosaicPaletteRegistryForMode(mode);
  var hexes = [];
  var i;
  for (i = 0; i < registry.length; i++) {
    if (registry[i].active) hexes.push(registry[i].hex);
  }
  legoPalette = hexes.map(createBrickColor);
  paletteLen = legoPalette.length;
  paletteR = new Uint8Array(paletteLen);
  paletteG = new Uint8Array(paletteLen);
  paletteB = new Uint8Array(paletteLen);
  paletteHex = new Array(paletteLen);
  for (i = 0; i < paletteLen; i++) {
    var brick = legoPalette[i];
    paletteR[i] = brick.r;
    paletteG[i] = brick.g;
    paletteB[i] = brick.b;
    paletteHex[i] = brick.hexString;
  }
}

function setMosaicColorMode(mode) {
  if (mode !== "colorful" && mode !== "blackWhite") return;
  mosaicColorMode = mode;
  rebuildMosaicPalette(mode);
}

rebuildMosaicPalette("colorful");

function getClosestPaletteIndex(r, g, b) {
  var closest = 0;
  var minDist = Number.MAX_VALUE;
  if (mosaicColorMode === "blackWhite") {
    var lum = 0.299 * r + 0.587 * g + 0.114 * b;
    for (var j = 0; j < paletteLen; j++) {
      var pLum = 0.299 * paletteR[j] + 0.587 * paletteG[j] + 0.114 * paletteB[j];
      var distL = lum - pLum;
      distL = distL * distL;
      if (distL < minDist) {
        minDist = distL;
        closest = j;
      }
    }
    return closest;
  }
  for (var i = 0; i < paletteLen; i++) {
    var dR = paletteR[i] - r;
    var dG = paletteG[i] - g;
    var dB = paletteB[i] - b;
    var dist = dR * dR + dG * dG + dB * dB;
    if (dist < minDist) {
      minDist = dist;
      closest = i;
    }
  }
  return closest;
}

function getClosestPaletteIndexFromRgba(rgba) {
  var a = rgba & 0xff;
  if (a === 0) return 0;
  var r = (rgba >>> 24) & 0xff;
  var g = (rgba >>> 16) & 0xff;
  var b = (rgba >>> 8) & 0xff;
  return getClosestPaletteIndex(r, g, b);
}

function writePaletteIndexToData(data, offset, idx) {
  data[offset] = paletteR[idx];
  data[offset + 1] = paletteG[idx];
  data[offset + 2] = paletteB[idx];
  data[offset + 3] = 255;
}

function countNeighborIndicesStep2(copyIdx, w, h, x, y, neighborCounts) {
  for (var i = 0; i < paletteLen; i++) neighborCounts[i] = 0;

  for (var dy = -1; dy <= 1; dy++) {
    for (var dx = -1; dx <= 1; dx++) {
      if (dx === 0 && dy === 0) continue;
      var nx = x + dx;
      var ny = y + dy;
      if (nx < 0 || nx >= w || ny < 0 || ny >= h) continue;
      neighborCounts[copyIdx[ny * w + nx]]++;
    }
  }

  var maxCount = 0;
  for (var c = 0; c < paletteLen; c++) {
    if (neighborCounts[c] > maxCount) maxCount = neighborCounts[c];
  }
  if (maxCount === 0) return -1;

  var maxIdx = -1;
  var maxKey = '';
  for (var c2 = 0; c2 < paletteLen; c2++) {
    if (neighborCounts[c2] !== maxCount) continue;
    var key = paletteR[c2] + ',' + paletteG[c2] + ',' + paletteB[c2];
    if (maxIdx < 0 || key < maxKey) {
      maxKey = key;
      maxIdx = c2;
    }
  }
  return maxIdx;
}

function countNeighborIndicesStep3(copyIdx, w, h, x, y, centerIdx, neighborCounts) {
  for (var i = 0; i < paletteLen; i++) neighborCounts[i] = 0;

  var maxIdx = centerIdx;
  var maxCount = 0;

  for (var dy = -1; dy <= 1; dy++) {
    for (var dx = -1; dx <= 1; dx++) {
      if (dx === 0 && dy === 0) continue;
      var nx = x + dx;
      var ny = y + dy;
      if (nx < 0 || nx >= w || ny < 0 || ny >= h) continue;
      var nIdx = copyIdx[ny * w + nx];
      var cnt = ++neighborCounts[nIdx];
      if (cnt > maxCount) {
        maxCount = cnt;
        maxIdx = nIdx;
      }
    }
  }

  return {
    centerCount: neighborCounts[centerIdx] || 0,
    maxCount: maxCount,
    maxIdx: maxIdx
  };
}

function rebuildNeededBricks(indices, numPixels) {
  for (var nk in neededBricks) {
    if (Object.prototype.hasOwnProperty.call(neededBricks, nk)) {
      delete neededBricks[nk];
    }
  }
  for (var i = 0; i < numPixels; i++) {
    var hex = paletteHex[indices[i]];
    if (!neededBricks[hex]) neededBricks[hex] = 0;
    neededBricks[hex]++;
  }
}

function getClosestPaletteItem(rgba) {
  return legoPalette[getClosestPaletteIndexFromRgba(rgba)];
}

// colour = [r,g,b]
function getColourDistanceBE(colour, rgba) {
  const r = (((rgba & redMask32) >> 24) >>> 0) & 0xff;
  const g = (rgba & greenMask32) >> 16;
  const b = (rgba & blueMask32) >> 8;
  const a = rgba & 0xff;

  // If pixel is transparent, don't process it
  if (a === 0) {
    return Number.MAX_VALUE;
  }

  const dR = colour.r - r;
  const dG = colour.g - g;
  const dB = colour.b - b;
  return Math.sqrt(dR * dR + dG * dG + dB * dB);
}

function brickify(imgBitmap) {
  var w = imgBitmap.width;
  var h = imgBitmap.height;
  var data = imgBitmap.data;
  var numPixels = w * h;
  var numPixelBytes = numPixels * 4;
  var indices = new Uint8Array(numPixels);
  var globalCount = new Int32Array(paletteLen);
  var neighborCounts = new Int32Array(paletteLen);

  for (var p = 0, px = 0; p < numPixelBytes; p += 4, px++) {
    var idx = data[p + 3] === 0
      ? 0
      : getClosestPaletteIndex(data[p], data[p + 1], data[p + 2]);
    indices[px] = idx;
    writePaletteIndexToData(data, p, idx);
    var hex = paletteHex[idx];
    if (!neededBricks[hex]) neededBricks[hex] = 0;
    neededBricks[hex]++;
  }

  // Step 2: drop colours used fewer than 5 times — replace each with the most
  // common colour among its 8 surrounding bricks.
  // B&W has only 6 greys; a low threshold preserves edge pixels that would
  // otherwise merge into larger flat regions.
  var minColorCount = mosaicColorMode === "blackWhite" ? 1 : 5;
  var maxPasses = 16;
  var pass = 0;
  var changed = true;
  while (changed && pass < maxPasses) {
    pass++;
    changed = false;

    for (var gi = 0; gi < paletteLen; gi++) globalCount[gi] = 0;
    for (var gpx = 0; gpx < numPixels; gpx++) globalCount[indices[gpx]]++;

    var hasUnderMin = false;
    for (var gc = 0; gc < paletteLen; gc++) {
      if (globalCount[gc] > 0 && globalCount[gc] < minColorCount) {
        hasUnderMin = true;
        break;
      }
    }
    if (!hasUnderMin) break;

    var copyIdx = new Uint8Array(indices);

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var pi = y * w + x;
        var centerIdx = copyIdx[pi];
        if (globalCount[centerIdx] >= minColorCount) continue;

        var targetIdx = countNeighborIndicesStep2(copyIdx, w, h, x, y, neighborCounts);
        if (targetIdx < 0 || targetIdx === centerIdx) continue;

        indices[pi] = targetIdx;
        writePaletteIndexToData(data, pi * 4, targetIdx);
        changed = true;
      }
    }
  }

  // Step 3: majority filter — replace isolated outlier bricks with the
  // most common color among their 8 neighbors.
  var copyLonelyIdx = new Uint8Array(indices);

  for (var yl = 0; yl < h; yl++) {
    for (var xl = 0; xl < w; xl++) {
      var li = yl * w + xl;
      var centerIdx3 = copyLonelyIdx[li];
      var stats = countNeighborIndicesStep3(copyLonelyIdx, w, h, xl, yl, centerIdx3, neighborCounts);
      var lonelyMinNeighbors = mosaicColorMode === "blackWhite" ? 7 : 5;
      if (stats.centerCount !== 0 || stats.maxCount < lonelyMinNeighbors || stats.maxIdx === centerIdx3) continue;

      indices[li] = stats.maxIdx;
      writePaletteIndexToData(data, li * 4, stats.maxIdx);
    }
  }

  rebuildNeededBricks(indices, numPixels);

  return imgBitmap;
}

/**
 * Replaces the first/last row and first/last column with mosaic black (registry id 91,
 * #131516). Same grid size as the product — no extra rows/columns.
 */
function applyMosaicBlackBorder(brickedBitmap) {
  var w = brickedBitmap.width;
  var h = brickedBitmap.height;
  if (w < 1 || h < 1) return brickedBitmap;
  var reg = getColorById(91);
  var blackBrick = createBrickColor(reg ? reg.hex : "#131516");
  var rgba = blackBrick.rgba;
  var data = brickedBitmap.data;
  var x;
  var y;
  var idx;
  for (x = 0; x < w; x++) {
    idx = x * 4;
    writeUInt32BE(data, rgba, idx);
    idx = ((h - 1) * w + x) * 4;
    writeUInt32BE(data, rgba, idx);
  }
  for (y = 0; y < h; y++) {
    idx = y * w * 4;
    writeUInt32BE(data, rgba, idx);
    idx = (y * w + (w - 1)) * 4;
    writeUInt32BE(data, rgba, idx);
  }
  return brickedBitmap;
}

// ===== ab-test.js =====
const BLACK_FRAME_AB_STORAGE_KEY = "editor-ab-mosaic-black-frame";

function initBlackFrameAbTest() {
  try {
    let stored = localStorage.getItem(BLACK_FRAME_AB_STORAGE_KEY);
    if (stored !== "on" && stored !== "off") {
      stored = Math.random() < 0.5 ? "on" : "off";
      localStorage.setItem(BLACK_FRAME_AB_STORAGE_KEY, stored);
    }
    mosaicBlackFrameEnabled = stored === "on";
  } catch (e) {
    mosaicBlackFrameEnabled = false;
  }
  updateBestellenTrackingLabel();
}

function updateBestellenTrackingLabel() {
  if (!mosaicBlackFrameEnabled) return;
  const trackLabel = "editor--btn-bestellen-black-frame";
  [addToCartButtonFooter, addToCartButton].forEach(function (btn) {
    if (btn) btn.setAttribute("data-track", trackLabel);
  });
}


// ===== utils.js =====
function sizeToPrice(sizeStr) {
  // Only return price if Shopify prices are loaded
  const price = sizeToPriceNumber(sizeStr);
  if (price !== null) {
    return `€${price} EUR`;
  }
  // Return empty string if prices not loaded yet
  return '';
}

function roundToOneDecimal(num) {
  return Math.round(num * 10) / 10;
}

function sizeToDimensionsCM(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);

  const widthCM = roundToOneDecimal(19.2 * baseW);
  const heightCM = roundToOneDecimal(19.2 * baseH);

  return `${widthCM}x${heightCM}cm`; // 19.2x19.2 cm is size of 1 baseplate
}

function imageToBuildBitmapCached(image, noBrickColour) {
  decodeCanvas.width = image.width;
  decodeCanvas.height = image.height;
  decodeCtx.drawImage(image, 0, 0);

  const imageData = decodeCtx.getImageData(0, 0, decodeCanvas.width, decodeCanvas.height);

  // Avoid copying: create a Uint8Array view on the same buffer
  const pixelData = new Uint8Array(imageData.data.buffer);

  return createBuildBitmap(pixelData, image.width, image.height, noBrickColour);
}

/**
 * Creates a BuildBitmap object from image data
 * @param {Uint8Array|Uint8ClampedArray} data - RGBA pixel data (4 bytes per pixel)
 * @param {number} width - Image width in pixels
 * @param {number} height - Image height in pixels
 * @param {{rgba: number}|undefined} noBrickColour - Optional color for transparent/background areas
 * @returns {BuildBitmap}
 */
function createBuildBitmap(data, width, height, noBrickColour = undefined) {
    // Ensure data is a Uint8Array (not Uint8ClampedArray)
    const pixelData = data instanceof Uint8Array 
      ? data 
      : new Uint8Array(data);
    
    return {
      data: pixelData,
      width: width,
      height: height,
      noBrickColour: noBrickColour
    };
}

function sizeToDimensionsCMLong(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);

  const widthCM = roundToOneDecimal(19.2 * baseW);
  const heightCM = roundToOneDecimal(19.2 * baseH);

  return `${sizeStr} baseplaten (${widthCM}x${heightCM}cm)`; // 19.2x19.2 cm is size of 1 baseplate
}

function sizeToBaseplates(sizeStr) {
  return `${sizeStr} baseplaten`;
}

function sizeToBricksCount(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);
  const totalBricks = baseW * baseH * 24 * 24;
  return `${totalBricks.toLocaleString('nl-NL')} steentjes`;
}

function sizeToPreviewFormat(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);
  const widthCM = roundToOneDecimal(19.2 * baseW);
  const heightCM = roundToOneDecimal(19.2 * baseH);
  // Format: "Formaat 96x115,2 cm • 5x6 baseplaten"
  return `Formaat ${widthCM}x${heightCM} cm • ${sizeStr} baseplaten`;
}

// Price cache: maps size (e.g., "2x3") to price in euros
let variantPrices = {};
let variantCompareAtPrices = {};
let availableEditorSizeOptions = [...editorSizeOptions];
let pricesLoaded = false;

// Fetch all variant prices from Shopify
async function loadPricesFromShopify(productHandle) {
  try {
    const isLocalhost =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");
    const endpoint = isLocalhost
      ? "/mock-shopify-product.json"
      : `/products/${productHandle}.js`;

    const response = await fetch(endpoint);
    if (!response.ok) {
      throw new Error(`Failed to fetch product: ${response.status}`);
    }
    const product = await response.json();
    
    // Reset cached values before reloading.
    variantPrices = {};
    variantCompareAtPrices = {};

    // Create reverse mappings: variant ID -> current price / compare-at price
    const variantIdToPrice = {};
    const variantIdToCompareAtPrice = {};
    const variantIdToAvailable = {};
    product.variants.forEach(variant => {
      variantIdToPrice[variant.id] = variant.price / 100; // Convert cents to euros
      variantIdToCompareAtPrice[variant.id] = variant.compare_at_price ? variant.compare_at_price / 100 : null;
      variantIdToAvailable[variant.id] = !!variant.available;
    });

    // Build sizes from Shopify variant availability, keeping predefined UI order.
    availableEditorSizeOptions = editorSizeOptions.filter((size) => {
      const variantId = mozaikVariantIDs[size];
      if (variantId && variantIdToAvailable[variantId]) {
        variantPrices[size] = variantIdToPrice[variantId];
        variantCompareAtPrices[size] = variantIdToCompareAtPrice[variantId];
        return true;
      }
      return false;
    });

    // Safety fallback: do not leave UI without sizes.
    if (availableEditorSizeOptions.length === 0) {
      availableEditorSizeOptions = [...editorSizeOptions];
    }
    
    pricesLoaded = true;
    console.log('Prices loaded from Shopify:', variantPrices);
    
    // Update all price displays in UI (updatePreviewTotal handles both base and total prices)
    if (typeof updatePreviewTotal === 'function') {
      updatePreviewTotal();
    }
    if (typeof updateSizeOptions === 'function') {
      updateSizeOptions();
    }
    const selectableSizes = getEditorSizeOptions();
    if (!selectableSizes.includes(selectedSize) && selectableSizes.length > 0) {
      selectedSize = selectableSizes[0];
      if (typeof render === 'function') {
        render();
      }
    }
  } catch (error) {
    console.error('Error loading prices from Shopify:', error);
    // Fall back to formula if fetch fails
    pricesLoaded = false;
  }
}

function sizeToPriceNumber(sizeStr) {
  // Only return price if Shopify prices are loaded
  if (variantPrices[sizeStr] !== undefined) {
    return variantPrices[sizeStr];
  }
  
  // Return null if prices not loaded yet (no fallback)
  return null;
}

function sizeToOldPriceNumber(sizeStr) {
  if (variantCompareAtPrices[sizeStr] !== undefined) {
    return variantCompareAtPrices[sizeStr];
  }
  return null;
}

function getEditorSizeOptions() {
  return availableEditorSizeOptions.length > 0
    ? availableEditorSizeOptions
    : editorSizeOptions;
}

function sizeToStripsCount(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);
  return baseW * baseH * 4; // 4 strips per baseplate
}

function parseSize(sizeStr) {
  const [w, h] = sizeStr.split("x").map(Number);
  return { baseW: w, baseH: h, pxW: w * 24, pxH: h * 24 };
}

function hexToRGB(hex) {
  const bigint = parseInt(hex.slice(1), 16);
  return [
    (bigint >> 16) & 255,
    (bigint >> 8) & 255,
    bigint & 255
  ];
}

function distanceFromMillimeters(mm) {
  return {
    mm,
    cm: mm / 10,
    m: mm / 1000,
    inches: mm * 0.0393701,
  };
}

function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) {
    throw new RangeError("offset is not uint");
  }
  if (offset + ext > length) {
    throw new RangeError("Trying to access beyond buffer length");
  }
}

function checkInt(buf, value, offset, ext, max, min) {
  if (value > max || value < min) {
    throw new RangeError('"value" argument is out of bounds');
  }
  if (offset + ext > buf.length) {
    throw new RangeError("Index out of range");
  }
}

function readUInt32BE(imgData, offset) {
  offset = offset >>> 0;
  checkOffset(offset, 4, imgData.length);

  return (
    imgData[offset] * 0x1000000 +
    ((imgData[offset + 1] << 16) | (imgData[offset + 2] << 8) | imgData[offset + 3])
  );
}

function writeUInt32BE(imgData, value, offset) {
  value = +value;
  offset = offset >>> 0;
  checkInt(imgData, value, offset, 4, 0xffffffff, 0);

  // Canvas ImageData.data is a Uint8ClampedArray, not a regular Uint8Array.
  // Uint8ClampedArray automatically clamps values to 0-255.
  // Ensure values are properly clamped.
  imgData[offset] = (value >>> 24) & 0xff;
  imgData[offset + 1] = (value >>> 16) & 0xff;
  imgData[offset + 2] = (value >>> 8) & 0xff;
  imgData[offset + 3] = value & 0xff;
}

// Find the best matching size based on image aspect ratio (among editorSizeOptions)
function findBestMatchingSize(imageWidth, imageHeight) {
  const selectableSizes = getEditorSizeOptions();
  const imageAspect = imageWidth / imageHeight;

  let bestSize = selectableSizes[0];
  let minDifference = Infinity;

  selectableSizes.forEach((size) => {
    const { baseW, baseH } = parseSize(size);
    const sizeAspect = baseW / baseH;
    const difference = Math.abs(imageAspect - sizeAspect);

    if (difference < minDifference) {
      minDifference = difference;
      bestSize = size;
    }
  });

  return { size: bestSize };
}

function updateDeliveryContent(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);
  const totalBaseplates = baseW * baseH;
  const totalBricks = totalBaseplates * 24 * 24;
  
  if (deliveryBaseplatesCount) {
    // Only update the number, "Transparent baseplaten" is already in HTML
    deliveryBaseplatesCount.innerText = totalBaseplates.toString();
  }
  
  if (deliveryBricksCount) {
    // Format large numbers with thousand separators and add "Steentjes" text
    deliveryBricksCount.innerText = totalBricks.toLocaleString('nl-NL');
  }
  
  // Check if strips are selected and show/hide strips card
  if (deliveryStripsCard && previewHangingOption) {
    const hangingText = previewHangingOption.innerText.toLowerCase();
    if (hangingText.includes('strips')) {
      // Calculate strips count (still needed for display in delivery modal)
      const stripsCount = sizeToStripsCount(sizeStr);
      
      if (deliveryStripsCount) {
        deliveryStripsCount.innerText = stripsCount.toString();
      }
      deliveryStripsCard.style.display = 'flex';
    } else {
      deliveryStripsCard.style.display = 'none';
    }
  }
  
  // Check if frame is selected and show/hide frame card
  if (deliveryFrameCard && previewHangingOption) {
    const hangingText = previewHangingOption.innerText.toLowerCase();
    if (hangingText.includes('lijst zwart') || hangingText.includes('zwart')) {
      // Black frame
      if (deliveryFrameImage) {
        deliveryFrameImage.src = 'https://cdn.shopify.com/s/files/1/0913/8998/5099/files/frame_black_front.png?v=1766620202';
        deliveryFrameImage.alt = 'Lijst zwart';
      }
      if (deliveryFrameText) {
        deliveryFrameText.innerText = 'Lijst zwart';
      }
      deliveryFrameCard.style.display = 'flex';
    } else if (hangingText.includes('lijst wit') || hangingText.includes('wit')) {
      // White frame
      if (deliveryFrameImage) {
        deliveryFrameImage.src = 'https://cdn.shopify.com/s/files/1/0913/8998/5099/files/frame_white_front.png?v=1766620202';
        deliveryFrameImage.alt = 'Lijst wit';
      }
      if (deliveryFrameText) {
        deliveryFrameText.innerText = 'Lijst wit';
      }
      deliveryFrameCard.style.display = 'flex';
    } else if (hangingText.includes('lijst goud') || hangingText.includes('goud')) {
      // Gold frame
      if (deliveryFrameImage) {
        deliveryFrameImage.src = 'https://cdn.shopify.com/s/files/1/0913/8998/5099/files/frame_gold_front.png?v=1766620295';
        deliveryFrameImage.alt = 'Lijst goud';
      }
      if (deliveryFrameText) {
        deliveryFrameText.innerText = 'Lijst goud';
      }
      deliveryFrameCard.style.display = 'flex';
    } else {
      deliveryFrameCard.style.display = 'none';
    }
  }
}



// ===== resize.js =====
function resizeOLD(img, sizeStr, offset, zoomFactor) {
    const { baseW, baseH, pxW, pxH } = parseSize(sizeStr);
  
    const xScale = pxW / img.width;
    const yScale = pxH / img.height;
    const useScale = Math.max(xScale, yScale) * zoomFactor;
    const targetWidth = Math.round(img.width * useScale);
    const targetHeight = Math.round(img.height * useScale);
  
  
    const canvasTemp = document.createElement("canvas");
    const ctxTemp = canvasTemp.getContext("2d", { willReadFrequently: true });
  
    canvasTemp.width = targetWidth;
    canvasTemp.height = targetHeight;
    
    // High quality settings
    ctxTemp.imageSmoothingEnabled = true;
    ctxTemp.imageSmoothingQuality = 'high';
    
    // Draw and resize in one step
    ctxTemp.drawImage(img, 0, 0, targetWidth, targetHeight);
  
    // document.body.appendChild(canvasTemp);
    
    return ctxTemp.getImageData(0, 0, targetWidth, targetHeight);
  }


function parseSize(sizeStr) {
    const [w, h] = sizeStr.split("x").map(Number);
    return { baseW: w, baseH: h, pxW: w * 24, pxH: h * 24 };
  }

function resizeADVANCED(imgBitmap, sizeStr, offset, zoomFactor) {
    const { baseW, baseH, pxW, pxH } = parseSize(sizeStr);

    const xScale = pxW / imgBitmap.width;
  const yScale = pxH / imgBitmap.height;
  const useScale = Math.max(xScale, yScale) * zoomFactor;
  let targetWidth = Math.round(imgBitmap.width * useScale);
  let targetHeight = Math.round(imgBitmap.height * useScale);
  // Clamp to at least 1 to avoid 0-sized buffer and ImageData constructor error during zoom
  targetWidth = Math.max(1, targetWidth);
  targetHeight = Math.max(1, targetHeight);

  return resizeBitmap(imgBitmap, targetWidth, targetHeight);
}

function resizeBitmap(image, targetWidth, targetHeight) {
    const state = createResizeState(image.width, image.height, targetWidth, targetHeight);
    initialize(state);
    const data = resize(state, image.data);
    return {
        ...image,
        data,
        width: targetWidth,
        height: targetHeight,
    };
}

// Constants
const BITMAP_CHANNELS = 4;
const FOURTH_CHANNEL = true; // RGBA has 4 channels

/**
 * Identity function that returns buffer as-is (for no-op resize passes)
 * @param {Uint8Array|Float32Array|Float64Array} buffer 
 * @returns {Uint8Array|Float32Array|Float64Array}
 */
function bufferIdentity(buffer) {
  return buffer;
}

/**
 * Creates a resize state object with all configuration and buffer references
 * @param {number} widthOriginal - Original image width
 * @param {number} heightOriginal - Original image height
 * @param {number} targetWidth - Target width after resize
 * @param {number} targetHeight - Target height after resize
 * @returns {ResizeState}
 */
function createResizeState(widthOriginal, heightOriginal, targetWidth, targetHeight) {
  // Normalize and validate dimensions
  const finalWidthOriginal = Math.abs(Math.floor(widthOriginal) || 0);
  const finalHeightOriginal = Math.abs(Math.floor(heightOriginal) || 0);
  const finalTargetWidth = Math.abs(Math.floor(targetWidth) || 0);
  const finalTargetHeight = Math.abs(Math.floor(targetHeight) || 0);

  // Calculate buffer sizes (multiply by 4 for RGBA channels)
  const targetWidthMultipliedByChannels = finalTargetWidth * BITMAP_CHANNELS;
  const originalWidthMultipliedByChannels = finalWidthOriginal * BITMAP_CHANNELS;
  const originalHeightMultipliedByChannels = finalHeightOriginal * BITMAP_CHANNELS;
  
  // Calculate intermediate and final buffer sizes
  const widthPassResultSize = targetWidthMultipliedByChannels * finalHeightOriginal;
  const finalResultSize = targetWidthMultipliedByChannels * finalTargetHeight;

  return {
    widthOriginal: finalWidthOriginal,
    heightOriginal: finalHeightOriginal,
    targetWidth: finalTargetWidth,
    targetHeight: finalTargetHeight,
    targetWidthMultipliedByChannels: targetWidthMultipliedByChannels,
    originalWidthMultipliedByChannels: originalWidthMultipliedByChannels,
    originalHeightMultipliedByChannels: originalHeightMultipliedByChannels,
    widthPassResultSize: widthPassResultSize,
    finalResultSize: finalResultSize,
    
    // Resize functions (will be assigned in configurePasses)
    resizeWidth: bufferIdentity,
    resizeHeight: bufferIdentity,
    
    // Ratio weights (will be calculated in configurePasses)
    ratioWeightWidthPass: 0,
    ratioWeightHeightPass: 0,
    
    // Buffers (will be allocated in initialize functions)
    widthBuffer: undefined,
    heightBuffer: undefined,
    outputHeightWorkBench: undefined,
    outputHeightWorkBenchOpaquePixelsCount: undefined,
    outputWidthWorkBench: undefined,
    outputWidthWorkBenchOpaquePixelsCount: undefined,
  };
}

/**
 * Generates a Float32Array buffer of specified length
 * @param {number} bufferLength 
 * @returns {Float32Array}
 */
function generateFloatBuffer(bufferLength) {
  return new Float32Array(bufferLength);
}

/**
 * Generates a Float64Array buffer of specified length
 * @param {number} bufferLength 
 * @returns {Float64Array}
 */
function generateFloat64Buffer(bufferLength) {
  return new Float64Array(bufferLength);
}

/**
 * Generates a Uint8Array buffer of specified length
 * @param {number} bufferLength 
 * @returns {Uint8Array}
 */
function generateUint8Buffer(bufferLength) {
  return new Uint8Array(bufferLength);
}

/**
 * Initializes buffers for the first pass (width resize)
 * @param {ResizeState} state - The resize state object
 * @param {boolean} BILINEARAlgo - Whether using bilinear interpolation (true) or area sampling (false)
 */
function initializeFirstPassBuffers(state, BILINEARAlgo) {
  // Initialize the internal width pass buffers:
  state.widthBuffer = generateFloatBuffer(state.widthPassResultSize);

  if (!BILINEARAlgo) {
    // Area sampling algorithm needs workbench buffers
    state.outputWidthWorkBench = generateFloatBuffer(
      state.originalHeightMultipliedByChannels,
    );

    if (BITMAP_CHANNELS > 3) {
      // Alpha channel support - track opaque pixel counts
      state.outputWidthWorkBenchOpaquePixelsCount = generateFloat64Buffer(
        state.heightOriginal,
      );
    }
  }
}

/**
 * Initializes buffers for the second pass (height resize)
 * @param {ResizeState} state - The resize state object
 * @param {boolean} BILINEARAlgo - Whether using bilinear interpolation (true) or area sampling (false)
 */
function initializeSecondPassBuffers(state, BILINEARAlgo) {
  // Initialize the internal height pass buffers:
  state.heightBuffer = generateUint8Buffer(state.finalResultSize);

  if (!BILINEARAlgo) {
    // Area sampling algorithm needs workbench buffers
    state.outputHeightWorkBench = generateFloatBuffer(
      state.targetWidthMultipliedByChannels,
    );

    if (BITMAP_CHANNELS > 3) {
      // Alpha channel support - track opaque pixel counts
      state.outputHeightWorkBenchOpaquePixelsCount = generateFloat64Buffer(
        state.targetWidth,
      );
    }
  }
}

/**
 * Configures the resize passes based on scale ratios
 * Sets up resizeWidth and resizeHeight functions and allocates buffers
 * @param {ResizeState} state - The resize state object
 */
function configurePasses(state) {
  // WIDTH PASS CONFIGURATION
  if (state.widthOriginal === state.targetWidth) {
    // No width resize needed - use identity function
    state.resizeWidth = bufferIdentity;
  } else {
    // Calculate scale ratio for width pass
    state.ratioWeightWidthPass = state.widthOriginal / state.targetWidth;

    if (state.ratioWeightWidthPass < 1) {
      // UPSCALING: Use bilinear interpolation
      initializeFirstPassBuffers(state, true);
      state.resizeWidth = (buffer) => resizeWidthInterpolatedRGBA(state, buffer);
    } else {
      // DOWNSCALING: Use area sampling
      initializeFirstPassBuffers(state, false);
      state.resizeWidth = (buffer) => _resizeWidthRGBChannels(state, buffer);
    }
  }

  // HEIGHT PASS CONFIGURATION
  if (state.heightOriginal === state.targetHeight) {
    // No height resize needed - use identity function
    state.resizeHeight = bufferIdentity;
  } else {
    // Calculate scale ratio for height pass
    state.ratioWeightHeightPass = state.heightOriginal / state.targetHeight;

    if (state.ratioWeightHeightPass < 1) {
      // UPSCALING: Use bilinear interpolation
      initializeSecondPassBuffers(state, true);
      state.resizeHeight = (buffer) => resizeHeightInterpolated(state, buffer);
    } else {
      // DOWNSCALING: Use area sampling
      initializeSecondPassBuffers(state, false);
      state.resizeHeight = (buffer) => _resizeHeightRGBChannels(state, buffer);
    }
  }
}

/**
 * Resizes width using bilinear interpolation (for upscaling)
 * @param {ResizeState} state - The resize state object
 * @param {Uint8Array|TypedArray} source - Source pixel data (RGBA)
 * @returns {Float32Array} Resized width buffer
 */
function _resizeWidthInterpolatedRGBChannels(state, source) {
  const ratioWeight = state.ratioWeightWidthPass;
  const outputBuffer = state.widthBuffer;
  let weight = 0;
  let finalOffset = 0;
  let pixelOffset = 0;
  let firstWeight = 0;
  let secondWeight = 0;
  let targetPosition;

  // Handle for only one interpolation input being valid for start calculation:
  // First 1/3 of pixels - use first source pixel directly (no interpolation)
  for (
    targetPosition = 0;
    weight < 1 / 3;
    targetPosition += BITMAP_CHANNELS, weight += ratioWeight
  ) {
    for (
      finalOffset = targetPosition, pixelOffset = 0;
      finalOffset < state.widthPassResultSize;
      pixelOffset += state.originalWidthMultipliedByChannels,
        finalOffset += state.targetWidthMultipliedByChannels
    ) {
      outputBuffer[finalOffset] = source[pixelOffset];
      outputBuffer[finalOffset + 1] = source[pixelOffset + 1];
      outputBuffer[finalOffset + 2] = source[pixelOffset + 2];
      if (FOURTH_CHANNEL) {
        outputBuffer[finalOffset + 3] = source[pixelOffset + 3];
      }
    }
  }

  // Adjust for overshoot of the last pass's counter:
  weight -= 1 / 3;
  let interpolationWidthSourceReadStop;

  // Main interpolation loop - interpolate between two adjacent source pixels
  for (
    interpolationWidthSourceReadStop = state.widthOriginal - 1;
    weight < interpolationWidthSourceReadStop;
    targetPosition += BITMAP_CHANNELS, weight += ratioWeight
  ) {
    // Calculate weightings:
    secondWeight = weight % 1;
    firstWeight = 1 - secondWeight;

    // Interpolate for each row:
    for (
      finalOffset = targetPosition,
        pixelOffset = Math.floor(weight) * BITMAP_CHANNELS;
      finalOffset < state.widthPassResultSize;
      pixelOffset += state.originalWidthMultipliedByChannels,
        finalOffset += state.targetWidthMultipliedByChannels
    ) {
      // Bilinear interpolation: blend between two adjacent pixels
      outputBuffer[finalOffset + 0] =
        source[pixelOffset + 0] * firstWeight +
        source[pixelOffset + BITMAP_CHANNELS + 0] * secondWeight;
      outputBuffer[finalOffset + 1] =
        source[pixelOffset + 1] * firstWeight +
        source[pixelOffset + BITMAP_CHANNELS + 1] * secondWeight;
      outputBuffer[finalOffset + 2] =
        source[pixelOffset + 2] * firstWeight +
        source[pixelOffset + BITMAP_CHANNELS + 2] * secondWeight;
      if (FOURTH_CHANNEL) {
        outputBuffer[finalOffset + 3] =
          source[pixelOffset + 3] * firstWeight +
          source[pixelOffset + BITMAP_CHANNELS + 3] * secondWeight;
      }
    }
  }

  // Handle for only one interpolation input being valid for end calculation:
  // Last pixels - use last source pixel directly (no interpolation)
  for (
    interpolationWidthSourceReadStop =
      state.originalWidthMultipliedByChannels - BITMAP_CHANNELS;
    targetPosition < state.targetWidthMultipliedByChannels;
    targetPosition += BITMAP_CHANNELS
  ) {
    for (
      finalOffset = targetPosition,
        pixelOffset = interpolationWidthSourceReadStop;
      finalOffset < state.widthPassResultSize;
      pixelOffset += state.originalWidthMultipliedByChannels,
        finalOffset += state.targetWidthMultipliedByChannels
    ) {
      outputBuffer[finalOffset] = source[pixelOffset];
      outputBuffer[finalOffset + 1] = source[pixelOffset + 1];
      outputBuffer[finalOffset + 2] = source[pixelOffset + 2];
      if (FOURTH_CHANNEL) {
        outputBuffer[finalOffset + 3] = source[pixelOffset + 3];
      }
    }
  }

  return outputBuffer;
}

/**
 * Wrapper for width resize with bilinear interpolation
 * @param {ResizeState} state - The resize state object
 * @param {Uint8Array|TypedArray} source - Source pixel data (RGBA)
 * @returns {Float32Array} Resized width buffer
 */
function resizeWidthInterpolatedRGBA(state, source) {
  return _resizeWidthInterpolatedRGBChannels(state, source);
}

/**
 * Area sampling loop for width downscaling
 * @param {ResizeState} state - The resize state object
 * @param {Uint8Array|TypedArray} buffer - Source pixel data
 * @param {Object} calcVars - Calculation variables (mutated during execution)
 */
function resizeWidthRgbaChannelsLoop(state, buffer, calcVars) {
  // Reset output buffer for this target pixel
  for (let line = 0; line < state.originalHeightMultipliedByChannels; ) {
    calcVars.output[line++] = 0;
    calcVars.output[line++] = 0;
    calcVars.output[line++] = 0;

    if (FOURTH_CHANNEL) {
      calcVars.output[line++] = 0;
      calcVars.trustworthyColorsCount[line / BITMAP_CHANNELS - 1] = 0;
    }
  }

  calcVars.weight = calcVars.ratioWeight;

  // Accumulate weighted pixel values from source
  do {
    calcVars.amountToNext =
      1 + calcVars.actualPosition - calcVars.currentPosition;
    calcVars.multiplier = Math.min(calcVars.weight, calcVars.amountToNext);

    let pixelOffset1 = calcVars.actualPosition;
    for (
      let line = 0;
      line < state.originalHeightMultipliedByChannels;
      pixelOffset1 += calcVars.nextLineOffsetOriginalWidth
    ) {
      const r = buffer[pixelOffset1];
      const g = buffer[++pixelOffset1];
      const b = buffer[++pixelOffset1];
      const a = FOURTH_CHANNEL ? buffer[++pixelOffset1] : 255;

      // Accumulate weighted color values (ignore RGB if pixel is transparent)
      calcVars.output[line++] += (a ? r : 0) * calcVars.multiplier;
      calcVars.output[line++] += (a ? g : 0) * calcVars.multiplier;
      calcVars.output[line++] += (a ? b : 0) * calcVars.multiplier;

      if (FOURTH_CHANNEL) {
        calcVars.output[line++] += a * calcVars.multiplier;
        calcVars.trustworthyColorsCount[line / BITMAP_CHANNELS - 1] += a
          ? calcVars.multiplier
          : 0;
      }
    }

    if (calcVars.weight >= calcVars.amountToNext) {
      calcVars.actualPosition += BITMAP_CHANNELS;
      calcVars.currentPosition = calcVars.actualPosition;
      calcVars.weight -= calcVars.amountToNext;
    } else {
      calcVars.currentPosition += calcVars.weight;
      break;
    }
  } while (
    calcVars.weight > 0 &&
    calcVars.actualPosition < state.originalWidthMultipliedByChannels
  );

  // Normalize accumulated values and write to output buffer
  let pixelOffset = calcVars.outputOffset;
  for (
    let line = 0;
    line < state.originalHeightMultipliedByChannels;
    pixelOffset += calcVars.nextLineOffsetTargetWidth
  ) {
    calcVars.weight = FOURTH_CHANNEL
      ? calcVars.trustworthyColorsCount[line / BITMAP_CHANNELS]
      : 1;
    calcVars.multiplier = FOURTH_CHANNEL
      ? calcVars.weight
        ? 1 / calcVars.weight
        : 0
      : calcVars.ratioWeightDivisor;
    calcVars.outputBuffer[pixelOffset] =
      calcVars.output[line++] * calcVars.multiplier;
    calcVars.outputBuffer[++pixelOffset] =
      calcVars.output[line++] * calcVars.multiplier;
    calcVars.outputBuffer[++pixelOffset] =
      calcVars.output[line++] * calcVars.multiplier;
    if (FOURTH_CHANNEL) {
      calcVars.outputBuffer[++pixelOffset] =
        calcVars.output[line++] * calcVars.ratioWeightDivisor;
    }
  }
  calcVars.outputOffset += BITMAP_CHANNELS;
}

/**
 * Resizes height using bilinear interpolation (for upscaling)
 * @param {ResizeState} state - The resize state object
 * @param {Uint8Array|TypedArray|Float32Array|Float64Array} source - Source pixel data (from width pass)
 * @returns {Float32Array|Float64Array} Resized height buffer
 */
function resizeHeightInterpolated(state, source) {
  const ratioWeight = state.ratioWeightHeightPass;
  const outputBuffer = state.heightBuffer;
  let weight = 0;
  let finalOffset = 0;
  let pixelOffset = 0;
  let pixelOffsetAccumulated = 0;
  let pixelOffsetAccumulated2 = 0;
  let firstWeight = 0;
  let secondWeight = 0;
  let interpolationHeightSourceReadStop;

  // Handle for only one interpolation input being valid for start calculation:
  // First 1/3 of pixels - use first source row directly (no interpolation)
  for (; weight < 1 / 3; weight += ratioWeight) {
    for (
      pixelOffset = 0;
      pixelOffset < state.targetWidthMultipliedByChannels;
    ) {
      outputBuffer[finalOffset++] = Math.round(source[pixelOffset++]);
    }
  }

  // Adjust for overshoot of the last pass's counter:
  weight -= 1 / 3;

  // Main interpolation loop - interpolate between two adjacent source rows
  for (
    interpolationHeightSourceReadStop = state.heightOriginal - 1;
    weight < interpolationHeightSourceReadStop;
    weight += ratioWeight
  ) {
    // Calculate weightings:
    secondWeight = weight % 1;
    firstWeight = 1 - secondWeight;

    // Interpolate:
    pixelOffsetAccumulated =
      Math.floor(weight) * state.targetWidthMultipliedByChannels;
    pixelOffsetAccumulated2 =
      pixelOffsetAccumulated + state.targetWidthMultipliedByChannels;

    for (
      pixelOffset = 0;
      pixelOffset < state.targetWidthMultipliedByChannels;
      ++pixelOffset
    ) {
      outputBuffer[finalOffset++] = Math.round(
        source[pixelOffsetAccumulated++] * firstWeight +
          source[pixelOffsetAccumulated2++] * secondWeight,
      );
    }
  }

  // Handle for only one interpolation input being valid for end calculation:
  // Last rows - use last source row directly (no interpolation)
  while (finalOffset < state.finalResultSize) {
    for (
      pixelOffset = 0,
        pixelOffsetAccumulated =
          interpolationHeightSourceReadStop *
          state.targetWidthMultipliedByChannels;
      pixelOffset < state.targetWidthMultipliedByChannels;
      ++pixelOffset
    ) {
      outputBuffer[finalOffset++] = Math.round(
        source[pixelOffsetAccumulated++],
      );
    }
  }

  return outputBuffer;
}

/**
 * Area sampling loop for height downscaling
 * @param {ResizeState} state - The resize state object
 * @param {Uint8Array|TypedArray|Float32Array|Float64Array} source - Source pixel data (from width pass)
 * @param {Object} calcVars - Calculation variables (mutated during execution)
 */
function resizeHeightLoop(state, source, calcVars) {
  // Reset output buffer for this target row
  for (let i = 0; i < state.targetWidthMultipliedByChannels; ) {
    state.outputHeightWorkBench[i++] = 0;
    state.outputHeightWorkBench[i++] = 0;
    state.outputHeightWorkBench[i++] = 0;

    if (FOURTH_CHANNEL) {
      state.outputHeightWorkBench[i++] = 0;
      state.outputHeightWorkBenchOpaquePixelsCount[i / BITMAP_CHANNELS - 1] = 0;
    }
  }

  let weight = state.ratioWeightHeightPass;

  // Accumulate weighted pixel values from source rows
  do {
    const amountToNext = 1 + calcVars.actualPosition - calcVars.currentPosition;
    const multiplier = Math.min(weight, amountToNext);
    let caret = calcVars.actualPosition;

    for (let j = 0; j < state.targetWidthMultipliedByChannels; ) {
      const r = source[caret++];
      const g = source[caret++];
      const b = source[caret++];
      const a = FOURTH_CHANNEL ? source[caret++] : 255;

      // Accumulate weighted color values (ignore RGB if pixel is transparent)
      state.outputHeightWorkBench[j++] += (a ? r : 0) * multiplier;
      state.outputHeightWorkBench[j++] += (a ? g : 0) * multiplier;
      state.outputHeightWorkBench[j++] += (a ? b : 0) * multiplier;

      if (FOURTH_CHANNEL) {
        state.outputHeightWorkBench[j++] += a * multiplier;
        state.outputHeightWorkBenchOpaquePixelsCount[j / BITMAP_CHANNELS - 1] += a
          ? multiplier
          : 0;
      }
    }

    if (weight >= amountToNext) {
      calcVars.actualPosition = caret;
      calcVars.currentPosition = calcVars.actualPosition;
      weight -= amountToNext;
    } else {
      calcVars.currentPosition += weight;
      break;
    }
  } while (weight > 0 && calcVars.actualPosition < state.widthPassResultSize);

  // Normalize accumulated values and write to output buffer
  for (let k = 0; k < state.targetWidthMultipliedByChannels; ) {
    const pixelWeight = FOURTH_CHANNEL
      ? state.outputHeightWorkBenchOpaquePixelsCount[k / BITMAP_CHANNELS]
      : 1;
    const multiplier = FOURTH_CHANNEL
      ? pixelWeight
        ? 1 / pixelWeight
        : 0
      : calcVars.ratioWeightDivisor;
    state.heightBuffer[calcVars.outputOffset++] = Math.round(
      state.outputHeightWorkBench[k++] * multiplier,
    );
    state.heightBuffer[calcVars.outputOffset++] = Math.round(
      state.outputHeightWorkBench[k++] * multiplier,
    );
    state.heightBuffer[calcVars.outputOffset++] = Math.round(
      state.outputHeightWorkBench[k++] * multiplier,
    );

    if (FOURTH_CHANNEL) {
      state.heightBuffer[calcVars.outputOffset++] = Math.round(
        state.outputHeightWorkBench[k++] * calcVars.ratioWeightDivisor,
      );
    }
  }
}

/**
 * Resizes height using area sampling (for downscaling)
 * @param {ResizeState} state - The resize state object
 * @param {Uint8Array|TypedArray|Float32Array|Float64Array} buffer - Source pixel data (from width pass)
 * @returns {Float32Array|Float64Array} Resized height buffer
 */
function _resizeHeightRGBChannels(state, buffer) {
  const calcVars = {
    ratioWeightDivisor: 1 / state.ratioWeightHeightPass,
    actualPosition: 0,
    currentPosition: 0,
    outputOffset: 0,
  };

  // Process each target row
  do {
    resizeHeightLoop(state, buffer, calcVars);
  } while (calcVars.outputOffset < state.finalResultSize);

  return state.heightBuffer;
}

/**
 * Resizes width using area sampling (for downscaling)
 * @param {ResizeState} state - The resize state object
 * @param {Uint8Array|TypedArray} buffer - Source pixel data (RGBA)
 * @returns {Float32Array|Float64Array} Resized width buffer
 */
function _resizeWidthRGBChannels(state, buffer) {
  const calcVars = {
    ratioWeight: state.ratioWeightWidthPass,
    ratioWeightDivisor: 1 / state.ratioWeightWidthPass,
    nextLineOffsetOriginalWidth:
      state.originalWidthMultipliedByChannels - BITMAP_CHANNELS + 1,
    nextLineOffsetTargetWidth:
      state.targetWidthMultipliedByChannels - BITMAP_CHANNELS + 1,
    output: state.outputWidthWorkBench,
    outputBuffer: state.widthBuffer,
    trustworthyColorsCount: state.outputWidthWorkBenchOpaquePixelsCount,
    weight: 0,
    amountToNext: 0,
    actualPosition: 0,
    currentPosition: 0,
    outputOffset: 0,
    multiplier: 1,
  };

  // Process each target pixel
  do {
    resizeWidthRgbaChannelsLoop(state, buffer, calcVars);
  } while (calcVars.outputOffset < state.targetWidthMultipliedByChannels);

  return calcVars.outputBuffer;
}

/**
 * Initializes the resize state by validating dimensions and configuring passes
 * @param {ResizeState} state - The resize state object to initialize
 * @throws {Error} If dimensions are invalid
 */
function initialize(state) {
  // Perform validation checks:
  if (
    state.widthOriginal > 0 &&
    state.heightOriginal > 0 &&
    state.targetWidth > 0 &&
    state.targetHeight > 0
  ) {
    configurePasses(state);
  } else {
    throw new Error("Invalid settings specified for the resizer.");
  }
}

/**
 * Converts ArrayBuffer or TypedArray to Uint8Array
 * @param {ArrayBuffer|TypedArray} array - The buffer to convert
 * @param {number} [byteOffset] - Optional byte offset
 * @param {number} [length] - Optional length
 * @returns {Uint8Array}
 */
function uint8ArrayFromArrayBuffer(array, byteOffset, length) {
  // If it's already a Uint8Array, return it
  if (array instanceof Uint8Array) {
    if (byteOffset === undefined && length === undefined) {
      return array;
    }
    if (length === undefined) {
      return new Uint8Array(array.buffer, array.byteOffset + (byteOffset || 0));
    }
    return new Uint8Array(array.buffer, array.byteOffset + (byteOffset || 0), length);
  }

  // If it's a TypedArray, get its buffer
  if (array.buffer instanceof ArrayBuffer) {
    const buffer = array.buffer;
    const offset = array.byteOffset + (byteOffset || 0);
    const len = length !== undefined ? length : (array.byteLength - (byteOffset || 0));
    
    if (offset < 0 || buffer.byteLength < offset) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (buffer.byteLength < offset + len) {
      throw new RangeError('"length" is outside of buffer bounds');
    }
    
    return new Uint8Array(buffer, offset, len);
  }

  // If it's an ArrayBuffer
  if (array instanceof ArrayBuffer) {
    if (byteOffset === undefined && length === undefined) {
      return new Uint8Array(array);
    }
    if (length === undefined) {
      return new Uint8Array(array, byteOffset);
    }
    
    if (byteOffset !== undefined && (byteOffset < 0 || array.byteLength < byteOffset)) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (byteOffset !== undefined && array.byteLength < byteOffset + length) {
      throw new RangeError('"length" is outside of buffer bounds');
    }
    
    return new Uint8Array(array, byteOffset, length);
  }

  // Fallback: try to create from buffer property
  if (array.buffer) {
    return new Uint8Array(array.buffer, array.byteOffset || 0, array.byteLength || array.length);
  }

  throw new TypeError('Invalid buffer type');
}

/**
 * Executes the two-pass resize operation
 * @param {ResizeState} state - The initialized resize state
 * @param {Uint8Array|TypedArray} source - Source pixel data (RGBA)
 * @returns {Uint8Array} Resized pixel data
 */
function resize(state, source) {
  // PASS 1: Resize width (horizontal)
  const widthBuffer = state.resizeWidth(source);
  
  // PASS 2: Resize height (vertical) using width result
  const heightResult = state.resizeHeight(widthBuffer);
  
  // Convert result to Uint8Array
  return uint8ArrayFromArrayBuffer(heightResult);
}

/**
 * Converts a JavaScript Image (HTMLImageElement) to BuildBitmap
 * @param {HTMLImageElement|Image} image - The image element to convert
 * @param {{rgba: number}|undefined} noBrickColour - Optional color for transparent/background areas
 * @returns {BuildBitmap}
 */
function imageToBuildBitmap(image, noBrickColour = undefined) {
  // Create a temporary canvas to extract pixel data
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  
  // Set canvas size to match image
  canvas.width = image.width;
  canvas.height = image.height;
  
  // Draw image to canvas
  ctx.drawImage(image, 0, 0);
  
  // Get ImageData (contains Uint8ClampedArray)
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  
  // Convert Uint8ClampedArray to Uint8Array
  const pixelData = new Uint8Array(imageData.data);
  
  // Create and return BuildBitmap
  return createBuildBitmap(pixelData, image.width, image.height, noBrickColour);
}

/**
 * Converts BuildBitmap to ImageData
 * @param {BuildBitmap} buildBitmap - The BuildBitmap to convert
 * @returns {ImageData}
 */
function buildBitmapToImageData(buildBitmap) {
  const expectedSize = buildBitmap.width * buildBitmap.height * 4;
  const dataSubarray = buildBitmap.data.subarray 
    ? buildBitmap.data.subarray(0, expectedSize)
    : buildBitmap.data.slice(0, expectedSize);
  const clampedData = Uint8ClampedArray.from 
    ? Uint8ClampedArray.from(dataSubarray)
    : new Uint8ClampedArray(dataSubarray);
  return new ImageData(clampedData, buildBitmap.width, buildBitmap.height);
}

// ===== crop.js =====
/**
 * Allocates a Uint8Array (unsafe - no bounds checking)
 * @param {number} size - Size in bytes
 * @returns {Uint8Array}
 */
function uint8ArrayAllocUnsafe(size) {
  return new Uint8Array(size < 0 ? 0 : size | 0);
}

/**
 * Crops a bitmap by copying pixels directly (reimplementation from brick.me)
 * @param {Object} image - Bitmap object with {data: Uint8Array, width: number, height: number}
 * @param {number} x - Crop start X coordinate
 * @param {number} y - Crop start Y coordinate
 * @param {number} w - Crop width
 * @param {number} h - Crop height
 * @returns {Object} Cropped bitmap with same structure as input
 */
function cropBitmap(image, x, y, w, h) {
  // Validation (matching brick.me)
  if (w !== Math.round(w) || h !== Math.round(h)) {
    throw new Error(`Crop expects int width height ${w}x${h}`);
  }

  // Optimization: If cropping from left edge with full width, use slice
  if (x === 0 && w === image.width) {
    const start = (w * y + x) << 2;  // << 2 = * 4 (bytes per pixel)
    const end = (start + h * w) << 2;

    return {
      ...image,
      data: image.data.slice(start, end),
      width: w,
      height: h,
    };
  }

  // General case: Manual pixel-by-pixel copy
  const bitmap = uint8ArrayAllocUnsafe(w * h * BITMAP_CHANNELS);
  let offset = 0;

  // Note: take reference just to be safe
  const { width, data } = image;
  for (let yi = y; yi < y + h; yi++) {
    for (let xi = x; xi < x + w; xi++) {
      // Calculate source pixel index
      const idx = (width * yi + xi) << 2;
      
      // Read 32-bit RGBA pixel as single value
      const pixel = readUInt32BE(data, idx);
      
      // Write to destination
      writeUInt32BE(bitmap, pixel, offset);
      offset += 4;
    }
  }

  return {
    ...image,
    data: bitmap,
    width: w,
    height: h,
  };
}

function cropOLD(img, sizeStr, offset, zoomFactor) {
  const { baseW, baseH, pxW, pxH } = parseSize(sizeStr);

  const freeX = img.width - pxW;
  const freeY = img.height - pxH;

  const cropX = Math.min(
    freeX,
    Math.max(0, Math.round(freeX / 2 - offset.x)),
  );
  const cropY = Math.min(
    freeY,
    Math.max(0, Math.round(freeY / 2 - offset.y)),
  );

  const canvasCrop = document.createElement('canvas');
  const ctxCrop = canvasCrop.getContext('2d', { willReadFrequently: true });
  
  // Load original
  canvasCrop.width = img.width;
  canvasCrop.height = img.height;
  ctxCrop.putImageData(img, 0, 0);

  // document.body.appendChild(canvasCrop);
  
  // Extract cropped portion
  return ctxCrop.getImageData(cropX, cropY, pxW, pxH);
}

/**
 * Advanced crop using bitmap manipulation (matching brick.me approach)
 * @param {Object} imgBitmap - BuildBitmap object with {data: Uint8Array, width: number, height: number}
 * @param {string} sizeStr - Size string like "3x3"
 * @param {Object} offset - Offset object with {x: number, y: number}
 * @returns {Object} Cropped BuildBitmap
 */
function cropADVANCED(imgBitmap, sizeStr, offset) {
  const { baseW, baseH, pxW, pxH } = parseSize(sizeStr);

  const freeX = imgBitmap.width - pxW;
  const freeY = imgBitmap.height - pxH;

  const cropX = Math.min(
    freeX,
    Math.max(0, Math.round(freeX / 2 - offset.x)),
  );
  const cropY = Math.min(
    freeY,
    Math.max(0, Math.round(freeY / 2 - offset.y)),
  );

  return cropBitmap(imgBitmap, cropX, cropY, pxW, pxH);
}

// ===== suggest-crop.js =====
/**
 * Google detect-api /suggest-crop integration: cheapest formats in the request,
 * generic handling of whatever formats and crops the API returns.
 */

/** Normalized crops from last successful /suggest-crop (keys = format e.g. "2x2"). Cleared on new image. */
let lastSuggestCropCropsByFormat = null;

function clearSuggestCropCache() {
  lastSuggestCropCropsByFormat = null;
}

/**
 * Returns the normalized crop for a given size string if available.
 * @param {string} sizeStr
 * @returns {{ left: number, top: number, width: number, height: number } | null}
 */
function getSuggestCropForSizeIfAvailable(sizeStr) {
  if (!lastSuggestCropCropsByFormat) return null;
  const crop = lastSuggestCropCropsByFormat[sizeStr];
  if (
    !crop ||
    typeof crop.left !== "number" ||
    typeof crop.top !== "number" ||
    typeof crop.width !== "number" ||
    typeof crop.height !== "number"
  ) {
    return null;
  }
  if (!(crop.width > 0 && crop.height > 0)) return null;
  return crop;
}

/**
 * Returns the crop box in pixel coordinates for the given size string if available.
 * @param {string} sizeStr
 * @param {number} imageW
 * @param {number} imageH
 * @returns {{ left: number, top: number, width: number, height: number } | null}
 */
function getSuggestCropBoxPxForSizeIfAvailable(sizeStr, imageW, imageH) {
  const crop = getSuggestCropForSizeIfAvailable(sizeStr);
  if (!crop) return null;
  if (!(imageW > 0 && imageH > 0)) return null;
  return {
    left: crop.left * imageW,
    top: crop.top * imageH,
    width: crop.width * imageW,
    height: crop.height * imageH,
  };
}

/**
 * If the API provided a box for this format, apply auto zoom/pan. Otherwise leave zoom/drag unchanged.
 * @param {string} sizeStr
 * @returns {boolean} true if framing was applied
 */
function applySuggestCropFramingForSizeIfAvailable(sizeStr) {
  if (!lastSuggestCropCropsByFormat || !uploadedSourceBitmap) return false;
  const crop = getSuggestCropForSizeIfAvailable(sizeStr);
  if (
    !crop ||
    typeof crop.width !== "number" ||
    typeof crop.height !== "number" ||
    crop.width <= 0 ||
    crop.height <= 0
  ) {
    return false;
  }
  const w = uploadedSourceBitmap.width;
  const h = uploadedSourceBitmap.height;
  applyFramingFromNormalizedCrop(crop, sizeStr, w, h);
  return true;
}

function gcdInt(a, b) {
  let x = Math.abs(a);
  let y = Math.abs(b);
  while (y !== 0) {
    const t = y;
    y = x % y;
    x = t;
  }
  return x || 1;
}

function ratioKeyFromSizeStr(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);
  const d = gcdInt(baseW, baseH);
  return `${baseW / d}:${baseH / d}`;
}

/**
 * Sort selectable formats like the format modal (price asc, then area, then label).
 * @returns {string[]}
 */
function getSelectableSizesSortedByPrice() {
  const selectableSizes = [...getEditorSizeOptions()].sort((a, b) => {
    const priceA = sizeToPriceNumber(a);
    const priceB = sizeToPriceNumber(b);
    const rankA = priceA === null ? Number.POSITIVE_INFINITY : priceA;
    const rankB = priceB === null ? Number.POSITIVE_INFINITY : priceB;
    if (rankA !== rankB) return rankA - rankB;
    const { baseW: aW, baseH: aH } = parseSize(a);
    const { baseW: bW, baseH: bH } = parseSize(b);
    const areaA = aW * aH;
    const areaB = bW * bH;
    if (areaA !== areaB) return areaA - areaB;
    return a.localeCompare(b);
  });
  return selectableSizes;
}

/**
 * First N cheapest formats to send to the API (fewer if the shop offers fewer sizes).
 * @param {number} limit
 * @returns {string[]}
 */
function getCheapestFormatsForSuggestCropRequest(limit) {
  const n = Math.max(0, Math.floor(limit));
  if (n === 0) return [];
  return getSelectableSizesSortedByPrice().slice(0, n);
}

/**
 * Map API response to a shop size string. Uses `bestFormat` when available in the shop;
 * otherwise matches `bestRatioKey` to the cheapest matching selectable size.
 * Does not assume a fixed number of requested formats.
 * @param {object|null} data
 * @returns {string|null}
 */
function pickBestSizeFromSuggestResponse(data) {
  if (!data || typeof data !== "object") return null;
  if (typeof data.bestFormat !== "string" || !data.bestFormat.trim()) return null;

  const selectable = getEditorSizeOptions();
  if (selectable.length === 0) return null;

  const bestFormat = data.bestFormat.trim();
  if (selectable.includes(bestFormat)) return bestFormat;

  const wantKey =
    typeof data.bestRatioKey === "string" && data.bestRatioKey.trim()
      ? data.bestRatioKey.trim()
      : ratioKeyFromSizeStr(bestFormat);

  const candidates = selectable.filter((s) => ratioKeyFromSizeStr(s) === wantKey);
  if (candidates.length === 0) return null;

  const sorted = getSelectableSizesSortedByPrice();
  const rank = new Map(sorted.map((s, i) => [s, i]));
  candidates.sort((a, b) => (rank.get(a) ?? 999) - (rank.get(b) ?? 999));
  return candidates[0];
}

/**
 * Apply normalized crop (0..1) to zoom + pan for the current resize/crop pipeline.
 * @param {{ left: number, top: number, width: number, height: number }} crop
 * @param {string} sizeStr
 * @param {number} sourceW
 * @param {number} sourceH
 */
function applyFramingFromNormalizedCrop(crop, sizeStr, sourceW, sourceH) {
  const nl = crop.left;
  const nt = crop.top;
  const nw = crop.width;
  const nh = crop.height;
  if (!(nw > 0 && nh > 0 && sourceW > 0 && sourceH > 0)) return;

  const { pxW, pxH } = parseSize(sizeStr);
  const coverScale = Math.max(pxW / sourceW, pxH / sourceH);

  const useScaleW = pxW / (nw * sourceW);
  const useScaleH = pxH / (nh * sourceH);
  let useScale = (useScaleW + useScaleH) / 2;
  if (!(useScale > 0) || !Number.isFinite(useScale)) return;

  let zoomVal = useScale / coverScale;
  zoomVal *= SUGGEST_CROP_ZOOM_BOOST > 0 ? SUGGEST_CROP_ZOOM_BOOST : 1;
  zoomVal = Math.max(EDITOR_MIN_ZOOM, Math.min(EDITOR_MAX_ZOOM, zoomVal));

  const effectiveUseScale = coverScale * zoomVal;
  const W1 = Math.round(sourceW * effectiveUseScale);
  const H1 = Math.round(sourceH * effectiveUseScale);
  const freeX = W1 - pxW;
  const freeY = H1 - pxH;
  if (freeX < 0 || freeY < 0) return;

  const cx = nl + nw / 2;
  const cy = nt + nh / 2;
  let cropX = Math.round(cx * W1 - pxW / 2);
  let cropY = Math.round(cy * H1 - pxH / 2);
  cropX = Math.max(0, Math.min(freeX, cropX));
  cropY = Math.max(0, Math.min(freeY, cropY));

  zoom = zoomVal;
  dragOffset = {
    x: freeX / 2 - cropX,
    y: freeY / 2 - cropY,
  };

  if (zoomRange) {
    zoomRange.value = String(zoom);
  }
}

function imageToJpegBase64(img) {
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth || img.width;
  canvas.height = img.naturalHeight || img.height;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  ctx.drawImage(img, 0, 0);
  const dataUrl = canvas.toDataURL("image/jpeg", 0.92);
  const comma = dataUrl.indexOf(",");
  return comma === -1 ? dataUrl : dataUrl.slice(comma + 1);
}

/**
 * @param {HTMLImageElement} img
 * @returns {Promise<boolean>} true if suggest-crop was applied
 */
async function fetchSuggestCropAndApply(img) {
  const baseUrl =
    typeof DETECT_API_BASE_URL === "string" ? DETECT_API_BASE_URL.trim() : "";
  if (!baseUrl) return false;

  const formats = getCheapestFormatsForSuggestCropRequest(
    typeof SUGGEST_CROP_REQUEST_FORMAT_LIMIT === "number"
      ? SUGGEST_CROP_REQUEST_FORMAT_LIMIT
      : 3,
  );
  if (formats.length === 0) return false;

  let base64;
  try {
    base64 = imageToJpegBase64(img);
  } catch (e) {
    console.warn("suggest-crop: could not encode image", e);
    return false;
  }

  const url = `${baseUrl.replace(/\/$/, "")}/suggest-crop`;
  const headers = { "content-type": "application/json" };
  if (
    typeof DETECT_API_KEY === "string" &&
    DETECT_API_KEY.trim() !== ""
  ) {
    headers["x-api-key"] = DETECT_API_KEY.trim();
  }
  let res;
  try {
    res = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify({ base64, formats }),
    });
  } catch (e) {
    console.warn("suggest-crop: request failed", e);
    return false;
  }

  if (!res.ok) {
    console.warn("suggest-crop: HTTP", res.status);
    return false;
  }

  let data;
  try {
    data = await res.json();
  } catch (e) {
    console.warn("suggest-crop: invalid JSON", e);
    return false;
  }

  if (!data || typeof data !== "object" || data.error) {
    if (data && data.error) console.warn("suggest-crop:", data.error);
    return false;
  }

  if (data.cropsByFormat && typeof data.cropsByFormat === "object") {
    lastSuggestCropCropsByFormat = { ...data.cropsByFormat };
  } else {
    lastSuggestCropCropsByFormat = null;
  }

  const picked = pickBestSizeFromSuggestResponse(data);
  if (!picked) return false;

  selectedSize = picked;

  const cropsByFormat = data.cropsByFormat;
  const crop =
    cropsByFormat && typeof cropsByFormat === "object"
      ? cropsByFormat[picked]
      : null;

  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;
  if (
    crop &&
    typeof crop.width === "number" &&
    typeof crop.height === "number" &&
    crop.width > 0 &&
    crop.height > 0
  ) {
    applyFramingFromNormalizedCrop(crop, picked, w, h);
  }

  return true;
}


// ===== cloudinary-indexeddb-sync.js =====
/**
 * Background Cloudinary uploader for IndexedDB-stored images.
 *
 * - Reads blobs + URLs from IndexedDB DB `uploaded_image_editor`
 * - If URLs already exist, does nothing
 * - If URLs are missing but blobs exist, uploads to Cloudinary and saves URLs back
 * - Designed to be non-blocking and safe to run on every page load
 *
 * Stored record fields (single record):
 * - originalImageArrayBuffer: ArrayBuffer|null
 * - originalImageMimeType: string|null
 * - transformedImageArrayBuffer: ArrayBuffer|null
 * - transformedImageMimeType: string|null
 * - originalURL: string|null
 * - transformedURL: string|null
 */

(function cloudinaryIndexedDbSync() {
  const DB_NAME = UPLOADED_IMAGE_DB_NAME;
  const DB_VERSION = UPLOADED_IMAGE_DB_VERSION;
  const STORE = UPLOADED_IMAGE_STORE;
  const KEY = UPLOADED_IMAGE_KEY;

  const CLOUDINARY_UPLOAD_URL = "https://api.cloudinary.com/v1_1/doegu5fqf/image/upload";
  const UPLOAD_PRESET = "mosaic_user_uploads1";
  const FOLDER_ORIGINAL = "mosaics/original";
  const FOLDER_TRANSFORMED = "mosaics/transformed";
  const CLOUDINARY_MAX_ATTEMPTS = 3;
  const CLOUDINARY_RETRY_DELAYS_MS = [800, 1800];

  function openDb() {
    return new Promise((resolve, reject) => {
      try {
        if (!("indexedDB" in window)) {
          reject(new Error("IndexedDB not supported"));
          return;
        }
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
          const db = req.result;
          if (!db.objectStoreNames.contains(STORE)) {
            db.createObjectStore(STORE, { keyPath: "id" });
          }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error || new Error("Failed to open IndexedDB"));
      } catch (e) {
        reject(e);
      }
    });
  }

  async function getRecord() {
    const db = await openDb();
    return new Promise((resolve, reject) => {
      try {
        const tx = db.transaction(STORE, "readonly");
        const store = tx.objectStore(STORE);
        const req = store.get(KEY);
        req.onsuccess = () => resolve(req.result || null);
        req.onerror = () => reject(req.error || new Error("Failed to read IndexedDB record"));
        tx.oncomplete = () => { try { db.close(); } catch {} };
      } catch (e) {
        try { db.close(); } catch {}
        reject(e);
      }
    });
  }

  async function putRecord(patch) {
    const db = await openDb();
    return new Promise((resolve, reject) => {
      try {
        const tx = db.transaction(STORE, "readwrite");
        const store = tx.objectStore(STORE);
        const req = store.get(KEY);
        req.onsuccess = () => {
          const prev = req.result && typeof req.result === "object" ? req.result : { id: KEY };
          store.put({ ...prev, ...patch, id: KEY });
        };
        req.onerror = () => reject(req.error || new Error("Failed to read for update"));
        tx.oncomplete = () => { try { db.close(); } catch {}; resolve(true); };
        tx.onerror = () => { try { db.close(); } catch {}; reject(tx.error || new Error("IndexedDB update failed")); };
        tx.onabort = () => { try { db.close(); } catch {}; reject(tx.error || new Error("IndexedDB update aborted")); };
      } catch (e) {
        try { db.close(); } catch {}
        reject(e);
      }
    });
  }

  function isNonEmptyString(v) {
    return typeof v === "string" && v.trim().length > 0;
  }

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function isLikelyNetworkError(err) {
    if (err instanceof TypeError) return true;
    const message = err && typeof err.message === "string" ? err.message : String(err || "");
    return /failed to fetch|networkerror|network request failed/i.test(message);
  }

  function waitForOnline(timeoutMs) {
    if (typeof navigator === "undefined") return Promise.resolve(false);
    if (navigator.onLine !== false) return Promise.resolve(true);
    if (typeof window === "undefined") return Promise.resolve(false);

    return new Promise((resolve) => {
      let settled = false;
      let timer = null;
      const finish = (value) => {
        if (settled) return;
        settled = true;
        if (timer) clearTimeout(timer);
        window.removeEventListener("online", handleOnline);
        resolve(value);
      };
      const handleOnline = () => finish(true);
      window.addEventListener("online", handleOnline, { once: true });
      timer = setTimeout(() => finish(false), timeoutMs);
    });
  }

  function getTransformedBlobFromRecord(record) {
    if (!record || typeof record !== "object") return null;
    if (record.transformedImageArrayBuffer instanceof ArrayBuffer && record.transformedImageArrayBuffer.byteLength > 0) {
      const mimeType =
        typeof record.transformedImageMimeType === "string" && record.transformedImageMimeType.trim()
          ? record.transformedImageMimeType.trim()
          : "image/jpeg";
      return new Blob([record.transformedImageArrayBuffer], { type: mimeType });
    }
    return null;
  }

  function getOriginalBlobFromRecord(record) {
    if (!record || typeof record !== "object") return null;
    if (record.originalImageArrayBuffer instanceof ArrayBuffer && record.originalImageArrayBuffer.byteLength > 0) {
      const mimeType =
        typeof record.originalImageMimeType === "string" && record.originalImageMimeType.trim()
          ? record.originalImageMimeType.trim()
          : "image/jpeg";
      return new Blob([record.originalImageArrayBuffer], { type: mimeType });
    }
    return null;
  }

  async function uploadBlobToCloudinary(blob, folder, quality) {
    let lastError = null;
    for (let attempt = 1; attempt <= CLOUDINARY_MAX_ATTEMPTS; attempt += 1) {
      const formData = new FormData();
      formData.append("file", blob);
      formData.append("upload_preset", UPLOAD_PRESET);
      formData.append("folder", folder);
      if (quality) formData.append("quality", quality);

      try {
        const res = await fetch(CLOUDINARY_UPLOAD_URL, { method: "POST", body: formData });
        if (!res.ok) {
          throw new Error(`Cloudinary upload failed (${res.status})`);
        }
        const json = await res.json();
        const url = json && json.secure_url;
        if (!isNonEmptyString(url)) {
          throw new Error("Cloudinary response missing secure_url");
        }
        return url;
      } catch (err) {
        lastError = err;
        const canRetry = attempt < CLOUDINARY_MAX_ATTEMPTS && isLikelyNetworkError(err);
        if (!canRetry) break;
        await waitForOnline(10_000);
        const backoffMs = CLOUDINARY_RETRY_DELAYS_MS[Math.min(attempt - 1, CLOUDINARY_RETRY_DELAYS_MS.length - 1)];
        await wait(backoffMs);
      }
    }

    throw lastError || new Error("Cloudinary upload failed");
  }

  async function run() {
    let record;
    try {
      record = await getRecord();
    } catch (e) {
      console.error("cloudinary sync: failed to read IndexedDB", e);
      return;
    }

    if (!record || typeof record !== "object") return;

    // If URLs already exist, do nothing.
    if (isNonEmptyString(record.originalURL) && isNonEmptyString(record.transformedURL)) return;

    const originalBlob = getOriginalBlobFromRecord(record);
    const transformedBlob = getTransformedBlobFromRecord(record);
    if (!(originalBlob instanceof Blob) || !(transformedBlob instanceof Blob)) {
      console.warn("cloudinary sync: missing blobs, cannot upload");
      return;
    }

    // Upload in background (non-blocking). We still await sequentially to simplify reliability.
    try {
      const originalURL = isNonEmptyString(record.originalURL)
        ? record.originalURL
        : await uploadBlobToCloudinary(originalBlob, FOLDER_ORIGINAL);
      await putRecord({ originalURL });
    } catch (e) {
      console.error("cloudinary sync: failed uploading original", e);
      return;
    }

    try {
      const transformedURL = isNonEmptyString(record.transformedURL)
        ? record.transformedURL
        : await uploadBlobToCloudinary(transformedBlob, FOLDER_TRANSFORMED, "auto:best");
      await putRecord({ transformedURL });
    } catch (e) {
      console.error("cloudinary sync: failed uploading transformed", e);
      return;
    }
  }

  // Non-blocking start.
  try {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(() => run().catch((e) => console.error("cloudinary sync: unexpected error", e)), { timeout: 1500 });
    } else {
      setTimeout(() => run().catch((e) => console.error("cloudinary sync: unexpected error", e)), 0);
    }
  } catch (e) {
    console.error("cloudinary sync: failed to schedule", e);
  }
})();



// ===== image-processing.js =====
function getCropRect(img, targetAspectRatio) {
  const imgAspect = img.width / img.height;
  let cropW, cropH, cropX, cropY;

  if (imgAspect > targetAspectRatio) {
    cropH = img.height;
    cropW = cropH * targetAspectRatio;
    cropX = (img.width - cropW) / 2;
    cropY = 0;
  } else {
    cropW = img.width;
    cropH = cropW / targetAspectRatio;
    cropX = 0;
    cropY = (img.height - cropH) / 2;
  }

  return { cropX, cropY, cropW, cropH };
}


// ===== detail-filter.js =====
// Helper functions for blend modes
function pixelBrightness(r, g, b) {
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

function clipPixelChannel(value) {
  return Math.max(0, Math.min(255, Math.round(value)));
}

function vividLightBlend(foregroundData, backgroundData, amount = 2) {
  const result = new Uint8ClampedArray(foregroundData.length);
  const pixelMidValue = 127.5;
  
  for (let i = 0; i < foregroundData.length; i += 4) {
    const fR = foregroundData[i];
    const fG = foregroundData[i + 1];
    const fB = foregroundData[i + 2];
    const bR = backgroundData[i];
    const bG = backgroundData[i + 1];
    const bB = backgroundData[i + 2];
    
    const fBrightness = pixelBrightness(fR, fG, fB);
    
    if (fBrightness <= pixelMidValue) {
      // Color burn mode
      result[i]     = clipPixelChannel(255 - 255 * ((255 - bR) / Math.max(1, amount * fR)));
      result[i + 1] = clipPixelChannel(255 - 255 * ((255 - bG) / Math.max(1, amount * fG)));
      result[i + 2] = clipPixelChannel(255 - 255 * ((255 - bB) / Math.max(1, amount * fB)));
        } else {
      // Color dodge mode
      result[i]     = clipPixelChannel(255 * (bR / Math.max(1, amount * (255 - fR))));
      result[i + 1] = clipPixelChannel(255 * (bG / Math.max(1, amount * (255 - fG))));
      result[i + 2] = clipPixelChannel(255 * (bB / Math.max(1, amount * (255 - fB))));
    }
    result[i + 3] = foregroundData[i + 3]; // Preserve alpha
  }
  
                return result;
}

function overlayBlend(foregroundData, backgroundData) {
  const result = new Uint8ClampedArray(foregroundData.length);
  const pixelMidValue = 127.5;
  
  for (let i = 0; i < foregroundData.length; i += 4) {
    const fR = foregroundData[i];
    const fG = foregroundData[i + 1];
    const fB = foregroundData[i + 2];
    const bR = backgroundData[i];
    const bG = backgroundData[i + 1];
    const bB = backgroundData[i + 2];
    
    const bBrightness = pixelBrightness(bR, bG, bB);
    
    if (bBrightness <= pixelMidValue) {
      // Multiply mode
      result[i]     = clipPixelChannel(255 * (((2 * bR) / 255) * fR) / 255);
      result[i + 1] = clipPixelChannel(255 * (((2 * bG) / 255) * fG) / 255);
      result[i + 2] = clipPixelChannel(255 * (((2 * bB) / 255) * fB) / 255);
            } else {
      // Screen mode
      result[i]     = clipPixelChannel(255 - 255 * (((2 * (255 - fR)) / 255) * (255 - bR)) / 255);
      result[i + 1] = clipPixelChannel(255 - 255 * (((2 * (255 - fG)) / 255) * (255 - bG)) / 255);
      result[i + 2] = clipPixelChannel(255 - 255 * (((2 * (255 - fB)) / 255) * (255 - bB)) / 255);
    }
    result[i + 3] = foregroundData[i + 3]; // Preserve alpha
  }
  
  return result;
}

// Old OpenCV-based detail filter (no longer used - kept for reference)
// Replaced by applyDetailFilterADVANCED which doesn't require OpenCV
// function applyDetailFilterOLD(imageData) { ... }

// Available detail filter preset values
// 10 presets with strength (0-5) and radiusRatio (0-0.008)
const availableDetailValues = [
  { strength: 0.5, radiusRatio: 0.0008 },
  { strength: 1.0, radiusRatio: 0.0016 },
  { strength: 1.5, radiusRatio: 0.0024 },
  { strength: 2.0, radiusRatio: 0.0032 },
  { strength: 2.5, radiusRatio: 0.004 },
  { strength: 3.0, radiusRatio: 0.0048 },
  { strength: 3.5, radiusRatio: 0.0056 },
  { strength: 4.0, radiusRatio: 0.0064 },
  { strength: 4.5, radiusRatio: 0.0072 },
  { strength: 5.0, radiusRatio: 0.008 }
];

/** YCbCr skin ratio on the brick grid (same rules as color-correction.js). */
function measureSkinRatioFromBitmap(bitmap) {
	const { data } = bitmap;
	let skinCount = 0;
	let total = 0;

	for (let i = 0; i < data.length; i += 4) {
		const r = data[i];
		const g = data[i + 1];
		const b = data[i + 2];
		const a = data[i + 3];
		if (a === 0) continue;
		total++;
		const y = 0.299 * r + 0.587 * g + 0.114 * b;
		const cb = 128 - 0.168736 * r - 0.331264 * g + 0.5 * b;
		const cr = 128 + 0.5 * r - 0.418688 * g - 0.081312 * b;
		if (y > 40 && cb >= 77 && cb <= 127 && cr >= 133 && cr <= 173) {
			skinCount++;
		}
	}

	return total > 0 ? skinCount / total : 0;
}

function extractLumaBitmap(imgBitmap) {
	const { data, width, height } = imgBitmap;
	const lumaData = new Uint8Array(data.length);

	for (let i = 0; i < data.length; i += 4) {
		const y = clipPixelChannel(
			0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2],
		);
		lumaData[i] = y;
		lumaData[i + 1] = y;
		lumaData[i + 2] = y;
		lumaData[i + 3] = 255;
	}

	return { width, height, data: lumaData };
}

/** Unsharp on luma only; scale RGB to keep hue (less magenta/blue fringing before brickify). */
function sharpenLuminanceOnly(originalBitmap, blurredLumaBitmap, strength) {
	const { width, height, data: originalData } = originalBitmap;
	const { width: blurredWidth, height: blurredHeight, data: blurredData } =
		blurredLumaBitmap;

	if (width !== blurredWidth || height !== blurredHeight) {
		throw new Error("Original and blurred image dimensions don't match");
	}

	const sharpenedData = new Uint8ClampedArray(originalData.length);

	for (let i = 0; i < originalData.length; i += 4) {
		const r = originalData[i];
		const g = originalData[i + 1];
		const b = originalData[i + 2];
		const origY = pixelBrightness(r, g, b);
		const blurY = pixelBrightness(
			blurredData[i],
			blurredData[i + 1],
			blurredData[i + 2],
		);
		let newY = origY + (origY - blurY) * strength;
		newY = Math.max(0, Math.min(255, newY));

		if (origY < 0.5) {
			const y8 = clipPixelChannel(newY);
			sharpenedData[i] = y8;
			sharpenedData[i + 1] = y8;
			sharpenedData[i + 2] = y8;
		} else {
			const scale = newY / origY;
			sharpenedData[i] = clipPixelChannel(r * scale);
			sharpenedData[i + 1] = clipPixelChannel(g * scale);
			sharpenedData[i + 2] = clipPixelChannel(b * scale);
		}
		sharpenedData[i + 3] = 255;
	}

	return {
		width,
		height,
		data: new Uint8Array(sharpenedData.buffer),
	};
}

function applyDetailFilterADVANCED(imgBitmap) {
	const shortSide = Math.min(imgBitmap.width, imgBitmap.height);
	const skinRatio = measureSkinRatioFromBitmap(imgBitmap);
	const presetIndex = skinRatio > 0.18 ? 0 : 1;
	const { strength, radiusRatio } = availableDetailValues[presetIndex];
	const pixelRadius = Math.max(1, Math.floor(shortSide * radiusRatio));

	const lumaBitmap = extractLumaBitmap(imgBitmap);
	const blurredLuma = gaussianBlur(lumaBitmap, pixelRadius);
	return sharpenLuminanceOnly(imgBitmap, blurredLuma, strength);
}

function createGaussianKernel(radius) {
	const sigma = Math.max(0.1, radius);
	const kernelSize = 2 * Math.ceil(sigma * 2.57) + 1;
	const kernel = new Float32Array(kernelSize);
	const halfSize = Math.floor(kernelSize / 2);
	let sum = 0;

	for (let i = 0; i < kernelSize; i++) {
		const x = i - halfSize;
		const value = Math.exp(-(x * x) / (2 * sigma * sigma));
		kernel[i] = value;
		sum += value;
	}

	for (let i = 0; i < kernelSize; i++) {
		kernel[i] /= sum;
	}
	return kernel;
}

function gaussianBlur(bitmap, radius) {
	const { data, width, height } = bitmap;
	const tempPixels = new Float32Array(data.length);
	const outputPixels = new Uint8Array(data.length);

	const kernel = createGaussianKernel(radius);
	const kernelSize = kernel.length;
	const halfKernelSize = Math.floor(kernelSize / 2);

	// Horizontal pass
	for (let y = 0; y < height; y++) {
		for (let x = 0; x < width; x++) {
			let r = 0,
				g = 0,
				b = 0;
			for (let i = 0; i < kernelSize; i++) {
				const weight = kernel[i];
				const pixelX = Math.min(width - 1, Math.max(0, x - halfKernelSize + i));
				const srcIndex = (y * width + pixelX) * 4;
				r += data[srcIndex] * weight;
				g += data[srcIndex + 1] * weight;
				b += data[srcIndex + 2] * weight;
			}
			const destIndex = (y * width + x) * 4;
			tempPixels[destIndex] = r;
			tempPixels[destIndex + 1] = g;
			tempPixels[destIndex + 2] = b;
			tempPixels[destIndex + 3] = 0xff;
		}
	}

	// Vertical pass
	for (let y = 0; y < height; y++) {
		for (let x = 0; x < width; x++) {
			let r = 0;
			let g = 0;
			let b = 0;
			for (let i = 0; i < kernelSize; i++) {
				const weight = kernel[i];
				const pixelY = Math.min(
					height - 1,
					Math.max(0, y - halfKernelSize + i),
				);
				const srcIndex = (pixelY * width + x) * 4;
				r += tempPixels[srcIndex] * weight;
				g += tempPixels[srcIndex + 1] * weight;
				b += tempPixels[srcIndex + 2] * weight;
			}
			const destIndex = (y * width + x) * 4;
			outputPixels[destIndex] = r;
			outputPixels[destIndex + 1] = g;
			outputPixels[destIndex + 2] = b;
			outputPixels[destIndex + 3] = 0xff;
		}
	}

	return {
		data: outputPixels,
		width,
		height,
	};
}

function sharpen(originalBitmap, blurredBitmap, strength) {
	const { width, height, data: originalData } = originalBitmap;
	const { width: blurredWidth, height: blurredHeight, data: blurredData } = blurredBitmap;
	
	if (width !== blurredWidth || height !== blurredHeight) {
		throw new Error("Original and blurred image dimensions don't match");
	}

	const sharpenedData = new Uint8ClampedArray(originalData.length);
	const bitmapChannels = 4;

	for (let i = 0; i < originalData.length; i += bitmapChannels) {
		const maskR = originalData[i] - blurredData[i];
		const maskG = originalData[i + 1] - blurredData[i + 1];
		const maskB = originalData[i + 2] - blurredData[i + 2];

		sharpenedData[i] = originalData[i] + maskR * strength;
		sharpenedData[i + 1] = originalData[i + 1] + maskG * strength;
		sharpenedData[i + 2] = originalData[i + 2] + maskB * strength;
		sharpenedData[i + 3] = 0xff;
	}
	return {
		width,
		height,
		data: new Uint8Array(sharpenedData.buffer),
	};
}

// ===== color-correction.js =====
// ========== Color Correction Functions ==========

// HSP color space coefficients (for perceived brightness)

// Helper function to bound and normalize values (matching reference)
function bound01(n, max) {
  n = Math.min(max, Math.max(0, n));
  // Handle floating point rounding errors
  if (Math.abs(n - max) < 0.000001) {
    return 1;
  }
  // Convert into [0, 1] range if it isn't already
  return (n % max) / max;
}

// RGB to HSL conversion - matching reference exactly
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = (max + min) / 2;
  let s = (max + min) / 2;
  const l = (max + min) / 2;
  
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  
  return { h: h * 360, s, l };
}

// HSL to RGB conversion - matching reference exactly
function hslToRgb(h, s, l) {
  h = bound01(h, 360);
  s = bound01(s, 1);
  l = bound01(l, 1);
  
  let r, g, b;
  
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
}

function rgbToHsp(r, g, b) {
  let h = 0;
  let s = 0;
  
  const p = Math.sqrt(
    r * r * pRedCoefficient +
    g * g * pGreenCoefficient +
    b * b * pBlueCoefficient
  );
  
  if (r !== g || r !== b) {
    if (r >= g && r >= b) {
      if (b >= g) {
        h = 6.0 / 6.0 - ((1.0 / 6.0) * (b - g)) / (r - g);
        s = 1.0 - g / r;
            } else {
        h = 0.0 / 6.0 + ((1.0 / 6.0) * (g - b)) / (r - b);
        s = 1.0 - b / r;
      }
    }
    
    if (g >= r && g >= b) {
      if (r >= b) {
        h = 2.0 / 6.0 - ((1.0 / 6.0) * (r - b)) / (g - b);
        s = 1 - b / g;
      } else {
        h = 2.0 / 6.0 + ((1.0 / 6.0) * (b - r)) / (g - r);
        s = 1.0 - r / g;
      }
    }
    
    if (b >= r && b >= g) {
      if (g >= r) {
        h = 4.0 / 6.0 - ((1.0 / 6.0) * (g - r)) / (b - r);
        s = 1.0 - r / b;
      } else {
        h = 4.0 / 6.0 + ((1.0 / 6.0) * (r - g)) / (b - g);
        s = 1.0 - g / b;
      }
    }
  }
  
  return {
    h: Math.round(h * 360.0),
    s: s * 100.0,
    p: Math.round(p)
  };
}

function hspToRgb(h0, s0, p0) {
  let h = h0 / 360.0;
  const s = s0 / 100.0;
  const p = p0;
  let r, g, b, part;
  const minOverMax = 1.0 - s;
  
  if (minOverMax > 0.0) {
    if (h < 1.0 / 6.0) {
      h = 6.0 * (h - 0.0 / 6.0);
      part = 1.0 + h * (1.0 / minOverMax - 1.0);
      b = p / Math.sqrt(pRedCoefficient / minOverMax / minOverMax + pGreenCoefficient * part * part + pBlueCoefficient);
      r = b / minOverMax;
      g = b + h * (r - b);
    } else if (h < 2.0 / 6.0) {
      h = 6.0 * (-h + 2.0 / 6.0);
      part = 1.0 + h * (1.0 / minOverMax - 1.0);
      b = p / Math.sqrt(pGreenCoefficient / minOverMax / minOverMax + pRedCoefficient * part * part + pBlueCoefficient);
      g = b / minOverMax;
      r = b + h * (g - b);
    } else if (h < 3.0 / 6.0) {
      h = 6.0 * (h - 2.0 / 6.0);
      part = 1.0 + h * (1.0 / minOverMax - 1.0);
      r = p / Math.sqrt(pGreenCoefficient / minOverMax / minOverMax + pBlueCoefficient * part * part + pRedCoefficient);
      g = r / minOverMax;
      b = r + h * (g - r);
    } else if (h < 4.0 / 6.0) {
      h = 6.0 * (-h + 4.0 / 6.0);
      part = 1.0 + h * (1.0 / minOverMax - 1.0);
      r = p / Math.sqrt(pBlueCoefficient / minOverMax / minOverMax + pGreenCoefficient * part * part + pRedCoefficient);
      b = r / minOverMax;
      g = r + h * (b - r);
    } else if (h < 5.0 / 6.0) {
      h = 6.0 * (h - 4.0 / 6.0);
      part = 1.0 + h * (1.0 / minOverMax - 1.0);
      g = p / Math.sqrt(pBlueCoefficient / minOverMax / minOverMax + pRedCoefficient * part * part + pGreenCoefficient);
      b = g / minOverMax;
      r = g + h * (b - g);
    } else {
      h = 6.0 * (-h + 6.0 / 6.0);
      part = 1.0 + h * (1.0 / minOverMax - 1.0);
      g = p / Math.sqrt(pRedCoefficient / minOverMax / minOverMax + pBlueCoefficient * part * part + pGreenCoefficient);
      r = g / minOverMax;
      b = g + h * (r - g);
    }
  } else {
    if (h < 1.0 / 6.0) {
      h = 6.0 * (h - 0.0 / 6.0);
      r = Math.sqrt((p * p) / (pRedCoefficient + pGreenCoefficient * h * h));
      g = r * h;
      b = 0.0;
    } else if (h < 2.0 / 6.0) {
      h = 6.0 * (-h + 2.0 / 6.0);
      g = Math.sqrt((p * p) / (pGreenCoefficient + pRedCoefficient * h * h));
      r = g * h;
      b = 0.0;
    } else if (h < 3.0 / 6.0) {
      h = 6.0 * (h - 2.0 / 6.0);
      g = Math.sqrt((p * p) / (pGreenCoefficient + pBlueCoefficient * h * h));
      b = g * h;
      r = 0.0;
    } else if (h < 4.0 / 6.0) {
      h = 6.0 * (-h + 4.0 / 6.0);
      b = Math.sqrt((p * p) / (pBlueCoefficient + pGreenCoefficient * h * h));
      g = b * h;
      r = 0.0;
    } else if (h < 5.0 / 6.0) {
      h = 6.0 * (h - 4.0 / 6.0);
      b = Math.sqrt((p * p) / (pBlueCoefficient + pRedCoefficient * h * h));
      r = b * h;
      g = 0.0;
    } else {
      h = 6.0 * (-h + 6.0 / 6.0);
      r = Math.sqrt((p * p) / (pRedCoefficient + pBlueCoefficient * h * h));
      b = r * h;
      g = 0.0;
    }
  }
  
  return {
    r: Math.min(255, Math.round(r)),
    g: Math.min(255, Math.round(g)),
    b: Math.min(255, Math.round(b))
  };
}

// Color correction function - matches reference implementation
function applyColorCorrectionsOLD(img, contrast = 0.15, saturation = 0.05, brightness = 0) {
  if (contrast === 0 && saturation === 0 && brightness === 0) {
    return img;
  }

  const newData = new Uint8ClampedArray(img.data);
  const numPixels = img.width * img.height;
  
  // Adjust contrast factor (matching the reference code logic exactly)
  const adjustedContrast = contrast > 0 ? contrast * 0.2 : contrast * 0.15;
  // This is a bit fudged to try and match photoshop's range
  const brightnessPositive = 0xff / 2.8;
  const brightnessNegative = 0xff / 9;
  const brightnessOffset = brightness * (brightness > 0 ? brightnessPositive : brightnessNegative);
  
  for (let i = 0; i < numPixels * 4; i += 4) {
    let r = newData[i];
    let g = newData[i + 1];
    let b = newData[i + 2];
    
    // Apply contrast first (as per reference implementation)
    if (contrast !== 0) {
      const factor = (adjustedContrast + 1) / (1 - adjustedContrast);
      r = Math.floor(factor * (r - 127) + 127);
      r = r < 0 ? 0 : r > 0xff ? 0xff : r;
      g = Math.floor(factor * (g - 127) + 127);
      g = g < 0 ? 0 : g > 0xff ? 0xff : g;
      b = Math.floor(factor * (b - 127) + 127);
      b = b < 0 ? 0 : b > 0xff ? 0xff : b;
    }
    
    // Apply brightness (using HSP color space)
    if (brightness !== 0) {
      // convert to HSP, increase P (perceived brightness), then back to rgb
      const hsp = rgbToHsp(r, g, b);
      const newRgb = hspToRgb(hsp.h, hsp.s, Math.max(0, Math.min(0xff, hsp.p + brightnessOffset)));
      r = newRgb.r;
      g = newRgb.g;
      b = newRgb.b;
    }
    
    // Apply saturation
    if (saturation !== 0) {
      if (saturation > 0) {
        const hsl = rgbToHsl(r, g, b);
        const result = hslToRgb(hsl.h, Math.min(1, hsl.s + saturation), hsl.l);
        r = result.r;
        g = result.g;
        b = result.b;
      } else if (saturation < 0) {
        const hsl = rgbToHsl(r, g, b);
        const result = hslToRgb(hsl.h, Math.max(0, hsl.s + saturation), hsl.l);
        r = result.r;
        g = result.g;
        b = result.b;
      }
    }
    
    newData[i] = r;
    newData[i + 1] = g;
    newData[i + 2] = b;
    // Alpha channel stays the same (newData[i + 3])
  }
  
  return new ImageData(newData, img.width, img.height);
}

// Color correction function - matches brick.me's colourCorrectionOperation
// Adapts to receive imageBitmap (like applyDetailFilterADVANCED) instead of BuildOperationInput
function applyColorCorrectionsADVANCED(imgBitmap, brightness = 0, contrast = 0, saturation = 0) {
	if (brightness === 0 && contrast === 0 && saturation === 0) {
		return imgBitmap;
	}

	const applyBrightness = brightness !== 0;
	const applyContrast = contrast !== 0;
	const applySaturation = saturation !== 0;

	// Clone the bitmap data (matching cloneBitmapToWritable behavior)
	const { data, width, height } = imgBitmap;
	const bitmapChannels = 4;
	const clonedData = new Uint8Array(data.length);
	clonedData.set(data);

	// This is a bit fudged to try and match photoshop's range
	const brightnessPositive = 0xff / 2.8;
	const brightnessNegative = 0xff / 9;
	const brightnessOffset = brightness * (brightness > 0 ? brightnessPositive : brightnessNegative);
	const adjustedContrast = contrast > 0 ? contrast * 0.2 : contrast * 0.15;

	const numPixelChannels = width * height * bitmapChannels;
	for (let i = 0; i < numPixelChannels; i += bitmapChannels) {
		let r = clonedData[i];
		let g = clonedData[i + 1];
		let b = clonedData[i + 2];

		// Found a comment somewhere saying you'd typically apply contrast first.
		// Not a super authoritative source, but the only source I've seen atm.
		if (applyContrast) {
			const factor = (adjustedContrast + 1) / (1 - adjustedContrast);
			r = Math.floor(factor * (r - 127) + 127);
			r = r < 0 ? 0 : r > 0xff ? 0xff : r;
			g = Math.floor(factor * (g - 127) + 127);
			g = g < 0 ? 0 : g > 0xff ? 0xff : g;
			b = Math.floor(factor * (b - 127) + 127);
			b = b < 0 ? 0 : b > 0xff ? 0xff : b;
		}

		if (applyBrightness) {
			// convert to HSP, increase P (perceived brightness), then back to rgb
			const hsp = rgbToHsp(r, g, b);
			const newRgb = hspToRgb(
				hsp.h,
				hsp.s,
				Math.max(0, Math.min(0xff, hsp.p + brightnessOffset)),
			);
			r = newRgb.r;
			g = newRgb.g;
			b = newRgb.b;
		}

		if (applySaturation) {
			if (saturation > 0) {
				const hsl = rgbToHsl(r, g, b);
				const result = hslToRgb(hsl.h, Math.min(1, hsl.s + saturation), hsl.l);
				r = result.r;
				g = result.g;
				b = result.b;
			} else if (saturation < 0) {
				const hsl = rgbToHsl(r, g, b);
				const result = hslToRgb(hsl.h, Math.max(0, hsl.s + saturation), hsl.l);
				r = result.r;
				g = result.g;
				b = result.b;
			}
		}

		clonedData[i] = r;
		clonedData[i + 1] = g;
		clonedData[i + 2] = b;
		// Alpha channel stays the same (clonedData[i + 3])
	}

	return {
		data: clonedData,
		width,
		height,
	};
}

// ========== Auto defaults (Bricks-Art style, adapted to our slider semantics) ==========

function clampNumber(x, min, max) {
  if (!Number.isFinite(x)) return min;
  return Math.max(min, Math.min(max, x));
}

function percentileFromHistogram(hist, totalCount, percentile01) {
  if (!Array.isArray(hist) || totalCount <= 0) return 0;
  const target = Math.floor(clampNumber(percentile01, 0, 1) * (totalCount - 1));
  let acc = 0;
  for (let i = 0; i < hist.length; i += 1) {
    acc += hist[i];
    if (acc > target) return i;
  }
  return hist.length - 1;
}

/**
 * Compute robust region stats for auto-correction.
 * - brightness proxy: robust mean luma (winsorized by p5/p95)
 * - contrast proxy: robust stddev luma (winsorized by p5/p95)
 * - saturation proxy: mean sat in 0..255
 * - skinRatio: simple YCbCr skin detector ratio (for safer portrait tuning)
 *
 * @param {HTMLImageElement} img
 * @param {{ left:number, top:number, width:number, height:number } | null} cropPx
 * @returns {{ brightnessMean:number, contrastStdDev:number, saturationMean:number, skinRatio:number }}
 */
function measureRegionStatsFromImage(img, cropPx) {
  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;
  if (!(w > 0 && h > 0)) {
    return { brightnessMean: 0, contrastStdDev: 0, saturationMean: 0, skinRatio: 0 };
  }

  let left = 0, top = 0, cw = w, ch = h;
  if (cropPx && Number.isFinite(cropPx.width) && Number.isFinite(cropPx.height) && cropPx.width > 0 && cropPx.height > 0) {
    left = clampNumber(cropPx.left, 0, w - 1);
    top = clampNumber(cropPx.top, 0, h - 1);
    cw = clampNumber(cropPx.width, 1, w - left);
    ch = clampNumber(cropPx.height, 1, h - top);
  }

  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.floor(cw));
  canvas.height = Math.max(1, Math.floor(ch));
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  if (!ctx) return { brightnessMean: 0, contrastStdDev: 0, saturationMean: 0, skinRatio: 0 };

  // Draw only the region we want to analyze.
  ctx.drawImage(img, -left, -top, w, h);
  const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

  const histY = new Array(256).fill(0);
  let total = 0;
  let sumSat = 0;
  let skinCount = 0;

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];

    const y = 0.299 * r + 0.587 * g + 0.114 * b;
    const yInt = clampNumber(Math.round(y), 0, 255);
    histY[yInt] += 1;
    total += 1;

    const mx = Math.max(r, g, b);
    const mn = Math.min(r, g, b);
    const sat = mx === 0 ? 0 : ((mx - mn) / mx) * 255;
    sumSat += sat;

    // Lightweight skin detector in YCbCr.
    const cb = 128 - 0.168736 * r - 0.331264 * g + 0.5 * b;
    const cr = 128 + 0.5 * r - 0.418688 * g - 0.081312 * b;
    if (y > 40 && cb >= 77 && cb <= 127 && cr >= 133 && cr <= 173) {
      skinCount += 1;
    }
  }

  const n = Math.max(1, total);
  const p05 = percentileFromHistogram(histY, n, 0.05);
  const p95 = percentileFromHistogram(histY, n, 0.95);

  let sumY = 0;
  let sumY2 = 0;
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const yRaw = 0.299 * r + 0.587 * g + 0.114 * b;
    const y = clampNumber(yRaw, p05, p95); // winsorize
    sumY += y;
    sumY2 += y * y;
  }

  const meanY = sumY / n;
  const varY = Math.max(0, sumY2 / n - meanY * meanY);
  const stdY = Math.sqrt(varY);
  const meanSat = sumSat / n;
  const skinRatio = skinCount / n;

  return { brightnessMean: meanY, contrastStdDev: stdY, saturationMean: meanSat, skinRatio };
}

/**
 * Suggest defaults for our sliders using Bricks-Art heuristics.
 *
 * Notes on mapping:
 * - Bricks-Art brightness is an RGB multiplier; ours is an additive perceived-brightness control.
 * - Bricks-Art contrast is a multiplier around 1; ours is a signed contrast strength.
 * - Bricks-Art saturation is a multiplier; ours is additive to HSL saturation.
 *
 * @param {HTMLImageElement} img
 * @param {{ left:number, top:number, width:number, height:number } | null} cropPx
 * @returns {{ brightness:number, contrast:number, saturation:number, isGreyscale:boolean }}
 */
function suggestColorCorrectionDefaults(img, cropPx) {
  const stats = measureRegionStatsFromImage(img, cropPx);
  const neutralBrightness = 0;
  const neutralContrast = 0.15;
  const neutralSaturation = 0.05;

  // Conservative targets for a safer default look.
  const targetBrightness = 110;
  const targetContrastStd = 62;
  const targetSaturation = 100;

  // If already close enough, keep neutral (mirrors their ±5 guard)
  const closeEnough = (measured, target) => Math.abs(measured - target) <= 5;

  // ---- Brightness (our additive control) ----
  // In applyColorCorrectionsADVANCED:
  // brightnessOffset = brightness * (brightness > 0 ? 0xff/2.8 : 0xff/9)
  const brightnessPositive = 0xff / 2.8;
  const brightnessNegative = 0xff / 9;
  let brightness = neutralBrightness;
  if (!closeEnough(stats.brightnessMean, targetBrightness) && Number.isFinite(stats.brightnessMean) && stats.brightnessMean > 0) {
    const delta = targetBrightness - stats.brightnessMean; // desired additive delta in luma space
    brightness = delta >= 0 ? delta / brightnessPositive : delta / brightnessNegative;
  }
  brightness = clampNumber(brightness, -1, 1);

  // ---- Contrast (map their multiplier to our contrast parameter) ----
  // Their multiplier m = clamp(target / measured, 0.7, 1.3).
  // Our apply uses: adjustedContrast = contrast>0 ? contrast*0.2 : contrast*0.15
  // factor = (ac + 1) / (1 - ac). Solve ac from factor ~= m => ac = (m - 1) / (m + 1)
  let contrast = neutralContrast;
  if (!closeEnough(stats.contrastStdDev, targetContrastStd) && Number.isFinite(stats.contrastStdDev) && stats.contrastStdDev > 0) {
    const m = clampNumber(targetContrastStd / stats.contrastStdDev, 0.78, 1.22);
    const ac = (m - 1) / (m + 1);
    contrast = ac >= 0 ? ac / 0.2 : ac / 0.15;
  }
  contrast = clampNumber(contrast, -1, 1);

  // ---- Saturation (map their multiplier to our additive HSL saturation) ----
  let saturation = neutralSaturation;
  const isGreyscale = stats.saturationMean < 10;
  if (!closeEnough(stats.saturationMean, targetSaturation) && Number.isFinite(stats.saturationMean) && stats.saturationMean > 0) {
    const m = clampNumber(targetSaturation / stats.saturationMean, 0.8, 1.2);
    const s0 = clampNumber(stats.saturationMean / 255, 0, 1);
    const s1 = clampNumber(s0 * m, 0, 1);
    saturation = neutralSaturation + (s1 - s0); // additive delta around our neutral baseline
  }
  saturation = clampNumber(saturation, -1, 1);

  // Tighter saturation range around neutral to avoid "overcooked" results.
  const satDelta = clampNumber(saturation - neutralSaturation, -0.08, 0.12);
  saturation = clampNumber(neutralSaturation + satDelta, -1, 1);

  // Portrait / skin guard: reduce contrast and saturation pushes if much skin is visible.
  if (stats.skinRatio > 0.18) {
    contrast = neutralContrast + (contrast - neutralContrast) * 0.7;
    saturation = neutralSaturation + (saturation - neutralSaturation) * 0.55;
  }

  // Confidence-weighted blend toward neutral. Keeps auto subtle unless evidence is strong.
  const brightnessDelta = Math.abs(targetBrightness - stats.brightnessMean) / 60;
  const contrastDelta = Math.abs(targetContrastStd - stats.contrastStdDev) / 40;
  const saturationDelta = Math.abs(targetSaturation - stats.saturationMean) / 80;
  const confidence = clampNumber((brightnessDelta + contrastDelta + saturationDelta) / 3, 0, 1);
  const strength = 0.35 + 0.2 * confidence; // 0.35 .. 0.55
  brightness = neutralBrightness + (brightness - neutralBrightness) * strength;
  contrast = neutralContrast + (contrast - neutralContrast) * strength;
  saturation = neutralSaturation + (saturation - neutralSaturation) * strength;

  // Extra safety caps around neutral.
  // Keep brightening notably lower than darkening so we avoid washing details into white bricks.
  brightness = neutralBrightness + clampNumber(brightness - neutralBrightness, -0.35, 0.35);
  contrast = neutralContrast + clampNumber(contrast - neutralContrast, -0.22, 0.28);
  saturation = neutralSaturation + clampNumber(saturation - neutralSaturation, -0.08, 0.12);

  return { brightness, contrast, saturation, isGreyscale };
}



// ===== rendering.js =====
function formatEuroNoRounding(value) {
  if (typeof value !== "number" || Number.isNaN(value)) return "";
  const normalized = value.toLocaleString("nl-NL", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  });
  return `€\u00A0${normalized}`;
}

function formatEuroForFooter(value) {
  const normalized = value.toLocaleString("nl-NL", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  });
  return `€${normalized}`;
}

function renderFooterTotalPrice(totalPrice, oldTotalPrice = null) {
  const totalPriceElement = document.querySelector('.preview-footer-total-price');
  if (!totalPriceElement) return;
  const hasDiscount = oldTotalPrice !== null && oldTotalPrice > totalPrice;
  if (hasDiscount) {
    totalPriceElement.innerHTML =
      `<span class="preview-footer-price-old">${formatEuroForFooter(oldTotalPrice)}</span>` +
      `<span class="preview-footer-price-current is-discount">${formatEuroForFooter(totalPrice)}</span>`;
    return;
  }
  totalPriceElement.innerHTML =
    `<span class="preview-footer-price-current">${formatEuroForFooter(totalPrice)}</span>`;
}

function createFormatPreviewCanvas(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);
  const ratio = baseW / baseH;
  const previewPixelsPerBaseplate = 14;
  const canvasPreview = document.createElement("canvas");
  canvasPreview.width = Math.max(1, baseW * previewPixelsPerBaseplate);
  canvasPreview.height = Math.max(1, baseH * previewPixelsPerBaseplate);

  canvasPreview.className = "format-option-preview";
  const previewCtx = canvasPreview.getContext("2d");
  if (!previewCtx) return canvasPreview;

  // Center-crop original uploaded image to the selected format ratio.
  if (uploadedImage && uploadedImage.width > 0 && uploadedImage.height > 0) {
    const sourceAspect = uploadedImage.width / uploadedImage.height;
    let sx = 0;
    let sy = 0;
    let sw = uploadedImage.width;
    let sh = uploadedImage.height;

    if (sourceAspect > ratio) {
      sw = Math.round(sh * ratio);
      sx = Math.round((uploadedImage.width - sw) / 2);
    } else if (sourceAspect < ratio) {
      sh = Math.round(sw / ratio);
      sy = Math.round((uploadedImage.height - sh) / 2);
    }

    previewCtx.drawImage(
      uploadedImage,
      sx,
      sy,
      sw,
      sh,
      0,
      0,
      canvasPreview.width,
      canvasPreview.height,
    );
  } else {
    previewCtx.fillStyle = "#f2f2f2";
    previewCtx.fillRect(0, 0, canvasPreview.width, canvasPreview.height);
  }

  return canvasPreview;
}

function updateSizeOptions() {
  sizesSelect.innerHTML = "";
  const scrollSelectedSizeIntoView = (behavior = "auto") => {
    const activeButton = sizesSelect.querySelector(".simple-creator-button-active");
    if (!activeButton) return;
    activeButton.scrollIntoView({
      block: "nearest",
      inline: "center",
      behavior,
    });
  };
  const selectableSizes = [...getEditorSizeOptions()].sort((a, b) => {
    const priceA = sizeToPriceNumber(a);
    const priceB = sizeToPriceNumber(b);
    const rankA = priceA === null ? Number.POSITIVE_INFINITY : priceA;
    const rankB = priceB === null ? Number.POSITIVE_INFINITY : priceB;
    if (rankA !== rankB) return rankA - rankB;
    const { baseW: aW, baseH: aH } = parseSize(a);
    const { baseW: bW, baseH: bH } = parseSize(b);
    const areaA = aW * aH;
    const areaB = bW * bH;
    if (areaA !== areaB) return areaA - areaB;
    return a.localeCompare(b);
  });

  selectableSizes.forEach((size, index) => {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "simple-creator-button no-theme-style format-option-card";
    button.setAttribute("data-track", `editor--size-${size}`);
    // Check if this size matches the selected size, or default to index 1 (3x3) if no match
    if (size === selectedSize || (index === 0 && !selectableSizes.includes(selectedSize))) {
      button.classList.add("simple-creator-button-active");
      if (size === selectedSize || index === 0) {
        selectedSize = size;
      }
    }

    if (size === "4x3") {
      button.classList.add("format-option-card--has-ribbon");
      const badge = document.createElement("span");
      badge.className = "format-option-ribbon";
      badge.textContent = "Meest populair";
      button.appendChild(badge);
    }

    const previewWrap = document.createElement("div");
    previewWrap.className = "format-option-preview-wrap";
    previewWrap.appendChild(createFormatPreviewCanvas(size));

    const meta = document.createElement("div");
    meta.className = "format-option-meta";

    const label = document.createElement("div");
    label.className = "simple-creator-button-label format-option-size-label";
    const { baseW, baseH } = parseSize(size);
    label.textContent = `${roundToOneDecimal(19.2 * baseW)} x ${roundToOneDecimal(19.2 * baseH)} cm`;

    const prices = document.createElement("div");
    prices.className = "format-option-prices";
    const oldPrice = sizeToOldPriceNumber(size);
    const newPrice = sizeToPriceNumber(size);
    const hasDiscount = oldPrice !== null && newPrice !== null && oldPrice > newPrice;
    if (hasDiscount) {
      const oldPriceEl = document.createElement("div");
      oldPriceEl.className = "format-option-price-old";
      const oldPriceText = document.createElement("span");
      oldPriceText.textContent = formatEuroNoRounding(oldPrice);
      oldPriceEl.appendChild(oldPriceText);
      prices.appendChild(oldPriceEl);
    }
    const newPriceEl = document.createElement("div");
    newPriceEl.className = "format-option-price-current";
    if (hasDiscount) {
      newPriceEl.classList.add("is-discount");
    }
    const newPriceText = document.createElement("span");
    newPriceText.textContent = newPrice !== null ? formatEuroNoRounding(newPrice) : "";
    newPriceEl.appendChild(newPriceText);
    prices.appendChild(newPriceEl);
    meta.appendChild(label);
    meta.appendChild(prices);

    // Combine
    button.appendChild(previewWrap);
    button.appendChild(meta);

    // Click handler
    button.addEventListener("click", () => {
      selectedSize = size;

      applySuggestCropFramingForSizeIfAvailable(size);

      // Toggle active class
      document.querySelectorAll("#sizesSelect .simple-creator-button").forEach(btn => {
        btn.classList.remove("simple-creator-button-active");
      });
      button.classList.add("simple-creator-button-active");
      scrollSelectedSizeIntoView("smooth");

      render();

      // Only update prices if Shopify prices are loaded
      const basePrice = sizeToPriceNumber(selectedSize);
      if (basePrice !== null) {
        mozaikPrices.forEach(item => {
          if (!item.classList.contains('preview-footer-total-price')) {
            item.innerText = sizeToPrice(selectedSize);
          }
        });
      }
      if (mozaikSizeShort) mozaikSizeShort.innerText = sizeToDimensionsCM(selectedSize);
      if (mozaikSizeLong) mozaikSizeLong.innerText = sizeToDimensionsCMLong(selectedSize);
      if (mozaikBaseplates) mozaikBaseplates.innerText = sizeToBaseplates(selectedSize);
      if (mozaikBricks) mozaikBricks.innerText = sizeToBricksCount(selectedSize);
      if (previewFormatSize) previewFormatSize.innerText = sizeToPreviewFormat(selectedSize);
      // Initialize hanging option (default to none - nothing selected)
      if (previewHangingOption) previewHangingOption.innerText = 'Geen ophangmiddel';
      if (previewHangingPrice) previewHangingPrice.innerText = '€0,00';
      // Hide hanging item by default
      if (previewHangingItem) previewHangingItem.style.display = 'none';
      updatePreviewTotal();
      updateDeliveryContent(selectedSize);
      // Update strips price in modal if it exists
      if (typeof updateStripsCount === 'function') {
        updateStripsCount();
      }
    });

    sizesSelect.appendChild(button);
  });

  // Only update prices if Shopify prices are loaded
  const basePrice = sizeToPriceNumber(selectedSize);
  if (basePrice !== null) {
    mozaikPrices.forEach(item => {
      if (!item.classList.contains('preview-footer-total-price')) {
        item.innerText = sizeToPrice(selectedSize);
      }
    });
  }
  if (mozaikSizeShort) mozaikSizeShort.innerText = sizeToDimensionsCM(selectedSize);
  if (mozaikSizeLong) mozaikSizeLong.innerText = sizeToDimensionsCMLong(selectedSize);
  if (mozaikBaseplates) mozaikBaseplates.innerText = sizeToBaseplates(selectedSize);
  if (mozaikBricks) mozaikBricks.innerText = sizeToBricksCount(selectedSize);
  if (previewFormatSize) previewFormatSize.innerText = sizeToPreviewFormat(selectedSize);
  // Initialize hanging option (default to none - nothing selected)
  if (previewHangingOption) previewHangingOption.innerText = 'Geen ophangmiddel';
  if (previewHangingPrice) previewHangingPrice.innerText = '€0,00';
  // Hide hanging item by default
  if (previewHangingItem) previewHangingItem.style.display = 'none';
  updatePreviewTotal();
  updateDeliveryContent(selectedSize);
  // Update strips price in modal if it exists
  if (typeof updateStripsCount === 'function') {
    updateStripsCount();
  }
  // Keep the auto-selected format visible without requiring manual scroll.
  requestAnimationFrame(() => scrollSelectedSizeIntoView("auto"));
}

function getCalibratedBrickPixelSize() {
  const refW =
    typeof MOSAIC_BRICK_PX_REFERENCE_INNER_WIDTH === "number" &&
    MOSAIC_BRICK_PX_REFERENCE_INNER_WIDTH > 0
      ? MOSAIC_BRICK_PX_REFERENCE_INNER_WIDTH
      : 414;
  const refPx =
    typeof MOSAIC_BRICK_PX_REFERENCE === "number" && MOSAIC_BRICK_PX_REFERENCE > 0
      ? MOSAIC_BRICK_PX_REFERENCE
      : 2;
  const minPx =
    typeof MOSAIC_BRICK_PX_MIN === "number" && MOSAIC_BRICK_PX_MIN > 0
      ? MOSAIC_BRICK_PX_MIN
      : 1;
  const maxPx =
    typeof MOSAIC_BRICK_PX_MAX === "number" && MOSAIC_BRICK_PX_MAX >= minPx
      ? MOSAIC_BRICK_PX_MAX
      : 3;
  const scale =
    typeof MOSAIC_BRICK_PX_SCALE === "number" && MOSAIC_BRICK_PX_SCALE > 0
      ? MOSAIC_BRICK_PX_SCALE
      : 1;
  const innerW =
    typeof window !== "undefined" && window.innerWidth > 0
      ? window.innerWidth
      : refW;
  const scaled = refPx * scale * (innerW / refW);
  return Math.max(minPx, Math.min(maxPx, Math.round(scaled)));
}

function temporaryAdjustCanvasSize(sizeStr) {
  const { baseW, baseH } = parseSize(sizeStr);
  const pixelSize = getCalibratedBrickPixelSize();
  const bricksPerBaseplate = 24;
  canvas.width = baseW * bricksPerBaseplate * pixelSize;
  canvas.height = baseH * bricksPerBaseplate * pixelSize;
}

function getRenderMeasurements(
  canvasWidth,
  canvasHeight,
  numberOfBricksX,
  numberOfBricksY,
) {
  const brickSizePixels = Math.min(
    canvasWidth / numberOfBricksX,
    canvasHeight / numberOfBricksY,
  );
  const ceilBrickSizePixels = Math.ceil(brickSizePixels);
  return {
    ceilBrickSizePixels,
    brickSizePixels,
  };
}

// From https://github.com/antimatter15/rgb-lab
function rgbToLab(r16, g16, b16) {
  let r = r16 / 0xff;
  let g = g16 / 0xff;
  let b = b16 / 0xff;

  r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
  g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
  b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;

  let x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
  let y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1;
  let z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;

  x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;

  return {
    l: Math.round(116 * y - 16),
    a: Math.round(500 * (x - y)),
    b: Math.round(200 * (y - z)),
  };
}

function labToRgb({ l, a, b }) {
  let y = (l + 16) / 116;
  let x = a / 500 + y;
  let z = y - b / 200;

  x = 0.95047 * (x * x * x > 0.008856 ? x * x * x : (x - 16 / 116) / 7.787);
  y = 1.0 * (y * y * y > 0.008856 ? y * y * y : (y - 16 / 116) / 7.787);
  z = 1.08883 * (z * z * z > 0.008856 ? z * z * z : (z - 16 / 116) / 7.787);

  let red = x * 3.2406 + y * -1.5372 + z * -0.4986;
  let green = x * -0.9689 + y * 1.8758 + z * 0.0415;
  let blue = x * 0.0557 + y * -0.204 + z * 1.057;

  red = red > 0.0031308 ? 1.055 * Math.pow(red, 1 / 2.4) - 0.055 : 12.92 * red;
  green =
    green > 0.0031308
      ? 1.055 * Math.pow(green, 1 / 2.4) - 0.055
      : 12.92 * green;
  blue =
    blue > 0.0031308 ? 1.055 * Math.pow(blue, 1 / 2.4) - 0.055 : 12.92 * blue;

  return {
    r: Math.round(Math.max(0, Math.min(1, red)) * 255),
    g: Math.round(Math.max(0, Math.min(1, green)) * 255),
    b: Math.round(Math.max(0, Math.min(1, blue)) * 255),
  };
}

// Offsets were created for hsp which is in the range 255, but lab in range 100
const offsetModifier = 100 / 255;
function modifyRgbL({ l, a, b }, offset) {
  const notchRidgeLab = {
    a,
    b,
    l: Math.min(100, Math.max(0, l + offset * offsetModifier)),
  };
  const rgb = labToRgb(notchRidgeLab);
  return `#${rgb.r.toString(16).padStart(2, "0")}${rgb.g.toString(16).padStart(2, "0")}${rgb.b.toString(16).padStart(2, "0")}`;
}

const realWorldBrickSize = distanceFromMillimeters(8);
const notchRadius = distanceFromMillimeters(4.8);
const notchRidgeWidth = distanceFromMillimeters(0.23);
const borderRatio = 0.037;
const notchShadowSizeRatio = 0.8;
const notchShadowPositionRatio = { x: 0.455, y: 0.55 };

function draw45DegreesLinearGradientCircle(
  cvsCtx,
  x,
  y,
  radius,
  startColour,
  midColour,
  endColour,
) {
  const gradientOffset = radius * Math.cos(Math.PI / 4);
  const start = {
    x: x - gradientOffset,
    y: y + gradientOffset,
  };
  const end = {
    x: x + gradientOffset,
    y: y - gradientOffset,
  };
  const gradient = cvsCtx.createLinearGradient(start.x, start.y, end.x, end.y);
  gradient.addColorStop(0, startColour);
  gradient.addColorStop(0.85, midColour);
  gradient.addColorStop(1, endColour);
  cvsCtx.fillStyle = gradient;
  cvsCtx.beginPath();
  cvsCtx.arc(x, y, radius, 0, 2 * Math.PI, false);
  cvsCtx.fill();
}

const renderBrickCache = new Map();

function renderBrick(
  colourString,
  brickSize,
  allowDrawOutline,
  drawStudOverlay = true,
  drawSurfaceGloss = true,
) {
  const cacheKey = `${colourString}${brickSize}${allowDrawOutline}${drawStudOverlay}${drawSurfaceGloss}`;
  if (renderBrickCache.has(cacheKey)) {
    return renderBrickCache.get(cacheKey);
  }


  const baseNum = parseInt(colourString.slice(1), 16);
  const baseR = (baseNum >> 24) & 0xff;
  const baseG = (baseNum >> 16) & 0xff;
  const baseB = (baseNum >> 8) & 0xff;
  const baseLab = rgbToLab(baseR, baseG, baseB);

  const notchRidgeColour = modifyRgbL(baseLab, -9);
  const notchMidRgbColour = modifyRgbL(baseLab, 26);
  const notchEndRgbColour = modifyRgbL(baseLab, 82);
  const notchRidgeMidColour = modifyRgbL(baseLab, 55);
  const notchRidgeEndColour = modifyRgbL(baseLab, 105);

  const halfBrickSize = brickSize * 0.5;
  const halfNotchSize =
    (halfBrickSize * notchRadius.mm) / realWorldBrickSize.mm;
  const drawNotchRidgeWidth =
    (notchRidgeWidth.mm * brickSize) / realWorldBrickSize.mm;

  // Base/underneath notch
  // TODO: Draw outline off if drawing a baseplate
  ctxPrerender.fillStyle = colourString;
  ctxPrerender.fillRect(0, 0, brickSize, brickSize);

  if (drawSurfaceGloss) {
    const tileGlossGradient = ctxPrerender.createLinearGradient(0, 0, brickSize, brickSize);
    tileGlossGradient.addColorStop(0, "rgba(255, 255, 255, 0.14)");
    tileGlossGradient.addColorStop(0.45, "rgba(255, 255, 255, 0.05)");
    tileGlossGradient.addColorStop(1, "rgba(0, 0, 0, 0.12)");
    ctxPrerender.fillStyle = tileGlossGradient;
    ctxPrerender.fillRect(0, 0, brickSize, brickSize);
  }

  // Outline
  const borderWidth = brickSize * borderRatio;

  // Don't do this check. Having a small border is still valuable.
  // && borderWidth >= 1
  if (allowDrawOutline) {
    const darkGradientEnd = modifyRgbL(baseLab, -29);
    const lightGradientEnd = modifyRgbL(baseLab, 72);

    // Top
    const topGradient = ctxPrerender.createLinearGradient(0, borderWidth, 0, 0);
    topGradient.addColorStop(0, colourString);
    topGradient.addColorStop(1, lightGradientEnd);
    ctxPrerender.fillStyle = topGradient;
    ctxPrerender.fillRect(0, 0, brickSize, Math.min(1, borderWidth));
    // ctx.strokeStyle = topGradient;
    // ctx.lineWidth = borderWidth;
    // ctx.beginPath();
    // ctx.moveTo(0, borderWidth / 2);
    // ctx.lineTo(brickSize, borderWidth / 2);
    // ctx.stroke();

    // Bottom
    const bottomGradient = ctxPrerender.createLinearGradient(
      0,
      brickSize - borderWidth,
      0,
      brickSize,
    );
    bottomGradient.addColorStop(0, colourString);
    bottomGradient.addColorStop(1, darkGradientEnd);
    ctxPrerender.fillStyle = bottomGradient;
    ctxPrerender.fillRect(0, brickSize - borderWidth, brickSize, borderWidth);

    // Left
    const leftGradient = ctxPrerender.createLinearGradient(0, 0, borderWidth, 0);
    leftGradient.addColorStop(0, darkGradientEnd);
    leftGradient.addColorStop(1, colourString);
    ctxPrerender.fillStyle = leftGradient;
    ctxPrerender.beginPath();
    ctxPrerender.moveTo(0, 0);
    ctxPrerender.lineTo(borderWidth, borderWidth);
    ctxPrerender.lineTo(borderWidth, brickSize - borderWidth);
    ctxPrerender.lineTo(0, brickSize);
    ctxPrerender.lineTo(0, 0);
    ctxPrerender.fill();

    // Right
    const rightGradient = ctxPrerender.createLinearGradient(
      brickSize - borderWidth,
      0,
      brickSize,
      0,
    );
    rightGradient.addColorStop(0, colourString);
    rightGradient.addColorStop(1, lightGradientEnd);
    ctxPrerender.fillStyle = rightGradient;
    ctxPrerender.beginPath();
    ctxPrerender.moveTo(brickSize, 0);
    ctxPrerender.lineTo(brickSize - borderWidth, borderWidth);
    ctxPrerender.lineTo(brickSize - borderWidth, brickSize - borderWidth);
    ctxPrerender.lineTo(brickSize, brickSize);
    ctxPrerender.lineTo(brickSize, 0);
    ctxPrerender.fill();

    // Thin seam makes per-brick boundaries clear at high zoom.
    const seamColour = modifyRgbL(baseLab, -18);
    ctxPrerender.strokeStyle = seamColour;
    ctxPrerender.globalAlpha = 0.28;
    ctxPrerender.lineWidth = Math.max(1, borderWidth * 0.85);
    ctxPrerender.strokeRect(0.5, 0.5, Math.max(0, brickSize - 1), Math.max(0, brickSize - 1));
    ctxPrerender.globalAlpha = 1;
  }

  // Notch/stud overlay
  if (drawStudOverlay && halfNotchSize >= 1) {
    // Drop shadow
    const shadowSize = brickSize * notchShadowSizeRatio;
    if (shadowSize >= 2) {
      ctxPrerender.save();

      const gradient = ctxPrerender.createRadialGradient(0, 0, 0, 0, 0, shadowSize / 2);
      gradient.addColorStop(0, "rgba(0, 0, 0, 0.86)");
      gradient.addColorStop(0.55, "rgba(0, 0, 0, 0.7)");
      gradient.addColorStop(1, "rgba(0, 0, 0, 0)");
      ctxPrerender.fillStyle = gradient;

      ctxPrerender.beginPath();
      ctxPrerender.translate(
        brickSize * notchShadowPositionRatio.x,
        brickSize * notchShadowPositionRatio.y,
      );
      ctxPrerender.rotate((-45 * Math.PI) / 180);
      ctxPrerender.scale(1, 0.85);
      ctxPrerender.arc(0, 0, shadowSize / 2, 0, 2 * Math.PI, false);
      ctxPrerender.fill();
      ctxPrerender.restore();
      // context.strokeStyle = "rgba(0, 0, 0, 0.01)";
    }

    // Tight contact shadow below the stud for a "raised" LEGO look.
    const contactShadowGradient = ctxPrerender.createRadialGradient(
      halfBrickSize + halfNotchSize * 0.15,
      halfBrickSize + halfNotchSize * 0.2,
      halfNotchSize * 0.25,
      halfBrickSize + halfNotchSize * 0.18,
      halfBrickSize + halfNotchSize * 0.24,
      halfNotchSize * 1.05,
    );
    contactShadowGradient.addColorStop(0, "rgba(0, 0, 0, 0.2)");
    contactShadowGradient.addColorStop(1, "rgba(0, 0, 0, 0)");
    ctxPrerender.fillStyle = contactShadowGradient;
    ctxPrerender.beginPath();
    ctxPrerender.arc(halfBrickSize, halfBrickSize, halfNotchSize * 1.02, 0, 2 * Math.PI, false);
    ctxPrerender.fill();

    // Ridge of notch
    if (drawNotchRidgeWidth >= 1) {
      draw45DegreesLinearGradientCircle(
        ctxPrerender,
        halfBrickSize,
        halfBrickSize,
        halfNotchSize,
        notchRidgeColour,
        notchRidgeMidColour,
        notchRidgeEndColour,
      );
    }

    // Notch
    draw45DegreesLinearGradientCircle(
      ctxPrerender,
      halfBrickSize,
      halfBrickSize,
      halfNotchSize - drawNotchRidgeWidth,
      colourString,
      notchMidRgbColour,
      notchEndRgbColour,
    );

    // Intentionally no extra specular dot highlight: it looked too artificial.
  }

  // Copy image data as array of pixels
  const ceilBrickSize = Math.ceil(brickSize);
  const cData = ctxPrerender.getImageData(0, 0, ceilBrickSize, ceilBrickSize);
  const pixelRows = new Array(ceilBrickSize);
  for (let j = 0; j < ceilBrickSize; j++) {
    pixelRows[j] = cData.data.subarray(
      j * ceilBrickSize * 4,
      j * ceilBrickSize * 4 + ceilBrickSize * 4,
    );
  }

  renderBrickCache.set(cacheKey, pixelRows);
  return pixelRows;
}

function rgbaNumberToHexString(num) {
  if (num < 0 || Number.isNaN(num) || num > 0xffffffff) {
    throw new Error(`Invalid rgba number: ${num.toString(16)}`);
  }
  return `#${num.toString(16).padStart(8, "0")}`;
}

function renderBitmapToCanvas(imgBitmap, sizeStr, targetCanvas, targetCtx) {
  if (!targetCanvas || !targetCtx || !imgBitmap) return;
  const { pxW, pxH } = parseSize(sizeStr);
  const { ceilBrickSizePixels, brickSizePixels } = getRenderMeasurements(
    targetCanvas.width,
    targetCanvas.height,
    pxW,
    pxH,
  );

  const oversizedImageDataWidth = Math.ceil(
    (imgBitmap.width - 1) * brickSizePixels + ceilBrickSizePixels,
  );
  const oversizedImageDataHeight = Math.ceil(
    (imgBitmap.height - 1) * brickSizePixels + ceilBrickSizePixels,
  );
  const newData = new Uint8ClampedArray(
    oversizedImageDataWidth * oversizedImageDataHeight * 4,
  );

  // Go backwards because the shadow is to the bottom right, this way shadow doesn't get drawn over
  // Using the same row-by-row yielding structure as the original implementation
  for (let y = imgBitmap.height - 1; y >= 0; y--) {
    const yOffset = y * imgBitmap.width * 4;
    const yPosBricks = Math.round(y * brickSizePixels);

    for (let x = imgBitmap.width - 1; x >= 0; x--) {
      const pixelOffset = yOffset + (x << 2);

      // Inline readUInt32BE for better performance
      const buildPixel =
        imgBitmap.data[pixelOffset] * 0x1000000 +
        ((imgBitmap.data[pixelOffset + 1] << 16) |
          (imgBitmap.data[pixelOffset + 2] << 8) |
          imgBitmap.data[pixelOffset + 3]);

      const pixel = buildPixel;

      const colourString = rgbaNumberToHexString(pixel);
      // Always keep full LEGO tile overlay for consistency (including details viewer).
      const allowDrawOutline = true;
      let pixelRows = renderBrick(
        colourString,
        ceilBrickSizePixels,
        allowDrawOutline,
        true,
        true,
      );

      const pixelXI = (x * brickSizePixels) | 0;

      // Copy all pixel rows at once for better performance
      for (let sourceRow = 0; sourceRow < pixelRows.length; sourceRow++) {
        const pixelRow = pixelRows[sourceRow];
        const destRowOffset =
          ((yPosBricks + sourceRow) * oversizedImageDataWidth + pixelXI) * 4;

        // Using TypedArray.set for faster copying
        newData.set(pixelRow, destRowOffset);
      }
    }

  }


  targetCtx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
  const drawX = Math.floor((targetCanvas.width - oversizedImageDataWidth) / 2);
  const drawY = Math.floor((targetCanvas.height - oversizedImageDataHeight) / 2);
  targetCtx.putImageData(
    new ImageData(newData, oversizedImageDataWidth, oversizedImageDataHeight),
    // ctx.createImageData(newData, oversizedImageDataWidth, oversizedImageDataHeight),
    // createImageData(
      // newData,
      // oversizedImageDataWidth,
      // oversizedImageDataHeight,
    // ),
    drawX,
    drawY,
  );
}

function renderOnCanvas(imgBitmap, sizeStr) {
  temporaryAdjustCanvasSize(sizeStr);
  renderBitmapToCanvas(imgBitmap, sizeStr, canvas, ctx);
}

// Fast zoom preview - resize and crop only, no filters/brickify (for smooth real-time zoom)
function renderZoomPreview() {
  if (!uploadedSourceBitmap || currentStep !== 1) return;
  
  // Fast path: just resize and crop, draw directly (no filters/brickify)
  const resizedBitmap = resizeADVANCED(uploadedSourceBitmap, selectedSize, { x: 0, y: 0 }, zoom);
  const croppedBitmap = cropADVANCED(resizedBitmap, selectedSize, dragOffset);
  
  const expectedLength = croppedBitmap.width * croppedBitmap.height * 4;
  if (croppedBitmap.width <= 0 || croppedBitmap.height <= 0 || croppedBitmap.data.length !== expectedLength) {
    return; // Skip this frame to avoid ImageData constructor error
  }
  
  // Adjust canvas size
  temporaryAdjustCanvasSize(selectedSize);
  
  // Convert bitmap to ImageData and draw directly
  const imageData = new ImageData(
    new Uint8ClampedArray(croppedBitmap.data),
    croppedBitmap.width,
    croppedBitmap.height
  );
  
  // Create temp canvas to draw the image
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = croppedBitmap.width;
  tempCanvas.height = croppedBitmap.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.putImageData(imageData, 0, 0);
  
  // Draw to main canvas - disable smoothing for sharper preview during zoom
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.imageSmoothingEnabled = false; // Disable smoothing for sharper, less blurry preview
  ctx.drawImage(tempCanvas, 0, 0, canvas.width, canvas.height);
  
}

// Lightweight preview render during drag - just pan the cached image
function renderPreview() {
  if (!uploadedSourceBitmap || currentStep !== 1) return;
  
  // During zoom, use fast zoom preview instead
  if (isZooming) {
    renderZoomPreview();
    return;
  }
  
  // If cache is invalid or doesn't exist, create it
  if (renderCache.needsUpdate || !renderCache.canvas || 
      renderCache.cachedZoom !== zoom || 
      renderCache.cachedSize !== selectedSize) {
    updateRenderCache();
  }
  
  // If no cache exists at all, we must create it
  if (!renderCache.canvas) {
    updateRenderCache();
  }
  
  if (!renderCache.canvas) return; // Safety check
  
  // Now just pan/translate the cached image based on dragOffset
  temporaryAdjustCanvasSize(selectedSize);
  const { pxW, pxH } = parseSize(selectedSize);
  
  // Use cached resized dimensions (no expensive calculation!)
  const resizedPixelWidth = renderCache.cachedResizedWidth;
  const resizedPixelHeight = renderCache.cachedResizedHeight;
  
  // Calculate brick size based on resized dimensions (not cache dimensions!)
  // The cache is oversized, so we need to use the original resized dimensions
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = resizedPixelWidth;
  tempCanvas.height = resizedPixelHeight;
  const { ceilBrickSizePixels, brickSizePixels } = getRenderMeasurements(
    tempCanvas.width, 
    tempCanvas.height, 
    pxW, 
    pxH
  );
  
  const freeX = resizedPixelWidth - pxW;
  const freeY = resizedPixelHeight - pxH;
  
  // Calculate crop position in pixel coordinates (same logic as cropADVANCED)
  const cropX = Math.min(
    freeX,
    Math.max(0, Math.round(freeX / 2 - dragOffset.x))
  );
  const cropY = Math.min(
    freeY,
    Math.max(0, Math.round(freeY / 2 - dragOffset.y))
  );
  
  // Convert pixel coordinates to cache coordinates (accounting for brick scaling)
  const sourceX = cropX * brickSizePixels;
  const sourceY = cropY * brickSizePixels;
  const sourceWidth = pxW * brickSizePixels;
  const sourceHeight = pxH * brickSizePixels;
  
  // Get cache dimensions for bounds checking
  const cacheWidth = renderCache.canvas.width;
  const cacheHeight = renderCache.canvas.height;
  
  // Clamp source coordinates to cache bounds to prevent reading outside
  const clampedSourceX = Math.max(0, Math.min(sourceX, cacheWidth - 1));
  const clampedSourceY = Math.max(0, Math.min(sourceY, cacheHeight - 1));
  const clampedSourceWidth = Math.min(sourceWidth, cacheWidth - clampedSourceX);
  const clampedSourceHeight = Math.min(sourceHeight, cacheHeight - clampedSourceY);
  
  // Clear canvas and draw the relevant portion from cache
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.imageSmoothingEnabled = false;
  
  // Draw the portion of cached image that corresponds to current dragOffset
  // Use clamped coordinates to ensure we don't read outside cache bounds
  if (clampedSourceWidth > 0 && clampedSourceHeight > 0) {
    ctx.drawImage(
      renderCache.canvas,
      clampedSourceX, clampedSourceY, clampedSourceWidth, clampedSourceHeight,
      0, 0, canvas.width, canvas.height
    );
  }
  
}

// Update the render cache with full processed image (only when zoom/size changes)
function updateRenderCache() {
  if (!uploadedSourceBitmap) return;
  
  // Resize the image (full size, no crop yet)
  const resizedBitmap = resizeADVANCED(uploadedSourceBitmap, selectedSize, { x: 0, y: 0 }, zoom);
  
  // Cache the resized dimensions for fast access during drag
  renderCache.cachedResizedWidth = resizedBitmap.width;
  renderCache.cachedResizedHeight = resizedBitmap.height;
  
  // Apply all expensive operations to the full resized image
  const filteredBitmap = applyDetailFilterADVANCED(resizedBitmap);
  const enhancedBitmap = applyColorCorrectionsADVANCED(
    filteredBitmap,
    colorCorrectionBrightness,
    colorCorrectionContrast,
    colorCorrectionSaturation,
  );
  const brickifyInput =
    mosaicColorMode === "blackWhite" ? extractLumaBitmap(enhancedBitmap) : enhancedBitmap;
  const brickedBitmap = finalizeBrickedBitmap(brickify(brickifyInput));
  
  // Render the full brickified image to cache (this is expensive, but only done once)
  const { pxW, pxH } = parseSize(selectedSize);
  
  // Calculate the oversized dimensions first (this is what the cache canvas should be)
  // We need to use the resized dimensions to calculate brick size
  // Create a temporary canvas to get the correct measurements
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = resizedBitmap.width;
  tempCanvas.height = resizedBitmap.height;
  const { ceilBrickSizePixels, brickSizePixels } = getRenderMeasurements(
    tempCanvas.width, 
    tempCanvas.height, 
    pxW, 
    pxH
  );
  
  const oversizedImageDataWidth = Math.ceil(
    (brickedBitmap.width - 1) * brickSizePixels + ceilBrickSizePixels
  );
  const oversizedImageDataHeight = Math.ceil(
    (brickedBitmap.height - 1) * brickSizePixels + ceilBrickSizePixels
  );
  
  // Create or reuse offscreen canvas
  if (!renderCache.canvas) {
    renderCache.canvas = document.createElement('canvas');
    renderCache.ctx = renderCache.canvas.getContext('2d');
  }
  
  // Set canvas size to match the oversized rendered dimensions (with brick pixels)
  renderCache.canvas.width = oversizedImageDataWidth;
  renderCache.canvas.height = oversizedImageDataHeight;
  const newData = new Uint8ClampedArray(
    oversizedImageDataWidth * oversizedImageDataHeight * 4
  );
  
  // Render bricks (same logic as renderOnCanvas but to cache)
  for (let y = brickedBitmap.height - 1; y >= 0; y--) {
    const yOffset = y * brickedBitmap.width * 4;
    const yPosBricks = Math.round(y * brickSizePixels);
    
    for (let x = brickedBitmap.width - 1; x >= 0; x--) {
      const pixelOffset = yOffset + (x << 2);
      const buildPixel =
        brickedBitmap.data[pixelOffset] * 0x1000000 +
        ((brickedBitmap.data[pixelOffset + 1] << 16) |
          (brickedBitmap.data[pixelOffset + 2] << 8) |
          brickedBitmap.data[pixelOffset + 3]);
      
      const colourString = rgbaNumberToHexString(buildPixel);
      // Keep cache lightweight for drag preview: flat coloured tiles only.
      let pixelRows = renderBrick(colourString, ceilBrickSizePixels, false, false, false);
      
      const pixelXI = (x * brickSizePixels) | 0;
      
      for (let sourceRow = 0; sourceRow < pixelRows.length; sourceRow++) {
        const pixelRow = pixelRows[sourceRow];
        const destRowOffset =
          ((yPosBricks + sourceRow) * oversizedImageDataWidth + pixelXI) * 4;
        newData.set(pixelRow, destRowOffset);
      }
    }
  }
  
  // Put the rendered image data into cache canvas
  renderCache.ctx.putImageData(
    new ImageData(newData, oversizedImageDataWidth, oversizedImageDataHeight),
    0, 0
  );
  
  // Update cache metadata
  renderCache.cachedZoom = zoom;
  renderCache.cachedSize = selectedSize;
  renderCache.cachedOffset = { ...dragOffset };
  renderCache.needsUpdate = false;
}

function finalizeBrickedBitmap(brickedBitmap) {
  return mosaicBlackFrameEnabled ? applyMosaicBlackBorder(brickedBitmap) : brickedBitmap;
}

function render() {
  if (!uploadedSourceBitmap) return;
  
  // Invalidate cache when doing full render (zoom/size might have changed)
  renderCache.needsUpdate = true;
  
  // const size = sizeSelect.value;
  const resizedBitmap = resizeADVANCED(uploadedSourceBitmap, selectedSize, dragOffset, zoom);
  const croppedBitmap = cropADVANCED(resizedBitmap, selectedSize, dragOffset);

  const filteredBitmap = applyDetailFilterADVANCED(croppedBitmap);
  const enhancedBitmap = applyColorCorrectionsADVANCED(
    filteredBitmap,
    colorCorrectionBrightness,
    colorCorrectionContrast,
    colorCorrectionSaturation,
  );
  const brickifyInput =
    mosaicColorMode === "blackWhite" ? extractLumaBitmap(enhancedBitmap) : enhancedBitmap;
  const brickedBitmap = finalizeBrickedBitmap(brickify(brickifyInput));

  // Store the brickified bitmap for later use (when adding to cart - no reprocessing needed)
  currentBrickedBitmap = brickedBitmap;

  // const bricked = buildBitmapToImageData(brickedBitmap);

  renderOnCanvas(brickedBitmap, selectedSize);

  // Update cache for next drag operation
  updateRenderCache();

  // alert(`resizedTime: ${resizedTime}ms | croppedTime: ${croppedTime}ms | brickedTime: ${brickedTime}ms | renderOnCanvasTime: ${renderOnCanvasTime}ms`)
  

  // const canvasTest = document.createElement('canvas');
  // const ctxTest = canvasTest.getContext('2d');
  // canvasTest.width = bricked.width;
  // canvasTest.height = bricked.height;
  // ctxTest.putImageData(bricked, 0, 0);
  // document.body.appendChild(canvasTest);
}

let uploadedSourceBitmap = null;

function setMozaikCanvasLoading(loading) {
  if (!mozaikCanvasLoader) return;
  const wrap = mozaikCanvasLoader.closest(".canvas-wrapper");
  if (wrap) {
    wrap.classList.toggle("canvas-wrapper--loading", loading);
  }
  if (loading) {
    mozaikCanvasLoader.hidden = false;
    mozaikCanvasLoader.removeAttribute("aria-hidden");
  } else {
    mozaikCanvasLoader.hidden = true;
    mozaikCanvasLoader.setAttribute("aria-hidden", "true");
  }
}

function loadImage() {
  (async () => {
    let record = null;
    let uploadRecordReadFailed = false;
    try {
      record = await getUploadedImageRecord();
    } catch (e) {
      uploadRecordReadFailed = true;
      console.error("Editor: failed to read IndexedDB upload record", e);
    }

    if (!isValidTransformedUploadRecord(record)) {
      if (isEditorShopifyPath()) {
        if (!uploadRecordReadFailed) {
          await clearUploadedImageRecordAndRedirect(
            "Editor: IndexedDB upload record is missing or has invalid original/transformed image buffers; clearing record and redirecting to upload."
          );
        } else {
          await clearUploadedImageRecordAndRedirect();
        }
        return;
      }
      console.warn("No cropped upload image in IndexedDB.");
      return;
    }

    const mimeType =
      typeof record.transformedImageMimeType === "string" && record.transformedImageMimeType.trim()
        ? record.transformedImageMimeType.trim()
        : "image/jpeg";
    const blob = new Blob([record.transformedImageArrayBuffer], { type: mimeType });
    const objectUrl = URL.createObjectURL(blob);
    setMozaikCanvasLoading(true);
    const img = new Image();
    img.alt = "Uploaded Mosaic Image";
    img.onerror = async () => {
      URL.revokeObjectURL(objectUrl);
      setMozaikCanvasLoading(false);
      if (isEditorShopifyPath()) {
        await clearUploadedImageRecordAndRedirect(
          "Editor: failed to decode transformed image from IndexedDB; clearing record and redirecting to upload."
        );
      } else {
        console.error("Editor: failed to decode uploaded image from IndexedDB.");
      }
    };
    img.onload = async () => {
      URL.revokeObjectURL(objectUrl);
      try {
        uploadedImage = img;
        uploadedSourceBitmap = imageToBuildBitmapCached(img, null);
        dragOffset = { x: 0, y: 0 };
        zoom = 1;
        autoColorDefaultsAppliedForCurrentImage = false;
        clearSuggestCropCache();

        const match = findBestMatchingSize(img.width, img.height);
        selectedSize = match.size;

        try {
          await fetchSuggestCropAndApply(img);
        } catch (e) {
          console.warn("suggest-crop: unexpected error", e);
        }

        // Auto color defaults: apply once per loaded image.
        if (!autoColorDefaultsAppliedForCurrentImage) {
          try {
            const w = img.naturalWidth || img.width;
            const h = img.naturalHeight || img.height;
            const cropPx = getSuggestCropBoxPxForSizeIfAvailable(selectedSize, w, h);
            const defaults = suggestColorCorrectionDefaults(img, cropPx);
            colorCorrectionBrightness = defaults.brightness;
            colorCorrectionContrast = defaults.contrast;
            colorCorrectionSaturation = defaults.saturation;
            setInitialMosaicColorModeForImage(defaults.isGreyscale);
            autoColorDefaultsAppliedForCurrentImage = true;
          } catch (e) {
            console.warn("auto color defaults: unexpected error", e);
          }
        }

        // Update size options to reflect the new selection
        updateSizeOptions();

        if (zoomRange) {
          zoomRange.value = String(zoom);
        }
        if (brightnessRange) {
          brightnessRange.value = String(colorCorrectionBrightness);
        }
        if (contrastRange) {
          contrastRange.value = String(colorCorrectionContrast);
        }
        if (saturationRange) {
          saturationRange.value = String(colorCorrectionSaturation);
        }
        render();
      } finally {
        requestAnimationFrame(() => {
          setMozaikCanvasLoading(false);
        });
      }
    };
    img.src = objectUrl;
  })();
}

function updatePreviewTotal() {
  if (!selectedSize) return;
  
  const basePrice = sizeToPriceNumber(selectedSize);
  
  // Only update prices if Shopify prices are loaded
  if (basePrice === null) {
    return; // Skip update if prices not loaded yet
  }
  
  // Update all base price elements (not the total)
  if (mozaikPrices && mozaikPrices.length > 0) {
    mozaikPrices.forEach(item => {
      // Skip preview footer total - we'll update that separately
      if (!item.classList.contains('preview-footer-total-price')) {
        item.innerText = sizeToPrice(selectedSize);
      }
    });
  }
  
  // Extract hanging price from the preview hanging price element
  let hangingPrice = 0; // Default to 0
  if (previewHangingPrice) {
    const priceText = previewHangingPrice.innerText.replace('€', '').replace(',', '.').trim();
    const parsedPrice = parseFloat(priceText);
    // Only use parsed price if it's a valid number (including 0)
    if (!isNaN(parsedPrice)) {
      hangingPrice = parsedPrice;
    }
  }
  
  const oldBasePrice = sizeToOldPriceNumber(selectedSize);
  const totalPrice = basePrice + hangingPrice;
  const oldTotalPrice = oldBasePrice !== null ? oldBasePrice + hangingPrice : null;
  renderFooterTotalPrice(totalPrice, oldTotalPrice);
}

let lastCalibratedBrickPixelSize = null;

function syncCalibratedCanvasOnResize() {
  const next = getCalibratedBrickPixelSize();
  if (lastCalibratedBrickPixelSize === null) {
    lastCalibratedBrickPixelSize = next;
    return;
  }
  if (
    next !== lastCalibratedBrickPixelSize &&
    uploadedSourceBitmap &&
    typeof render === "function"
  ) {
    lastCalibratedBrickPixelSize = next;
    renderCache.needsUpdate = true;
    render();
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("resize", () => {
    requestAnimationFrame(syncCalibratedCanvasOnResize);
  });
}


// ===== return-discount.js =====
const RETURN_DISCOUNT_CHECKOUT_KEY = "editor-checkout-non-2x2";
const RETURN_DISCOUNT_SHOWN_KEY = "editor-return-discount-shown";
const RETURN_DISCOUNT_CODE = "HAPPY5";
const RETURN_DISCOUNT_SHOW_DELAY_MS = 2000;
const RETURN_DISCOUNT_AUTO_HIDE_MS = 10000;

function getShopOrigin() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    const host = window.location.hostname || "";
    if (host === "localhost" || host === "127.0.0.1") {
      return "https://pixelbrick.nl";
    }
    return window.location.origin;
  }
  return "https://pixelbrick.nl";
}

function markCheckoutQualifiedForReturnDiscount() {
  try {
    if (selectedSize && selectedSize !== "2x2") {
      localStorage.setItem(RETURN_DISCOUNT_CHECKOUT_KEY, "1");
    }
  } catch (e) {
    /* ignore storage errors */
  }
}

function shouldShowReturnDiscountOffer() {
  try {
    return (
      localStorage.getItem(RETURN_DISCOUNT_CHECKOUT_KEY) === "1" &&
      localStorage.getItem(RETURN_DISCOUNT_SHOWN_KEY) !== "1"
    );
  } catch (e) {
    return false;
  }
}

function markReturnDiscountOfferShown() {
  try {
    localStorage.setItem(RETURN_DISCOUNT_SHOWN_KEY, "1");
    localStorage.removeItem(RETURN_DISCOUNT_CHECKOUT_KEY);
  } catch (e) {
    /* ignore storage errors */
  }
}

function applyReturnDiscountCode() {
  const redirectTarget = window.location.pathname + window.location.search + window.location.hash;
  const discountUrl =
    getShopOrigin() +
    "/discount/" +
    encodeURIComponent(RETURN_DISCOUNT_CODE) +
    "?redirect=" +
    encodeURIComponent(redirectTarget || "/");
  window.location.href = discountUrl;
}

function createCornerConfettiParticle(width, height, fromLeft, colors, index) {
  const spread = width * 0.14;
  const x = fromLeft
    ? Math.random() * spread
    : width - Math.random() * spread;
  const launchSpeed = 9 + Math.random() * 7;
  const launchAngle = fromLeft
    ? -Math.PI * (0.28 + Math.random() * 0.22)
    : -Math.PI * (0.5 + Math.random() * 0.22);

  return {
    x: x,
    y: height + Math.random() * 16,
    w: 5 + Math.random() * 7,
    h: 3 + Math.random() * 6,
    color: colors[index % colors.length],
    rotation: Math.random() * Math.PI,
    spin: (Math.random() - 0.5) * 0.3,
    vx: Math.cos(launchAngle) * launchSpeed,
    vy: Math.sin(launchAngle) * launchSpeed,
    alpha: 1,
  };
}

function fireEditorConfetti(durationMs) {
  const duration = durationMs || 3800;
  const canvas = document.createElement("canvas");
  canvas.className = "editor-confetti-canvas";
  canvas.setAttribute("aria-hidden", "true");
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  if (!ctx) {
    canvas.remove();
    return;
  }

  let width = window.innerWidth;
  let height = window.innerHeight;
  canvas.width = width;
  canvas.height = height;

  const colors = ["#e54912", "#fdae29", "#007aff", "#ffffff", "#2b79bd"];
  const particles = [];
  const burstCount = Math.min(220, Math.floor((width * height) / 2800));
  const burstWaves = 4;

  function spawnBurst(waveIndex) {
    for (let i = 0; i < burstCount; i++) {
      particles.push(
        createCornerConfettiParticle(width, height, i % 2 === 0, colors, waveIndex * burstCount + i),
      );
    }
  }

  spawnBurst(0);

  const startedAt = performance.now();
  let rafId = 0;
  let nextBurstWave = 1;
  const burstIntervalMs = 180;

  function resize() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
  }

  function frame(now) {
    const elapsed = now - startedAt;
    while (nextBurstWave < burstWaves && elapsed >= nextBurstWave * burstIntervalMs) {
      spawnBurst(nextBurstWave);
      nextBurstWave++;
    }

    ctx.clearRect(0, 0, width, height);

    for (let i = 0; i < particles.length; i++) {
      const p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vx *= 0.992;
      p.vy += 0.18;
      p.rotation += p.spin;
      if (elapsed > duration * 0.65) {
        p.alpha = Math.max(0, p.alpha - 0.02);
      }

      ctx.save();
      ctx.globalAlpha = p.alpha;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rotation);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w * 0.5, -p.h * 0.5, p.w, p.h);
      ctx.restore();
    }

    if (elapsed < duration) {
      rafId = window.requestAnimationFrame(frame);
    } else {
      window.removeEventListener("resize", resize);
      canvas.remove();
    }
  }

  window.addEventListener("resize", resize);
  rafId = window.requestAnimationFrame(frame);

  return function cancel() {
    window.cancelAnimationFrame(rafId);
    window.removeEventListener("resize", resize);
    canvas.remove();
  };
}

function removeReturnDiscountPopup(popup, hideTimerId) {
  if (!popup || !popup.parentNode) return;
  if (hideTimerId) window.clearTimeout(hideTimerId);
  popup.classList.add("editor-return-discount-popup--hide");
  window.setTimeout(function () {
    if (popup.parentNode) popup.parentNode.removeChild(popup);
  }, 280);
}

function showReturnDiscountPopup() {
  const headerWrap =
    document.querySelector(".simple-editor-page__header") ||
    document.querySelector(".simple-editor-header")?.parentElement;
  if (!headerWrap) return;

  markReturnDiscountOfferShown();
  fireEditorConfetti();

  const popup = document.createElement("div");
  popup.className = "editor-return-discount-popup";
  popup.setAttribute("role", "status");
  popup.setAttribute("aria-live", "polite");

  const message = document.createElement("p");
  message.className = "editor-return-discount-popup__message";
  message.textContent = "Je hebt er één gekozen! Hier is jouw speciale korting: 5%";

  const actions = document.createElement("div");
  actions.className = "editor-return-discount-popup__actions";

  const useBtn = document.createElement("button");
  useBtn.type = "button";
  useBtn.className = "editor-return-discount-popup__btn";
  useBtn.textContent = "Gebruiken";
  useBtn.setAttribute("data-track", "editor--return-discount-use");

  const codeLabel = document.createElement("p");
  codeLabel.className = "editor-return-discount-popup__code-label";
  codeLabel.innerHTML = 'Kortingscode: <code>HAPPY5</code>';

  useBtn.addEventListener("click", function () {
    removeReturnDiscountPopup(popup, hideTimerId);
    applyReturnDiscountCode();
  });

  actions.appendChild(useBtn);
  popup.appendChild(message);
  popup.appendChild(actions);
  popup.appendChild(codeLabel);
  headerWrap.appendChild(popup);

  const hideTimerId = window.setTimeout(function () {
    removeReturnDiscountPopup(popup, null);
  }, RETURN_DISCOUNT_AUTO_HIDE_MS);
}

let returnDiscountOfferScheduled = false;

function initReturnDiscountOffer() {
  if (!shouldShowReturnDiscountOffer() || returnDiscountOfferScheduled) return;
  returnDiscountOfferScheduled = true;
  window.setTimeout(showReturnDiscountPopup, RETURN_DISCOUNT_SHOW_DELAY_MS);
}

// Browsers restore this page from bfcache on back navigation without re-running init.
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    initReturnDiscountOffer();
  }
});


// ===== ui-handlers.js =====

// Zoom limits (EDITOR_MIN_ZOOM / EDITOR_MAX_ZOOM in constants.js)
const MIN_ZOOM = EDITOR_MIN_ZOOM;
const MAX_ZOOM = EDITOR_MAX_ZOOM;

// Smooth zoom - render immediately during zoom, full render when stops
let isZooming = false;
let zoomRenderTimeout = null;
let zoomAnimationFrame = null;

function handleZoomChange() {
  // Mark that we're zooming
  isZooming = true;
  
  // Update slider immediately for responsive feel
  if (zoomRange) {
    zoomRange.value = zoom;
  }
  
  // Throttle rendering with requestAnimationFrame (smooth 60fps, prevents blocking)
  if (!zoomAnimationFrame) {
    zoomAnimationFrame = requestAnimationFrame(() => {
      renderPreview(); // Fast preview during zoom
      zoomAnimationFrame = null;
    });
  }
  
  // Clear existing timeout
  if (zoomRenderTimeout) {
    clearTimeout(zoomRenderTimeout);
  }
  
  // Schedule full render when zoom stops
  zoomRenderTimeout = setTimeout(() => {
    isZooming = false;
    if (zoomAnimationFrame) {
      cancelAnimationFrame(zoomAnimationFrame);
      zoomAnimationFrame = null;
    }
    render(); // Full render when zoom stops
    zoomRenderTimeout = null;
  }, 200);
}

if (zoomRange) {
  zoomRange.addEventListener("input", () => {
    if (currentStep!=1) return;

    zoom = parseFloat(zoomRange.value);
    handleZoomChange();
  });
}

// Color correction sliders - debounce full renders (no fast preview path)
let colorRenderTimeout = null;
function scheduleColorRender() {
  if (currentStep !== 1) return;
  if (colorRenderTimeout) clearTimeout(colorRenderTimeout);
  colorRenderTimeout = setTimeout(() => {
    render();
    colorRenderTimeout = null;
  }, 150);
}

if (brightnessRange) {
  brightnessRange.addEventListener("input", () => {
    colorCorrectionBrightness = parseFloat(brightnessRange.value);
    scheduleColorRender();
  });
}
if (contrastRange) {
  contrastRange.addEventListener("input", () => {
    colorCorrectionContrast = parseFloat(contrastRange.value);
    scheduleColorRender();
  });
}
if (saturationRange) {
  saturationRange.addEventListener("input", () => {
    colorCorrectionSaturation = parseFloat(saturationRange.value);
    scheduleColorRender();
  });
}

function syncColorModeButtons() {
  if (!colorModeColorfulBtn || !colorModeBwBtn) return;
  var colorful = mosaicColorMode === "colorful";
  colorModeColorfulBtn.classList.toggle("editor-color-mode__btn--on-colorful", colorful);
  colorModeBwBtn.classList.toggle("editor-color-mode__btn--on-bw", !colorful);
  colorModeColorfulBtn.setAttribute("aria-pressed", colorful ? "true" : "false");
  colorModeBwBtn.setAttribute("aria-pressed", colorful ? "false" : "true");
}

function syncBrightnessRangeFromState() {
  if (brightnessRange) {
    brightnessRange.value = String(colorCorrectionBrightness);
  }
}

/** Zwart-wit: −0.8 on brightness slider (clamped); kleurrijk restores saved value. */
function applyBrightnessForColorMode(mode) {
  if (mode === "blackWhite") {
    colorBrightnessBeforeBlackWhite = colorCorrectionBrightness;
    colorCorrectionBrightness = Math.max(-1, colorCorrectionBrightness - 0.8);
  } else if (colorBrightnessBeforeBlackWhite !== null) {
    colorCorrectionBrightness = colorBrightnessBeforeBlackWhite;
    colorBrightnessBeforeBlackWhite = null;
  }
  syncBrightnessRangeFromState();
}

function applyMosaicColorMode(mode) {
  if (mosaicColorMode === mode) return;
  setMosaicColorMode(mode);
  applyBrightnessForColorMode(mode);
  syncColorModeButtons();
  if (typeof renderCache !== "undefined" && renderCache) {
    renderCache.needsUpdate = true;
  }
  if (typeof uploadedSourceBitmap !== "undefined" && uploadedSourceBitmap && typeof render === "function") {
    render();
  }
}

/** Reset to colorful, then switch to B&W when the loaded image is greyscale. No render. */
function setInitialMosaicColorModeForImage(isGreyscale) {
  colorBrightnessBeforeBlackWhite = null;
  setMosaicColorMode("colorful");
  if (isGreyscale) {
    setMosaicColorMode("blackWhite");
    colorBrightnessBeforeBlackWhite = colorCorrectionBrightness;
    colorCorrectionBrightness = Math.max(-1, colorCorrectionBrightness - 0.8);
  }
  syncColorModeButtons();
  syncBrightnessRangeFromState();
  if (typeof renderCache !== "undefined" && renderCache) {
    renderCache.needsUpdate = true;
  }
}

if (colorModeColorfulBtn) {
  colorModeColorfulBtn.addEventListener("click", function () {
    applyMosaicColorMode("colorful");
  });
}
if (colorModeBwBtn) {
  colorModeBwBtn.addEventListener("click", function () {
    applyMosaicColorMode("blackWhite");
  });
}
syncColorModeButtons();

// orientationSelect.addEventListener("change", () => {
//   updateSizeOptions();
//   render();
// });

// sizeSelect.addEventListener("change", render);
const interactionSurface = pictureRendering || canvas;

// Mouse events (desktop)
if (interactionSurface) {
  interactionSurface.addEventListener("mousedown", e => {
    if (currentStep !== 1) return;
    isDragging = true;
    dragStart = { x: e.clientX, y: e.clientY };
  });
}

window.addEventListener("mouseup", () => {
  if (currentStep !== 1) return;
  if (isDragging) {
    isDragging = false;
    // Cancel any pending preview render and do full render
    if (renderAnimationFrame) {
      cancelAnimationFrame(renderAnimationFrame);
      renderAnimationFrame = null;
    }
    isDragRendering = false;
    render(); // Full render when drag ends
  }
});

window.addEventListener("mousemove", e => {
  if (!isDragging || currentStep !== 1) return;
  handleDrag(e.clientX, e.clientY);
});

window.addEventListener("mouseleave", () => {
  isDragging = false;
});

// Mouse wheel zoom (desktop)
if (interactionSurface) {
  interactionSurface.addEventListener("wheel", e => {
    if (currentStep !== 1) return;
    
    e.preventDefault();
    
    // Don't zoom out when already at minimum (avoids resize/crop edge case and redundant render)
    if (zoom <= MIN_ZOOM && e.deltaY > 0) return;
    
    // Small, smooth zoom steps
    const delta = e.deltaY > 0 ? 0.98 : 1.02;
    let newZoom = zoom * delta;
    newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, newZoom));
    
    // Update zoom value immediately
    zoom = newZoom;
    
    // Render immediately for smooth zoom
    handleZoomChange();
  }, { passive: false });
}

// Helper for touch distance
function getTouchDistance(t1, t2) {
  const dx = t1.clientX - t2.clientX;
  const dy = t1.clientY - t2.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

// Touch events (mobile) - support drag and pinch zoom
let isPinching = false;
let pinchStartDistance = 0;
let pinchStartZoom = 1;

if (interactionSurface) {
  interactionSurface.addEventListener("touchstart", e => {
    if (currentStep !== 1) return;
    
    if (e.touches.length === 2) {
      // Pinch zoom - start
      isPinching = true;
      isDragging = false;
      pinchStartDistance = getTouchDistance(e.touches[0], e.touches[1]);
      pinchStartZoom = zoom;
      e.preventDefault();
    } else if (e.touches.length === 1 && !isPinching) {
      // Single touch - drag
      isDragging = true;
      const touch = e.touches[0];
      dragStart = { x: touch.clientX, y: touch.clientY };
    }
  }, { passive: false });
}

window.addEventListener("touchend", e => {
  if (currentStep !== 1) return;
  
  if (e.touches.length < 2) {
    isPinching = false;
  }
  
  if (e.touches.length === 0) {
    if (isDragging) {
      isDragging = false;
      if (renderAnimationFrame) {
        cancelAnimationFrame(renderAnimationFrame);
        renderAnimationFrame = null;
      }
      isDragRendering = false;
      render(); // Full render when drag ends
    }
    
    // If was zooming, do final render
    if (isZooming || zoomRenderTimeout) {
      isZooming = false;
      if (zoomAnimationFrame) {
        cancelAnimationFrame(zoomAnimationFrame);
        zoomAnimationFrame = null;
      }
      if (zoomRenderTimeout) {
        clearTimeout(zoomRenderTimeout);
        zoomRenderTimeout = null;
      }
      render(); // Final render when zoom ends
    }
  }
});

window.addEventListener("touchmove", e => {
  if (currentStep !== 1) return;
  
  if (e.touches.length === 2 && isPinching) {
    // Pinch zoom - update zoom value and render immediately
    const currentDistance = getTouchDistance(e.touches[0], e.touches[1]);
    const scale = currentDistance / pinchStartDistance;
    let newZoom = pinchStartZoom * scale;
    newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, newZoom));
    
    // Don't zoom out when already at minimum (avoids resize/crop edge case and redundant render)
    if (zoom <= MIN_ZOOM && newZoom <= MIN_ZOOM) return;
    
    // Update zoom value immediately
    zoom = newZoom;
    
    // Render immediately for smooth zoom
    handleZoomChange();
    
    e.preventDefault();
  } else if (e.touches.length === 1 && isDragging && !isPinching) {
    // Drag
    const touch = e.touches[0];
    handleDrag(touch.clientX, touch.clientY);
    e.preventDefault();
  }
}, { passive: false });

let renderAnimationFrame = null;
let isDragRendering = false;

function handleDrag(x, y) {
  dragOffset.x += (x - dragStart.x) / zoom;
  dragOffset.y += (y - dragStart.y) / zoom;
  dragStart = { x, y };
  
  // Throttle rendering during drag using requestAnimationFrame
  if (!isDragRendering) {
    isDragRendering = true;
    if (renderAnimationFrame) {
      cancelAnimationFrame(renderAnimationFrame);
    }
    renderAnimationFrame = requestAnimationFrame(() => {
      renderPreview(); // Use lightweight preview render during drag
      isDragRendering = false;
    });
  }
}

// Create color index map (RGBA value -> index in palette)
function createColorIndexMap() {
  const indexMap = new Map();
  legoPalette.forEach((color, index) => {
    indexMap.set(color.rgba, index);
  });
  return indexMap;
}

// Extract optimized brick array (stores indices 0-49 instead of hex strings)
/** Longer side (px) of uploaded mosaic image — always exactly this; shorter side scales proportionally (≤ this). */
const MOSAIC_UPLOAD_LONG_EDGE_PX = 800;

/**
 * Renders the brickified bitmap to a PNG. Scales so **max(width, height) === MOSAIC_UPLOAD_LONG_EDGE_PX**
 * (up or down from native bricked size) with nearest-neighbor (sharp studs).
 * @param {object} brickedBitmap - build bitmap from brickify pipeline
 * @param {(blob: Blob | null) => void} callback
 */
function createMosaicExportBlob(brickedBitmap, callback) {
  const w = brickedBitmap.width;
  const h = brickedBitmap.height;
  if (!w || !h) {
    callback(null);
    return;
  }
  let outW;
  let outH;
  if (w >= h) {
    outW = MOSAIC_UPLOAD_LONG_EDGE_PX;
    outH = Math.max(1, Math.round((h * MOSAIC_UPLOAD_LONG_EDGE_PX) / w));
  } else {
    outH = MOSAIC_UPLOAD_LONG_EDGE_PX;
    outW = Math.max(1, Math.round((w * MOSAIC_UPLOAD_LONG_EDGE_PX) / h));
  }

  try {
    const srcCanvas = document.createElement("canvas");
    srcCanvas.width = w;
    srcCanvas.height = h;
    const srcCtx = srcCanvas.getContext("2d", { willReadFrequently: true });
    srcCtx.putImageData(buildBitmapToImageData(brickedBitmap), 0, 0);

    const outCanvas = document.createElement("canvas");
    outCanvas.width = outW;
    outCanvas.height = outH;
    const outCtx = outCanvas.getContext("2d", { willReadFrequently: true });
    outCtx.imageSmoothingEnabled = false;
    outCtx.drawImage(srcCanvas, 0, 0, w, h, 0, 0, outW, outH);

    outCanvas.toBlob(callback, "image/png");
  } catch (e) {
    console.error("createMosaicExportBlob:", e);
    callback(null);
  }
}

function extractBrickArrayOptimized(brickedBitmap) {
  const { pxW, pxH } = parseSize(selectedSize);
  const colorIndexMap = createColorIndexMap();
  const brickArray = [];
  
  for (let y = 0; y < pxH; y++) {
    const row = [];
    for (let x = 0; x < pxW; x++) {
      const pixelIndex = (y * pxW + x) * 4; // 4 bytes per pixel (RGBA)
      const rgba = readUInt32BE(brickedBitmap.data, pixelIndex);
      
      // Get color index (0-49) instead of hex string
      const colorIndex = colorIndexMap.get(rgba);
      if (colorIndex === undefined) {
        console.error(`Color not found in palette: ${rgba.toString(16)}`);
        // Fallback to index 0 if color not found
        row.push(0);
      } else {
        row.push(colorIndex);
      }
    }
    brickArray.push(row);
  }
  
  return brickArray;
}

function getTransformedBlobFromUploadRecord(record) {
  if (!record || typeof record !== "object") return null;
  if (record.transformedImageArrayBuffer instanceof ArrayBuffer && record.transformedImageArrayBuffer.byteLength > 0) {
    const mimeType =
      typeof record.transformedImageMimeType === "string" && record.transformedImageMimeType.trim()
        ? record.transformedImageMimeType.trim()
        : "image/jpeg";
    return new Blob([record.transformedImageArrayBuffer], { type: mimeType });
  }
  return null;
}

const CLOUDINARY_UPLOAD_URL = "https://api.cloudinary.com/v1_1/doegu5fqf/image/upload";
const CLOUDINARY_MAX_ATTEMPTS = 3;
const CLOUDINARY_RETRY_DELAYS_MS = [800, 1800];

function waitMs(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function safeStringifyDeep(value) {
  const seen = new WeakSet();
  return JSON.stringify(value, function replacer(key, current) {
    if (typeof current === "object" && current !== null) {
      if (seen.has(current)) return "[Circular]";
      seen.add(current);
    }
    if (current instanceof Error) {
      return {
        name: current.name,
        message: current.message,
        stack: current.stack
      };
    }
    if (typeof current === "bigint") return `${current.toString()}n`;
    if (typeof current === "function") return `[Function ${current.name || "anonymous"}]`;
    return current;
  });
}

function logObjectError(label, details) {
  try {
    console.error(`${label} ${safeStringifyDeep(details)}`);
  } catch (e) {
    console.error(label, details);
  }
}

function isLikelyNetworkError(err) {
  if (err instanceof TypeError) return true;
  const message = err && typeof err.message === "string" ? err.message : String(err || "");
  return /failed to fetch|networkerror|network request failed/i.test(message);
}

function waitForOnline(timeoutMs) {
  if (typeof navigator === "undefined") return Promise.resolve(false);
  if (navigator.onLine !== false) return Promise.resolve(true);
  if (typeof window === "undefined") return Promise.resolve(false);

  return new Promise(resolve => {
    let settled = false;
    let timer = null;
    const finish = value => {
      if (settled) return;
      settled = true;
      if (timer) clearTimeout(timer);
      window.removeEventListener("online", handleOnline);
      resolve(value);
    };
    const handleOnline = () => finish(true);
    window.addEventListener("online", handleOnline, { once: true });
    timer = setTimeout(() => finish(false), timeoutMs);
  });
}

async function uploadBlobToCloudinaryWithRetry(blob, folder) {
  let lastError = null;
  for (let attempt = 1; attempt <= CLOUDINARY_MAX_ATTEMPTS; attempt += 1) {
    const formData = new FormData();
    formData.append("file", blob);
    formData.append("upload_preset", "mosaic_user_uploads1");
    if (folder) formData.append("folder", folder);

    try {
      const res = await fetch(CLOUDINARY_UPLOAD_URL, {
        method: "POST",
        body: formData
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json || typeof json.secure_url !== "string" || !json.secure_url.trim()) {
        throw new Error(
          (json && json.error && json.error.message) || `Cloudinary upload failed (${res.status})`
        );
      }
      return json.secure_url.trim();
    } catch (err) {
      lastError = err;
      const canRetry = attempt < CLOUDINARY_MAX_ATTEMPTS && isLikelyNetworkError(err);
      if (!canRetry) break;
      await waitForOnline(10_000);
      const backoffMs = CLOUDINARY_RETRY_DELAYS_MS[Math.min(attempt - 1, CLOUDINARY_RETRY_DELAYS_MS.length - 1)];
      await waitMs(backoffMs);
    }
  }

  throw lastError || new Error("Cloudinary upload failed");
}

async function uploadTransformedBlobForCheckout(blob) {
  return uploadBlobToCloudinaryWithRetry(blob, "mosaics/transformed");
}

async function addItemToShopifyCartWithRetry(variantId, lineItemProperties) {
  const maxAttempts = 5;
  const retryDelaysMs = [500, 1000, 1500, 2000, 2500];
  let lastResult = null;

  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    const addToCartRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: lineItemProperties
          }
        ]
      })
    });

    const responseText = await addToCartRes.text().catch(() => "");
    let responseJson = {};
    try {
      responseJson = responseText ? JSON.parse(responseText) : {};
    } catch (e) {
      responseJson = {};
    }

    lastResult = {
      ok: addToCartRes.ok,
      status: addToCartRes.status,
      responseText,
      responseJson
    };

    if (addToCartRes.ok) return lastResult;
    if (
      (addToCartRes.status === 403 || addToCartRes.status === 422) &&
      attempt < maxAttempts
    ) {
      await waitMs(retryDelaysMs[attempt - 1] || 2500);
      continue;
    }
    break;
  }

  return lastResult || { ok: false, status: 0, responseText: "", responseJson: {} };
}

function addToCart() {
  // console.log(canvas);
  if (!canvas) return;
  
  // Check if we have the brickified bitmap already (no reprocessing needed)
  if (!currentBrickedBitmap) {
    console.error("Bricked bitmap not available. Please wait for rendering to complete.");
    alert("Please wait for the image to finish processing.");
    return;
  }

  createMosaicExportBlob(currentBrickedBitmap, async function (blob) {
    if (!blob) {
      console.error("Could not export mosaic image for upload");
      alert("Could not prepare mosaic image. Please try again.");
      return;
    }

    // Upload to Cloudinary
    try {
      const mosaicImageUrl = await uploadBlobToCloudinaryWithRetry(blob);

      let transformedImageUrl = null;
      try {
        const rec = await getUploadedImageRecord();
        if (rec && typeof rec.transformedURL === "string" && rec.transformedURL.trim()) {
          transformedImageUrl = rec.transformedURL.trim();
        } else {
          const transformedBlob = getTransformedBlobFromUploadRecord(rec);
          if (transformedBlob) {
            transformedImageUrl = await uploadTransformedBlobForCheckout(transformedBlob);
          }
        }
      } catch (e) {
        console.warn("Could not read transformedURL from IndexedDB for cart payload", e);
      }

      // Extract brick array from already-processed bitmap (no reprocessing!)
      const brickArray = extractBrickArrayOptimized(currentBrickedBitmap);

      // Combine palette, brick array, and image URLs into one object
      // Use static color registry with fixed IDs that never change (or LEGO_COLOR_REGISTRY__2 if ?palette=2 / #palette=2)
      const mosaicData = {
        palette: getMosaicPaletteRegistry()
          .filter(color => color.active)
          .map(color => ({
            id: color.id,  // Fixed ID from registry - NEVER changes, matches physical label numbers
            hex: color.hex // Current hex color value
          })),
        bricks: brickArray,        // 2D array of color indices — maps to active palette array position
        colorMode: mosaicColorMode,
        transformedImageUrl: transformedImageUrl,  // URL to transformed image used to create mosaic
        mosaicImageUrl: mosaicImageUrl              // URL to processed mosaic image
      };

      // Encode payload exactly as expected by pixelbrick-api /product.
      const mosaicDataJson = JSON.stringify(mosaicData);
      const mosaicDataBase64 = btoa(unescape(encodeURIComponent(mosaicDataJson)));

      const apiBase =
        typeof DETECT_API_BASE_URL === "string" ? DETECT_API_BASE_URL.trim().replace(/\/+$/, "") : "";
      if (!apiBase) {
        throw new Error("DETECT_API_BASE_URL is not configured");
      }

      const productApiUrl = `${apiBase}/product`;
      const maxAttempts = 3;
      let productJson = null;

      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        const headers = { "content-type": "application/json" };
        if (typeof DETECT_API_KEY === "string" && DETECT_API_KEY.trim()) {
          headers["x-api-key"] = DETECT_API_KEY.trim();
        }

        try {
          const productRes = await fetch(productApiUrl, {
            method: "POST",
            headers,
            body: JSON.stringify({ base64: mosaicDataBase64 })
          });

          productJson = await productRes.json().catch(() => ({}));
          if (productRes.ok) {
            break;
          }

          if (productRes.status >= 500 && productRes.status <= 599 && attempt < maxAttempts) {
            // Retry only transient server-side failures.
            await waitMs(300 * attempt);
            continue;
          }

          logObjectError("Product API error:", {
            status: productRes.status,
            response: productJson
          });
          throw new Error(productJson.error || "Could not create your product");
        } catch (err) {
          const canRetry = attempt < maxAttempts && isLikelyNetworkError(err);
          if (!canRetry) throw err;
          await waitForOnline(10_000);
          await waitMs(300 * attempt);
        }
      }

      if (!productJson || !productJson.shopify_variant_id || !productJson.design_id) {
        console.error("Unexpected /product response:", productJson);
        throw new Error("Could not create your product");
      }

      const lineItemProperties = {
        _design_id: String(productJson.design_id)
      };
      const variantId = String(productJson.shopify_variant_id).trim();

      try {
        await deleteUploadedImageRecord();
      } catch (e) {
        console.warn("Could not clear IndexedDB upload after add to cart", e);
      }

      const clearCartRes = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          accept: "application/json"
        }
      });
      if (!clearCartRes.ok) {
        const clearCartJson = await clearCartRes.json().catch(() => ({}));
        logObjectError("Shopify cart/clear.js error:", {
          status: clearCartRes.status,
          response: clearCartJson
        });
        if (clearCartRes.status === 403) {
          const propertiesBase64 = btoa(unescape(encodeURIComponent(JSON.stringify(lineItemProperties))));
          const checkoutUrl = `https://pixelbrick.nl/cart/${encodeURIComponent(variantId)}:1?properties=${encodeURIComponent(propertiesBase64)}`;
          window.location.href = checkoutUrl;
          return;
        }
        throw new Error(clearCartJson.description || clearCartJson.message || "Could not clear cart");
      }

      const addToCartResult = await addItemToShopifyCartWithRetry(variantId, lineItemProperties);
      if (!addToCartResult.ok) {
        if (addToCartResult.status !== 403) {
          logObjectError("Shopify cart/add.js error:", {
            status: addToCartResult.status,
            response: addToCartResult.responseJson,
            response_text: addToCartResult.responseText,
            variant_id: variantId,
            design_id: lineItemProperties._design_id
          });
        }
        const addToCartJson = addToCartResult.responseJson || {};
        if (addToCartResult.status === 403 || addToCartResult.status === 422) {
          const propertiesBase64 = btoa(unescape(encodeURIComponent(JSON.stringify(lineItemProperties))));
          const checkoutUrl = `https://pixelbrick.nl/cart/${encodeURIComponent(variantId)}:1?properties=${encodeURIComponent(propertiesBase64)}`;
          window.location.href = checkoutUrl;
          return;
        }
        throw new Error(addToCartJson.description || addToCartJson.message || "Could not add product to cart");
      }

      window.location.href = "/checkout";
    } catch (err) {
      logObjectError("Error creating product / adding to cart:", err);
      resetBuyButtons();
      alert("Something went wrong. Please try again.");
    }
  });
}

const defaultBuyButtonHtmlByButton = new Map();
[addToCartButton, addToCartButtonFooter].forEach(function (button) {
  if (button) defaultBuyButtonHtmlByButton.set(button, button.innerHTML);
});

function setButtonLoadingState(button) {
  if (!button) return;
  button.disabled = true;
  button.classList.add("buy-btn--loading");
  button.innerHTML =
    '<span class="buy-btn-spinner" aria-hidden="true"></span><span>Mozaïek maken…</span>';
}

function resetButtonState(button) {
  if (!button) return;
  button.classList.remove("buy-btn--loading");
  const defaultHtml = defaultBuyButtonHtmlByButton.get(button);
  if (defaultHtml != null) {
    button.innerHTML = defaultHtml;
  } else {
    button.textContent = "Bestellen";
  }
  button.disabled = false;
}

function resetBuyButtons() {
  resetButtonState(addToCartButton);
  resetButtonState(addToCartButtonFooter);
  addToCartButtonClicked = false;
}

// Browsers can restore this page from bfcache with stale disabled/loading state
// when the user navigates back from checkout.
window.addEventListener("pageshow", function () {
  resetBuyButtons();
});

resetBuyButtons();

function handleAddToCart() {
  if (addToCartButtonClicked) return;
  markCheckoutQualifiedForReturnDiscount();
  addToCartButtonClicked = true;
  // Keep both CTAs in sync to avoid double-submit.
  setButtonLoadingState(addToCartButton);
  setButtonLoadingState(addToCartButtonFooter);
  addToCart();
}

if (addToCartButton) {
  addToCartButton.addEventListener("click", e => {
    handleAddToCart();
  });
}

if (addToCartButtonFooter) {
  addToCartButtonFooter.addEventListener("click", e => {
    handleAddToCart();
  });
}

if (nextStepButton) nextStepButton.addEventListener("click", e => {
  if (currentStep == 1) {
    currentStep = 2;
    sizeCropToolbar.style.display="none";
    previewToolbar.style.display="flex";
    if (previewFooter) previewFooter.style.display="flex";
    prevStepButton.style.display="flex";
    if (headerStepTitle) headerStepTitle.innerText="Preview"; // Preview
    if (headerStepIndicator) headerStepIndicator.innerText="Stap 3 van 3";
    if (helpButtonStep1) helpButtonStep1.style.display="none";
    if (helpButtonStep2) helpButtonStep2.style.display="flex";
    render();
    
    // Open help modal automatically only once per page load (resets on reload)
    if (!window.previewHelpShown) {
    setTimeout(() => {
      if (typeof MicroModal !== 'undefined' && MicroModal.show) {
        MicroModal.show('modal-help-preview');
          window.previewHelpShown = true;
      }
    }, 500);
    }
  } else if (currentStep == 2) {
    addToCart();
  }
});

function goBackToStep1() {
  if (currentStep == 1) {
      window.location.href = "/pages/creeren";
  } else if (currentStep == 2) {
    currentStep = 1;
    sizeCropToolbar.style.display="flex";
    previewToolbar.style.display="none";
    if (previewFooter) previewFooter.style.display="flex";
    prevStepButton.style.display="flex";
    if (nextStepButton) nextStepButton.innerText="Preview →"; // Next with arrow
    if (headerStepTitle) headerStepTitle.innerText="Ontwerp je mozaïek"; // Size & Crop
    if (headerStepIndicator) headerStepIndicator.innerText="Stap 2 van 3";
    if (helpButtonStep1) helpButtonStep1.style.display="flex";
    if (helpButtonStep2) helpButtonStep2.style.display="none";
    render();
  }
}

prevStepButton.addEventListener("click", e => {
  goBackToStep1();
});

// "Bewerken" link should do the same as back button
if (previewHangingEdit) {
  previewHangingEdit.addEventListener("click", e => {
    e.preventDefault();
    goBackToStep1();
  });
}

// Hanging options modal handlers
const hangingOptions = document.querySelectorAll('.modal-hanging-option');

function saveHangingOption(selectedOption) {
  if (!selectedOption) return;
  
  const optionType = selectedOption.getAttribute('data-hanging-option');
  const optionPrice = selectedOption.getAttribute('data-hanging-price');
  
  // Store frame selection in state
  if (optionType === 'frame-black' || optionType === 'frame-white' || optionType === 'frame-gold') {
    selectedFrame = optionType;
  } else {
    selectedFrame = null; // No frame for strips or none
  }
  
  // Update preview display
  if (previewHangingOption) {
    if (optionType === 'frame-black') {
      previewHangingOption.innerText = 'Lijst zwart';
    } else if (optionType === 'frame-white') {
      previewHangingOption.innerText = 'Lijst wit';
    } else if (optionType === 'frame-gold') {
      previewHangingOption.innerText = 'Lijst goud';
    } else if (optionType === 'strips') {
      // Just show "Strips" without the count (count is still calculated for cart)
      previewHangingOption.innerText = 'Strips';
    } else if (optionType === 'none') {
      previewHangingOption.innerText = 'Geen ophangmiddel';
    }
  }
  
  if (previewHangingPrice) {
    previewHangingPrice.innerText = `€${optionPrice.replace('.', ',')}`;
  }
  
  // Hide/show hanging item based on selection
  if (previewHangingItem) {
    if (optionType === 'none') {
      previewHangingItem.style.display = 'none';
    } else {
      previewHangingItem.style.display = 'flex';
    }
  }
  
  // Update total price
  updatePreviewTotal();
  
  // Update delivery content modal if it's open or will be opened
  if (typeof updateDeliveryContent === 'function' && typeof selectedSize !== 'undefined') {
    updateDeliveryContent(selectedSize);
  }
  
  // Close modal with animation
  // Manually trigger the close animation by setting aria-hidden while keeping is-open
  setTimeout(() => {
    const modal = document.getElementById('modal-hanging-finishing');
    if (modal) {
      // Set aria-hidden to trigger close animation, but keep is-open for now
      modal.setAttribute('aria-hidden', 'true');
      // After animation completes, remove is-open (don't set display: none inline)
      setTimeout(() => {
        modal.classList.remove('is-open');
        // Remove any inline display style that might have been set
        modal.style.display = '';
      }, 300); // Match animation duration (0.3s)
    }
  }, 150);
}

hangingOptions.forEach(option => {
  option.addEventListener('click', () => {
    // Remove selected class from all options
    hangingOptions.forEach(opt => opt.classList.remove('modal-hanging-option-selected'));
    // Add selected class to clicked option
    option.classList.add('modal-hanging-option-selected');
    
    // Automatically save and close
    saveHangingOption(option);
  });
});

// Update strips count and sync selection when modal opens
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-micromodal-trigger="modal-hanging-finishing"]');
  if (trigger) {
    // Small delay to ensure modal is ready
    setTimeout(() => {
      updateStripsCount();
      syncModalSelection();
    }, 50);
  }
});

function updateFormatDetailsButtonPosition() {
  const toolbar = document.getElementById("size-crop-toopbar");
  const panelCandidates = [
    document.getElementById("format-panel"),
    document.getElementById("zoom-panel"),
    document.getElementById("color-panel"),
  ];
  if (!toolbar) return;
  const openPanel = panelCandidates.find((panel) => panel && !panel.hidden) || null;
  const panelOffset = openPanel ? openPanel.offsetHeight : 0;
  toolbar.style.setProperty("--format-details-offset", `${panelOffset + 12}px`);
}

function setFormatPanelOpen(open) {
  const panel = document.getElementById("format-panel");
  const btn = document.getElementById("btn-format-toggle");
  if (!panel) return;
  panel.hidden = !open;
  panel.setAttribute("aria-hidden", open ? "false" : "true");
  if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
  updateFormatDetailsButtonPosition();
}

function setZoomPanelOpen(open) {
  const panel = document.getElementById("zoom-panel");
  const btn = document.getElementById("btn-zoom-toggle");
  if (!panel) return;
  panel.hidden = !open;
  panel.setAttribute("aria-hidden", open ? "false" : "true");
  if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
  updateFormatDetailsButtonPosition();
}

function setColorPanelOpen(open) {
  const panel = document.getElementById("color-panel");
  const btn = document.getElementById("btn-color-toggle");
  if (!panel) return;
  panel.hidden = !open;
  panel.setAttribute("aria-hidden", open ? "false" : "true");
  if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
  updateFormatDetailsButtonPosition();
}

// Also update when modal is shown via MicroModal events
function runEditorUiSetup() {
  const modal = document.getElementById('modal-hanging-finishing');
  if (modal) {
    modal.addEventListener('micromodal:show', () => {
      updateStripsCount();
      syncModalSelection();
    });
  }

  const sizeCropToolbar = document.getElementById("size-crop-toopbar");
  const formatToggle = document.getElementById("btn-format-toggle");
  const formatPanelClose = document.getElementById("format-panel-close");
  const zoomToggle = document.getElementById("btn-zoom-toggle");
  const zoomPanelClose = document.getElementById("zoom-panel-close");
  const colorToggle = document.getElementById("btn-color-toggle");
  const colorPanelClose = document.getElementById("color-panel-close");
  const allPanels = [
    document.getElementById("format-panel"),
    document.getElementById("zoom-panel"),
    document.getElementById("color-panel"),
  ].filter(Boolean);
  setFormatPanelOpen(true);
  setZoomPanelOpen(false);
  setColorPanelOpen(false);
  updateFormatDetailsButtonPosition();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      updateFormatDetailsButtonPosition();
      if (sizeCropToolbar) {
        setTimeout(() => {
          updateFormatDetailsButtonPosition();
          sizeCropToolbar.classList.add("format-details-ready");
        }, 1000);
      }
    });
  });
  if (typeof ResizeObserver !== "undefined" && allPanels.length) {
    const panelObserver = new ResizeObserver(() => {
      updateFormatDetailsButtonPosition();
    });
    allPanels.forEach((panel) => panelObserver.observe(panel));
  }
  window.addEventListener("resize", () => {
    requestAnimationFrame(() => {
      updateFormatDetailsButtonPosition();
    });
  });
  if (formatToggle) {
    formatToggle.addEventListener("click", () => {
      const panel = document.getElementById("format-panel");
      if (!panel) return;
      if (panel.hidden) {
        setZoomPanelOpen(false);
        setColorPanelOpen(false);
      }
      setFormatPanelOpen(panel.hidden);
    });
  }
  if (formatPanelClose) {
    formatPanelClose.addEventListener("click", () => setFormatPanelOpen(false));
  }
  if (zoomToggle) {
    zoomToggle.addEventListener("click", () => {
      const panel = document.getElementById("zoom-panel");
      if (!panel) return;
      if (panel.hidden) {
        setFormatPanelOpen(false);
        setColorPanelOpen(false);
      }
      setZoomPanelOpen(panel.hidden);
    });
  }
  if (zoomPanelClose) {
    zoomPanelClose.addEventListener("click", () => setZoomPanelOpen(false));
  }
  if (colorToggle) {
    colorToggle.addEventListener("click", () => {
      const panel = document.getElementById("color-panel");
      if (!panel) return;
      if (panel.hidden) {
        setFormatPanelOpen(false);
        setZoomPanelOpen(false);
      }
      setColorPanelOpen(panel.hidden);
    });
  }
  if (colorPanelClose) {
    colorPanelClose.addEventListener("click", () => setColorPanelOpen(false));
  }
  
  // Update strips count on initial load
  updateStripsCount();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runEditorUiSetup);
} else {
  runEditorUiSetup();
}

function syncModalSelection() {
  // Get the currently selected hanging option from preview
  if (!previewHangingOption) return;
  
  const currentOptionText = previewHangingOption.innerText.toLowerCase();
  let targetOptionType = 'none'; // Default to none (nothing selected)
  
  // Determine which option is currently selected based on preview text
  if (currentOptionText.includes('lijst zwart') || currentOptionText.includes('zwart')) {
    targetOptionType = 'frame-black';
  } else if (currentOptionText.includes('lijst wit') || currentOptionText.includes('wit')) {
    targetOptionType = 'frame-white';
  } else if (currentOptionText.includes('lijst goud') || currentOptionText.includes('goud')) {
    targetOptionType = 'frame-gold';
  } else if (currentOptionText.includes('strips')) {
    targetOptionType = 'strips';
  } else if (currentOptionText.includes('geen ophangmiddel') || currentOptionText.includes('ophangmiddel')) {
    targetOptionType = 'none';
  }
  
  // Update modal selection
  const hangingOptions = document.querySelectorAll('.modal-hanging-option');
  hangingOptions.forEach(option => {
    const optionType = option.getAttribute('data-hanging-option');
    if (optionType === targetOptionType) {
      option.classList.add('modal-hanging-option-selected');
    } else {
      option.classList.remove('modal-hanging-option-selected');
    }
  });
}

function updateStripsCount() {
  // Calculate strips count (still needed for cart, but not shown in UI)
  if (typeof selectedSize !== 'undefined' && typeof sizeToStripsCount === 'function') {
    const stripsCount = sizeToStripsCount(selectedSize);
    
    // Calculate price dynamically: strips / 4 * 2
    const stripsPrice = (stripsCount / 4) * 2;
    const formattedPrice = stripsPrice.toLocaleString('nl-NL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20
    });
    
    // Update price display in modal
    const stripsPriceEl = document.querySelector('.js-strips-price');
    if (stripsPriceEl) {
      stripsPriceEl.innerText = `€${formattedPrice}`;
    }
    
    // Update data-hanging-price attribute for the strips button
    const stripsButton = document.querySelector('[data-hanging-option="strips"]');
    if (stripsButton) {
      stripsButton.setAttribute('data-hanging-price', String(stripsPrice));
    }
  }
}

// Details Viewer (zoom + pan mode)
const DETAILS_MIN_ZOOM = 0.25;
const DETAILS_MAX_ZOOM = 3;
const DETAILS_DEFAULT_ZOOM = 1;
let detailsZoom = DETAILS_DEFAULT_ZOOM;
let detailsPanX = 0;
let detailsPanY = 0;
let detailsIsDragging = false;
let detailsDragStartX = 0;
let detailsDragStartY = 0;
let detailsPinching = false;
let detailsPinchStartDistance = 0;
let detailsPinchStartZoom = DETAILS_DEFAULT_ZOOM;
let detailsTapStartX = 0;
let detailsTapStartY = 0;
let detailsTapMoved = false;
let detailsLastTapTime = 0;
let detailsLastTapX = 0;
let detailsLastTapY = 0;

function clampDetailsZoom(value) {
  return Math.max(DETAILS_MIN_ZOOM, Math.min(DETAILS_MAX_ZOOM, value));
}

function updateDetailsViewerTransform() {
  if (!detailsViewerCanvas) return;
  detailsViewerCanvas.style.transform = `translate(-50%, -50%) translate(${detailsPanX}px, ${detailsPanY}px) scale(${detailsZoom})`;
  if (detailsViewerZoomValue) {
    detailsViewerZoomValue.innerText = `${detailsZoom.toFixed(1)}x`;
  }
}

function copyCurrentMosaicToDetailsViewer() {
  if (!detailsViewerCanvas || !canvas) return;
  const stageRect = detailsViewerStage
    ? detailsViewerStage.getBoundingClientRect()
    : { width: canvas.width, height: canvas.height };
  const safeWidth = Math.max(1, Math.round(stageRect.width));
  const safeHeight = Math.max(1, Math.round(stageRect.height));
  const dpr = window.devicePixelRatio || 1;
  let qualityScale = 2;
  if (
    typeof parseSize === "function" &&
    typeof selectedSize === "string" &&
    selectedSize
  ) {
    const { pxW, pxH } = parseSize(selectedSize);
    const baseBrickPixels = Math.min(
      (safeWidth * dpr) / Math.max(1, pxW),
      (safeHeight * dpr) / Math.max(1, pxH),
    );
    const targetBrickPixels = 6;
    const adaptiveScale = targetBrickPixels / Math.max(0.01, baseBrickPixels);
    qualityScale = Math.max(2, Math.min(4, adaptiveScale));
  }
  detailsViewerCanvas.width = Math.max(1, Math.round(safeWidth * dpr * qualityScale));
  detailsViewerCanvas.height = Math.max(1, Math.round(safeHeight * dpr * qualityScale));
  const detailsCtx = detailsViewerCanvas.getContext('2d');
  if (!detailsCtx) return;
  if (
    typeof renderBitmapToCanvas === "function" &&
    currentBrickedBitmap &&
    typeof selectedSize === "string" &&
    selectedSize
  ) {
    renderBitmapToCanvas(currentBrickedBitmap, selectedSize, detailsViewerCanvas, detailsCtx);
    return;
  }
  detailsCtx.clearRect(0, 0, detailsViewerCanvas.width, detailsViewerCanvas.height);
  detailsCtx.drawImage(canvas, 0, 0, detailsViewerCanvas.width, detailsViewerCanvas.height);
}

function resetDetailsViewerState() {
  detailsZoom = DETAILS_DEFAULT_ZOOM;
  detailsPanX = 0;
  detailsPanY = 0;
  updateDetailsViewerTransform();
}

function openDetailsViewer() {
  if (!detailsViewer) return;
  resetDetailsViewerState();
  detailsViewer.style.display = 'flex';
  requestAnimationFrame(() => {
    copyCurrentMosaicToDetailsViewer();
    detailsViewer.classList.add('active');
  });
  document.body.style.overflow = 'hidden';
}

function closeDetailsViewer() {
  if (!detailsViewer) return;
  detailsViewer.classList.remove('active');
  setTimeout(() => {
    detailsViewer.style.display = 'none';
    document.body.style.overflow = '';
  }, 220);
}

function getDetailsTouchDistance(touchA, touchB) {
  const dx = touchA.clientX - touchB.clientX;
  const dy = touchA.clientY - touchB.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

if (formatDetailsButton) {
  formatDetailsButton.addEventListener('click', (e) => {
    e.preventDefault();
    openDetailsViewer();
  });
}

if (detailsViewerCloseTop) {
  detailsViewerCloseTop.addEventListener('click', closeDetailsViewer);
}

if (detailsViewerCloseBottom) {
  detailsViewerCloseBottom.addEventListener('click', closeDetailsViewer);
}

if (detailsViewerReset) {
  detailsViewerReset.addEventListener('click', () => {
    resetDetailsViewerState();
  });
}

if (detailsViewerZoomOut) {
  detailsViewerZoomOut.addEventListener('click', () => {
    detailsZoom = clampDetailsZoom(detailsZoom - 0.2);
    updateDetailsViewerTransform();
  });
}

if (detailsViewerZoomIn) {
  detailsViewerZoomIn.addEventListener('click', () => {
    detailsZoom = clampDetailsZoom(detailsZoom + 0.2);
    updateDetailsViewerTransform();
  });
}

if (detailsViewerStage) {
  detailsViewerStage.addEventListener('dblclick', () => {
    resetDetailsViewerState();
  });

  detailsViewerStage.addEventListener('wheel', (e) => {
    if (!detailsViewer || detailsViewer.style.display === 'none') return;
    e.preventDefault();
    const zoomDelta = e.deltaY > 0 ? -0.12 : 0.12;
    detailsZoom = clampDetailsZoom(detailsZoom + zoomDelta);
    updateDetailsViewerTransform();
  }, { passive: false });

  detailsViewerStage.addEventListener('mousedown', (e) => {
    if (!detailsViewer || detailsViewer.style.display === 'none') return;
    detailsIsDragging = true;
    detailsViewerStage.classList.add('is-dragging');
    detailsDragStartX = e.clientX - detailsPanX;
    detailsDragStartY = e.clientY - detailsPanY;
  });

  detailsViewerStage.addEventListener('touchstart', (e) => {
    if (!detailsViewer || detailsViewer.style.display === 'none') return;
    if (e.touches.length === 2) {
      detailsPinching = true;
      detailsIsDragging = false;
      detailsTapMoved = true;
      detailsViewerStage.classList.remove('is-dragging');
      detailsPinchStartDistance = getDetailsTouchDistance(e.touches[0], e.touches[1]);
      detailsPinchStartZoom = detailsZoom;
      e.preventDefault();
      return;
    }
    if (e.touches.length === 1) {
      detailsPinching = false;
      detailsIsDragging = true;
      detailsViewerStage.classList.add('is-dragging');
      detailsDragStartX = e.touches[0].clientX - detailsPanX;
      detailsDragStartY = e.touches[0].clientY - detailsPanY;
      detailsTapStartX = e.touches[0].clientX;
      detailsTapStartY = e.touches[0].clientY;
      detailsTapMoved = false;
    }
  }, { passive: false });

  detailsViewerStage.addEventListener('touchmove', (e) => {
    if (!detailsViewer || detailsViewer.style.display === 'none') return;
    if (detailsPinching && e.touches.length === 2) {
      const distance = getDetailsTouchDistance(e.touches[0], e.touches[1]);
      const zoomRatio = distance / detailsPinchStartDistance;
      detailsZoom = clampDetailsZoom(detailsPinchStartZoom * zoomRatio);
      updateDetailsViewerTransform();
      e.preventDefault();
      return;
    }
    if (detailsIsDragging && e.touches.length === 1) {
      detailsPanX = e.touches[0].clientX - detailsDragStartX;
      detailsPanY = e.touches[0].clientY - detailsDragStartY;
      const moveDx = e.touches[0].clientX - detailsTapStartX;
      const moveDy = e.touches[0].clientY - detailsTapStartY;
      if ((moveDx * moveDx + moveDy * moveDy) > 64) {
        detailsTapMoved = true;
      }
      updateDetailsViewerTransform();
      e.preventDefault();
    }
  }, { passive: false });

  detailsViewerStage.addEventListener('touchend', (e) => {
    if (!detailsPinching && !detailsTapMoved && e.changedTouches && e.changedTouches.length === 1) {
      const touch = e.changedTouches[0];
      const now = Date.now();
      const tapDx = touch.clientX - detailsLastTapX;
      const tapDy = touch.clientY - detailsLastTapY;
      const isSecondTapNearby = (tapDx * tapDx + tapDy * tapDy) <= 576;
      if ((now - detailsLastTapTime) < 320 && isSecondTapNearby) {
        resetDetailsViewerState();
        detailsLastTapTime = 0;
      } else {
        detailsLastTapTime = now;
        detailsLastTapX = touch.clientX;
        detailsLastTapY = touch.clientY;
      }
    }
    detailsIsDragging = false;
    detailsPinching = false;
    detailsViewerStage.classList.remove('is-dragging');
  });
}

window.addEventListener('mousemove', (e) => {
  if (!detailsIsDragging || !detailsViewer || detailsViewer.style.display === 'none') return;
  detailsPanX = e.clientX - detailsDragStartX;
  detailsPanY = e.clientY - detailsDragStartY;
  updateDetailsViewerTransform();
});

window.addEventListener('mouseup', () => {
  detailsIsDragging = false;
  if (detailsViewerStage) {
    detailsViewerStage.classList.remove('is-dragging');
  }
});

/* ===================== AR Wall Viewer ===================== */
(function setupArWallViewer() {
  if (!arPreviewButton) return;

  /* ---- Real AR (model-viewer / native Quick Look + Scene Viewer) ---- */
  let lastPreparedBitmap = null;
  let lastPreparedSize = null;
  let arPrepareInFlight = null;
  let arWatcher = null;
  let arRuntimePromise = null;
  let arIdlePreloadScheduled = false;

  function getArAssetUrls() {
    const cfg = window.__brickmeArAssets;
    if (cfg && cfg.modelViewer && cfg.wall) return cfg;
    // Local dev only — never use relative paths on the live Shopify store.
    const isLocalDev = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
    if (isLocalDev) {
      return {
        modelViewer: './vendor-ar/ar-model-viewer.min.js',
        wall: './ar-wall.bundle.js',
      };
    }
    return null;
  }

  function ensureModelViewerElement() {
    if (document.getElementById('ar-model-viewer')) return;
    const mv = document.createElement('model-viewer');
    mv.id = 'ar-model-viewer';
    mv.setAttribute('ar', '');
    mv.setAttribute('ar-modes', 'scene-viewer quick-look');
    mv.setAttribute('ar-placement', 'wall');
    mv.setAttribute('ar-scale', 'fixed');
    mv.setAttribute('interaction-prompt', 'none');
    mv.setAttribute('aria-hidden', 'true');
    mv.style.cssText =
      'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
    document.body.appendChild(mv);
  }

  function loadModuleScript(src) {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector('script[type="module"][data-ar-src="' + src + '"]');
      if (existing) {
        if (existing.dataset.arLoaded === '1') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => reject(new Error('Failed to load ' + src)), { once: true });
        return;
      }
      const script = document.createElement('script');
      script.type = 'module';
      script.src = src;
      script.dataset.arSrc = src;
      script.addEventListener('load', () => {
        script.dataset.arLoaded = '1';
        resolve();
      }, { once: true });
      script.addEventListener('error', () => reject(new Error('Failed to load ' + src)), { once: true });
      document.head.appendChild(script);
    });
  }

  function ensureArRuntime() {
    if (window.brickmeWallAR) return Promise.resolve(window.brickmeWallAR);
    if (arRuntimePromise) return arRuntimePromise;
    arRuntimePromise = (async () => {
      ensureModelViewerElement();
      const assets = getArAssetUrls();
      if (!assets) throw new Error('AR assets not configured');
      await loadModuleScript(assets.modelViewer);
      await loadModuleScript(assets.wall);
      if (window.brickmeWallAR) return window.brickmeWallAR;
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('AR runtime timeout')), 30000);
        window.addEventListener('brickme-wallar-ready', () => {
          clearTimeout(timeout);
          resolve();
        }, { once: true });
      });
      if (!window.brickmeWallAR) throw new Error('AR runtime missing');
      return window.brickmeWallAR;
    })().catch((e) => {
      arRuntimePromise = null;
      throw e;
    });
    return arRuntimePromise;
  }

  function scheduleArIdlePreload() {
    if (arIdlePreloadScheduled || !deviceMightSupportAr()) return;
    arIdlePreloadScheduled = true;
    const run = () => {
      ensureArRuntime()
        .then(() => startArWatcher())
        .catch(() => {});
    };
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 5000 });
    } else {
      setTimeout(run, 4000);
    }
  }

  function deviceMightSupportAr() {
    const ua = navigator.userAgent || '';
    const isAndroid = /android/i.test(ua);
    const isIOS =
      /iphone|ipad|ipod/i.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    let quickLook = false;
    try {
      const a = document.createElement('a');
      quickLook = !!(a.relList && a.relList.supports && a.relList.supports('ar'));
    } catch (e) {
      quickLook = false;
    }
    return isAndroid || isIOS || quickLook;
  }

  function getArDimsMeters() {
    if (typeof parseSize === 'function' && typeof selectedSize === 'string' && selectedSize) {
      const { baseW, baseH } = parseSize(selectedSize);
      // 19.2 cm per baseplate edge -> 0.192 m
      return { w: Math.max(0.05, baseW * 0.192), h: Math.max(0.05, baseH * 0.192) };
    }
    return { w: 0.384, h: 0.384 };
  }

  function buildArTextureCanvas() {
    if (typeof renderBitmapToCanvas !== 'function' || !currentBrickedBitmap || !selectedSize) {
      return null;
    }
    const aspect =
      currentBrickedBitmap.width && currentBrickedBitmap.height
        ? currentBrickedBitmap.width / currentBrickedBitmap.height
        : 1;
    const longEdge = 1100;
    let w;
    let h;
    if (aspect >= 1) {
      w = longEdge;
      h = Math.max(1, Math.round(longEdge / aspect));
    } else {
      h = longEdge;
      w = Math.max(1, Math.round(longEdge * aspect));
    }
    const cnv = document.createElement('canvas');
    cnv.width = w;
    cnv.height = h;
    const cx = cnv.getContext('2d');
    if (!cx) return null;
    renderBitmapToCanvas(currentBrickedBitmap, selectedSize, cnv, cx);
    // Fill transparent margins behind the mosaic with a dark mat so the panel looks framed.
    cx.globalCompositeOperation = 'destination-over';
    cx.fillStyle = '#141414';
    cx.fillRect(0, 0, w, h);
    cx.globalCompositeOperation = 'source-over';
    return cnv;
  }

  async function prepareArModelsIfNeeded(force) {
    let ar;
    try {
      ar = await ensureArRuntime();
    } catch (e) {
      return false;
    }
    if (!ar || typeof ar.prepare !== 'function') return false;
    if (!deviceMightSupportAr()) return Promise.resolve(false);
    if (!currentBrickedBitmap || !selectedSize) return Promise.resolve(false);
    if (
      !force &&
      currentBrickedBitmap === lastPreparedBitmap &&
      selectedSize === lastPreparedSize &&
      ar.isReady()
    ) {
      return true;
    }
    // Coalesce concurrent calls (watcher + pointerdown + click) into one build.
    if (arPrepareInFlight) return arPrepareInFlight;
    const bitmapAtStart = currentBrickedBitmap;
    const sizeAtStart = selectedSize;
    arPrepareInFlight = (async () => {
      try {
        const cnv = buildArTextureCanvas();
        if (!cnv) return false;
        const dims = getArDimsMeters();
        const key = sizeAtStart + ':' + bitmapAtStart.width + 'x' + bitmapAtStart.height;
        const ok = await ar.prepare(cnv, dims.w, dims.h, key);
        if (ok) {
          lastPreparedBitmap = bitmapAtStart;
          lastPreparedSize = sizeAtStart;
        }
        return ok;
      } catch (e) {
        return false;
      } finally {
        arPrepareInFlight = null;
      }
    })();
    return arPrepareInFlight;
  }

  function startArWatcher() {
    if (arWatcher || !deviceMightSupportAr()) return;
    arWatcher = setInterval(() => {
      if (document.hidden) return;
      const ar = window.brickmeWallAR;
      if (!ar) return;
      if (!currentBrickedBitmap || !selectedSize) return;
      if (
        currentBrickedBitmap === lastPreparedBitmap &&
        selectedSize === lastPreparedSize &&
        ar.isReady()
      ) {
        return;
      }
      prepareArModelsIfNeeded(false);
    }, 1200);
  }

  /* ---- Availability message (replaces the old camera-overlay fallback) ---- */
  const arMessage = document.getElementById('ar-message');
  const arMessageTitle = document.getElementById('ar-message-title');
  const arMessageText = document.getElementById('ar-message-text');
  const arMessageClose = document.getElementById('ar-message-close');
  const arMessageProgress = document.getElementById('ar-message-progress');
  let arMessageKind = null;
  let arSessionActive = false;

  function trackArEvent(name, detail) {
    const payload = Object.assign({ event: name }, detail || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
    document.dispatchEvent(new CustomEvent('brickme-track', { detail: payload }));
  }

  function markArSessionStarted() {
    arSessionActive = true;
    trackArEvent('editor--ar-launched');
  }

  function isInAppBrowser() {
    const ua = navigator.userAgent || '';
    return /FBAN|FBAV|FB_IAB|Instagram|Line\/|Twitter|Pinterest|Snapchat|TikTok|musical_ly|WhatsApp|GSA\//i.test(ua);
  }

  function showArMessage(kind) {
    if (!arMessage) return;
    arMessageKind = kind;
    let title;
    let text;
    if (kind === 'inapp') {
      title = 'Open in je browser';
      text = 'AR werkt niet in de app van bijvoorbeeld Instagram, Facebook of TikTok. Open deze pagina in Safari (iPhone) of Chrome (Android) en probeer het opnieuw.';
      trackArEvent('editor--ar-unsupported', { ar_reason: 'inapp' });
    } else if (kind === 'preparing') {
      title = 'Even geduld';
      text = 'We maken de AR-weergave klaar…';
    } else if (kind === 'error') {
      title = 'Er ging iets mis';
      text = 'We konden de AR-weergave niet starten. Probeer het opnieuw, of gebruik Safari (iPhone) of Chrome (Android).';
      trackArEvent('editor--ar-unsupported', { ar_reason: 'error' });
    } else {
      title = 'AR niet beschikbaar';
      text = 'Je toestel of browser ondersteunt AR helaas niet. Gebruik een recentere telefoon, of open de pagina in Safari (iPhone) of Chrome (Android).';
      trackArEvent('editor--ar-unsupported', { ar_reason: 'unsupported' });
    }
    if (arMessageTitle) arMessageTitle.textContent = title;
    if (arMessageText) arMessageText.textContent = text;
    if (arMessageProgress) arMessageProgress.hidden = kind !== 'preparing';
    arMessage.hidden = false;
    requestAnimationFrame(() => arMessage.classList.add('active'));
    document.body.style.overflow = 'hidden';
  }

  function hideArMessage(source) {
    if (!arMessage) return;
    if (source === 'user' && arMessageKind) {
      trackArEvent('editor--ar-dialog-close', { ar_context: arMessageKind });
    }
    arMessageKind = null;
    if (arMessageProgress) arMessageProgress.hidden = true;
    arMessage.classList.remove('active');
    document.body.style.overflow = '';
    setTimeout(() => {
      arMessage.hidden = true;
    }, 200);
  }

  async function launchAr(ar) {
    const launched = await ar.activate();
    if (launched) {
      markArSessionStarted();
    }
    return launched;
  }

  /* ---- Wire up controls ---- */
  arPreviewButton.addEventListener('pointerdown', () => {
    // Load AR scripts + warm models on intent so launch stays inside the tap gesture.
    ensureArRuntime()
      .then(() => prepareArModelsIfNeeded(false))
      .catch(() => {});
  }, { passive: true });

  arPreviewButton.addEventListener('click', async (e) => {
    e.preventDefault();

    if (!deviceMightSupportAr()) {
      showArMessage(isInAppBrowser() ? 'inapp' : 'unsupported');
      return;
    }

    let ar;
    try {
      ar = await ensureArRuntime();
    } catch (err) {
      showArMessage('error');
      return;
    }

    // Pre-warmed and ready: launch immediately so the call stays inside the
    // user gesture (required for iOS Quick Look).
    if (ar.isReady()) {
      const launched = await launchAr(ar);
      if (!launched) showArMessage('unsupported');
      return;
    }

    // Not ready yet: build the model now, then launch.
    showArMessage('preparing');
    const ok = await prepareArModelsIfNeeded(true);
    if (arMessageKind !== 'preparing') return;
    if (ok && ar.isReady()) {
      const launched = await launchAr(ar);
      if (launched) {
        hideArMessage();
      } else {
        showArMessage('error');
      }
    } else {
      showArMessage('error');
    }
  });

  if (arMessageClose) {
    arMessageClose.addEventListener('click', () => hideArMessage('user'));
  }
  if (arMessage) {
    arMessage.addEventListener('click', (e) => {
      if (e.target && e.target.hasAttribute('data-ar-message-close')) hideArMessage('user');
    });
  }
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && arMessage && !arMessage.hidden) hideArMessage('user');
  });
  document.addEventListener('visibilitychange', () => {
    if (!arSessionActive || document.visibilityState !== 'visible') return;
    arSessionActive = false;
    trackArEvent('editor--ar-session-end');
  });

  scheduleArIdlePreload();
})();



// ===== main.js =====
(function startEditor() {
  initBlackFrameAbTest();

  function continueInit() {
    initReturnDiscountOffer();
    loadImage();
    updateSizeOptions();
    if (typeof mozaikProductHandle !== "undefined" && mozaikProductHandle) {
      loadPricesFromShopify(mozaikProductHandle);
    }
  }

  if (!isEditorShopifyPath()) {
    continueInit();
    return;
  }

  if (!("indexedDB" in window)) {
    window.location.href = UPLOAD_PAGE_PATH;
    return;
  }

  getUploadedImageRecord()
    .then(function (record) {
      if (!isValidTransformedUploadRecord(record)) {
        return clearUploadedImageRecordAndRedirect(
          "Editor: IndexedDB upload record is missing or has invalid original/transformed image buffers; clearing record and redirecting to upload."
        );
      }
      continueInit();
    })
    .catch(function (err) {
      console.error("Editor: failed to read IndexedDB upload record", err);
      return clearUploadedImageRecordAndRedirect();
    });
})();



